/******/ (function() { // webpackBootstrap
/******/ 	"use strict";

;// ./node_modules/redux/dist/redux.mjs
// src/utils/formatProdErrorMessage.ts
function formatProdErrorMessage(code) {
  return `Minified Redux error #${code}; visit https://redux.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}

// src/utils/symbol-observable.ts
var $$observable = /* @__PURE__ */ (() => typeof Symbol === "function" && Symbol.observable || "@@observable")();
var symbol_observable_default = $$observable;

// src/utils/actionTypes.ts
var randomString = () => Math.random().toString(36).substring(7).split("").join(".");
var ActionTypes = {
  INIT: `@@redux/INIT${/* @__PURE__ */ randomString()}`,
  REPLACE: `@@redux/REPLACE${/* @__PURE__ */ randomString()}`,
  PROBE_UNKNOWN_ACTION: () => `@@redux/PROBE_UNKNOWN_ACTION${randomString()}`
};
var actionTypes_default = ActionTypes;

// src/utils/isPlainObject.ts
function redux_isPlainObject(obj) {
  if (typeof obj !== "object" || obj === null)
    return false;
  let proto = obj;
  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }
  return Object.getPrototypeOf(obj) === proto || Object.getPrototypeOf(obj) === null;
}

// src/utils/kindOf.ts
function miniKindOf(val) {
  if (val === void 0)
    return "undefined";
  if (val === null)
    return "null";
  const type = typeof val;
  switch (type) {
    case "boolean":
    case "string":
    case "number":
    case "symbol":
    case "function": {
      return type;
    }
  }
  if (Array.isArray(val))
    return "array";
  if (isDate(val))
    return "date";
  if (isError(val))
    return "error";
  const constructorName = ctorName(val);
  switch (constructorName) {
    case "Symbol":
    case "Promise":
    case "WeakMap":
    case "WeakSet":
    case "Map":
    case "Set":
      return constructorName;
  }
  return Object.prototype.toString.call(val).slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function ctorName(val) {
  return typeof val.constructor === "function" ? val.constructor.name : null;
}
function isError(val) {
  return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function isDate(val) {
  if (val instanceof Date)
    return true;
  return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function kindOf(val) {
  let typeOfVal = typeof val;
  if (false) {}
  return typeOfVal;
}

// src/createStore.ts
function createStore(reducer, preloadedState, enhancer) {
  if (typeof reducer !== "function") {
    throw new Error( true ? formatProdErrorMessage(2) : 0);
  }
  if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") {
    throw new Error( true ? formatProdErrorMessage(0) : 0);
  }
  if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
    enhancer = preloadedState;
    preloadedState = void 0;
  }
  if (typeof enhancer !== "undefined") {
    if (typeof enhancer !== "function") {
      throw new Error( true ? formatProdErrorMessage(1) : 0);
    }
    return enhancer(createStore)(reducer, preloadedState);
  }
  let currentReducer = reducer;
  let currentState = preloadedState;
  let currentListeners = /* @__PURE__ */ new Map();
  let nextListeners = currentListeners;
  let listenerIdCounter = 0;
  let isDispatching = false;
  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = /* @__PURE__ */ new Map();
      currentListeners.forEach((listener, key) => {
        nextListeners.set(key, listener);
      });
    }
  }
  function getState() {
    if (isDispatching) {
      throw new Error( true ? formatProdErrorMessage(3) : 0);
    }
    return currentState;
  }
  function subscribe(listener) {
    if (typeof listener !== "function") {
      throw new Error( true ? formatProdErrorMessage(4) : 0);
    }
    if (isDispatching) {
      throw new Error( true ? formatProdErrorMessage(5) : 0);
    }
    let isSubscribed = true;
    ensureCanMutateNextListeners();
    const listenerId = listenerIdCounter++;
    nextListeners.set(listenerId, listener);
    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }
      if (isDispatching) {
        throw new Error( true ? formatProdErrorMessage(6) : 0);
      }
      isSubscribed = false;
      ensureCanMutateNextListeners();
      nextListeners.delete(listenerId);
      currentListeners = null;
    };
  }
  function dispatch(action) {
    if (!redux_isPlainObject(action)) {
      throw new Error( true ? formatProdErrorMessage(7) : 0);
    }
    if (typeof action.type === "undefined") {
      throw new Error( true ? formatProdErrorMessage(8) : 0);
    }
    if (typeof action.type !== "string") {
      throw new Error( true ? formatProdErrorMessage(17) : 0);
    }
    if (isDispatching) {
      throw new Error( true ? formatProdErrorMessage(9) : 0);
    }
    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }
    const listeners = currentListeners = nextListeners;
    listeners.forEach((listener) => {
      listener();
    });
    return action;
  }
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== "function") {
      throw new Error( true ? formatProdErrorMessage(10) : 0);
    }
    currentReducer = nextReducer;
    dispatch({
      type: actionTypes_default.REPLACE
    });
  }
  function observable() {
    const outerSubscribe = subscribe;
    return {
      /**
       * The minimal observable subscription method.
       * @param observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe(observer) {
        if (typeof observer !== "object" || observer === null) {
          throw new Error( true ? formatProdErrorMessage(11) : 0);
        }
        function observeState() {
          const observerAsObserver = observer;
          if (observerAsObserver.next) {
            observerAsObserver.next(getState());
          }
        }
        observeState();
        const unsubscribe = outerSubscribe(observeState);
        return {
          unsubscribe
        };
      },
      [symbol_observable_default]() {
        return this;
      }
    };
  }
  dispatch({
    type: actionTypes_default.INIT
  });
  const store = {
    dispatch,
    subscribe,
    getState,
    replaceReducer,
    [symbol_observable_default]: observable
  };
  return store;
}
function legacy_createStore(reducer, preloadedState, enhancer) {
  return createStore(reducer, preloadedState, enhancer);
}

// src/utils/warning.ts
function warning(message) {
  if (typeof console !== "undefined" && typeof console.error === "function") {
    console.error(message);
  }
  try {
    throw new Error(message);
  } catch (e) {
  }
}

// src/combineReducers.ts
function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  const reducerKeys = Object.keys(reducers);
  const argumentName = action && action.type === actionTypes_default.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
  if (reducerKeys.length === 0) {
    return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
  }
  if (!redux_isPlainObject(inputState)) {
    return `The ${argumentName} has unexpected type of "${kindOf(inputState)}". Expected argument to be an object with the following keys: "${reducerKeys.join('", "')}"`;
  }
  const unexpectedKeys = Object.keys(inputState).filter((key) => !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key]);
  unexpectedKeys.forEach((key) => {
    unexpectedKeyCache[key] = true;
  });
  if (action && action.type === actionTypes_default.REPLACE)
    return;
  if (unexpectedKeys.length > 0) {
    return `Unexpected ${unexpectedKeys.length > 1 ? "keys" : "key"} "${unexpectedKeys.join('", "')}" found in ${argumentName}. Expected to find one of the known reducer keys instead: "${reducerKeys.join('", "')}". Unexpected keys will be ignored.`;
  }
}
function assertReducerShape(reducers) {
  Object.keys(reducers).forEach((key) => {
    const reducer = reducers[key];
    const initialState = reducer(void 0, {
      type: actionTypes_default.INIT
    });
    if (typeof initialState === "undefined") {
      throw new Error( true ? formatProdErrorMessage(12) : 0);
    }
    if (typeof reducer(void 0, {
      type: actionTypes_default.PROBE_UNKNOWN_ACTION()
    }) === "undefined") {
      throw new Error( true ? formatProdErrorMessage(13) : 0);
    }
  });
}
function combineReducers(reducers) {
  const reducerKeys = Object.keys(reducers);
  const finalReducers = {};
  for (let i = 0; i < reducerKeys.length; i++) {
    const key = reducerKeys[i];
    if (false) {}
    if (typeof reducers[key] === "function") {
      finalReducers[key] = reducers[key];
    }
  }
  const finalReducerKeys = Object.keys(finalReducers);
  let unexpectedKeyCache;
  if (false) {}
  let shapeAssertionError;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }
  return function combination(state = {}, action) {
    if (shapeAssertionError) {
      throw shapeAssertionError;
    }
    if (false) {}
    let hasChanged = false;
    const nextState = {};
    for (let i = 0; i < finalReducerKeys.length; i++) {
      const key = finalReducerKeys[i];
      const reducer = finalReducers[key];
      const previousStateForKey = state[key];
      const nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === "undefined") {
        const actionType = action && action.type;
        throw new Error( true ? formatProdErrorMessage(14) : 0);
      }
      nextState[key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
    return hasChanged ? nextState : state;
  };
}

// src/bindActionCreators.ts
function bindActionCreator(actionCreator, dispatch) {
  return function(...args) {
    return dispatch(actionCreator.apply(this, args));
  };
}
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === "function") {
    return bindActionCreator(actionCreators, dispatch);
  }
  if (typeof actionCreators !== "object" || actionCreators === null) {
    throw new Error( true ? formatProdErrorMessage(16) : 0);
  }
  const boundActionCreators = {};
  for (const key in actionCreators) {
    const actionCreator = actionCreators[key];
    if (typeof actionCreator === "function") {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}

// src/compose.ts
function compose(...funcs) {
  if (funcs.length === 0) {
    return (arg) => arg;
  }
  if (funcs.length === 1) {
    return funcs[0];
  }
  return funcs.reduce((a, b) => (...args) => a(b(...args)));
}

// src/applyMiddleware.ts
function applyMiddleware(...middlewares) {
  return (createStore2) => (reducer, preloadedState) => {
    const store = createStore2(reducer, preloadedState);
    let dispatch = () => {
      throw new Error( true ? formatProdErrorMessage(15) : 0);
    };
    const middlewareAPI = {
      getState: store.getState,
      dispatch: (action, ...args) => dispatch(action, ...args)
    };
    const chain = middlewares.map((middleware) => middleware(middlewareAPI));
    dispatch = compose(...chain)(store.dispatch);
    return {
      ...store,
      dispatch
    };
  };
}

// src/utils/isAction.ts
function redux_isAction(action) {
  return redux_isPlainObject(action) && "type" in action && typeof action.type === "string";
}

//# sourceMappingURL=redux.mjs.map
;// ./node_modules/redux-thunk/dist/redux-thunk.mjs
// src/index.ts
function createThunkMiddleware(extraArgument) {
  const middleware = ({ dispatch, getState }) => (next) => (action) => {
    if (typeof action === "function") {
      return action(dispatch, getState, extraArgument);
    }
    return next(action);
  };
  return middleware;
}
var redux_thunk_thunk = createThunkMiddleware();
var withExtraArgument = createThunkMiddleware;


;// ./node_modules/immer/dist/immer.mjs
// src/utils/env.ts
var NOTHING = Symbol.for("immer-nothing");
var DRAFTABLE = Symbol.for("immer-draftable");
var DRAFT_STATE = Symbol.for("immer-state");

// src/utils/errors.ts
var errors =  false ? 0 : [];
function die(error, ...args) {
  if (false) {}
  throw new Error(
    `[Immer] minified error nr: ${error}. Full error at: https://bit.ly/3cXEKWf`
  );
}

// src/utils/common.ts
var getPrototypeOf = Object.getPrototypeOf;
function immer_isDraft(value) {
  return !!value && !!value[DRAFT_STATE];
}
function isDraftable(value) {
  if (!value)
    return false;
  return immer_isPlainObject(value) || Array.isArray(value) || !!value[DRAFTABLE] || !!value.constructor?.[DRAFTABLE] || isMap(value) || isSet(value);
}
var objectCtorString = Object.prototype.constructor.toString();
function immer_isPlainObject(value) {
  if (!value || typeof value !== "object")
    return false;
  const proto = getPrototypeOf(value);
  if (proto === null) {
    return true;
  }
  const Ctor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
  if (Ctor === Object)
    return true;
  return typeof Ctor == "function" && Function.toString.call(Ctor) === objectCtorString;
}
function original(value) {
  if (!immer_isDraft(value))
    die(15, value);
  return value[DRAFT_STATE].base_;
}
function each(obj, iter) {
  if (getArchtype(obj) === 0 /* Object */) {
    Reflect.ownKeys(obj).forEach((key) => {
      iter(key, obj[key], obj);
    });
  } else {
    obj.forEach((entry, index) => iter(index, entry, obj));
  }
}
function getArchtype(thing) {
  const state = thing[DRAFT_STATE];
  return state ? state.type_ : Array.isArray(thing) ? 1 /* Array */ : isMap(thing) ? 2 /* Map */ : isSet(thing) ? 3 /* Set */ : 0 /* Object */;
}
function has(thing, prop) {
  return getArchtype(thing) === 2 /* Map */ ? thing.has(prop) : Object.prototype.hasOwnProperty.call(thing, prop);
}
function get(thing, prop) {
  return getArchtype(thing) === 2 /* Map */ ? thing.get(prop) : thing[prop];
}
function set(thing, propOrOldValue, value) {
  const t = getArchtype(thing);
  if (t === 2 /* Map */)
    thing.set(propOrOldValue, value);
  else if (t === 3 /* Set */) {
    thing.add(value);
  } else
    thing[propOrOldValue] = value;
}
function is(x, y) {
  if (x === y) {
    return x !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}
function isMap(target) {
  return target instanceof Map;
}
function isSet(target) {
  return target instanceof Set;
}
function latest(state) {
  return state.copy_ || state.base_;
}
function shallowCopy(base, strict) {
  if (isMap(base)) {
    return new Map(base);
  }
  if (isSet(base)) {
    return new Set(base);
  }
  if (Array.isArray(base))
    return Array.prototype.slice.call(base);
  const isPlain = immer_isPlainObject(base);
  if (strict === true || strict === "class_only" && !isPlain) {
    const descriptors = Object.getOwnPropertyDescriptors(base);
    delete descriptors[DRAFT_STATE];
    let keys = Reflect.ownKeys(descriptors);
    for (let i = 0; i < keys.length; i++) {
      const key = keys[i];
      const desc = descriptors[key];
      if (desc.writable === false) {
        desc.writable = true;
        desc.configurable = true;
      }
      if (desc.get || desc.set)
        descriptors[key] = {
          configurable: true,
          writable: true,
          // could live with !!desc.set as well here...
          enumerable: desc.enumerable,
          value: base[key]
        };
    }
    return Object.create(getPrototypeOf(base), descriptors);
  } else {
    const proto = getPrototypeOf(base);
    if (proto !== null && isPlain) {
      return { ...base };
    }
    const obj = Object.create(proto);
    return Object.assign(obj, base);
  }
}
function freeze(obj, deep = false) {
  if (isFrozen(obj) || immer_isDraft(obj) || !isDraftable(obj))
    return obj;
  if (getArchtype(obj) > 1) {
    obj.set = obj.add = obj.clear = obj.delete = dontMutateFrozenCollections;
  }
  Object.freeze(obj);
  if (deep)
    Object.entries(obj).forEach(([key, value]) => freeze(value, true));
  return obj;
}
function dontMutateFrozenCollections() {
  die(2);
}
function isFrozen(obj) {
  return Object.isFrozen(obj);
}

// src/utils/plugins.ts
var plugins = {};
function getPlugin(pluginKey) {
  const plugin = plugins[pluginKey];
  if (!plugin) {
    die(0, pluginKey);
  }
  return plugin;
}
function loadPlugin(pluginKey, implementation) {
  if (!plugins[pluginKey])
    plugins[pluginKey] = implementation;
}

// src/core/scope.ts
var currentScope;
function getCurrentScope() {
  return currentScope;
}
function createScope(parent_, immer_) {
  return {
    drafts_: [],
    parent_,
    immer_,
    // Whenever the modified draft contains a draft from another scope, we
    // need to prevent auto-freezing so the unowned draft can be finalized.
    canAutoFreeze_: true,
    unfinalizedDrafts_: 0
  };
}
function usePatchesInScope(scope, patchListener) {
  if (patchListener) {
    getPlugin("Patches");
    scope.patches_ = [];
    scope.inversePatches_ = [];
    scope.patchListener_ = patchListener;
  }
}
function revokeScope(scope) {
  leaveScope(scope);
  scope.drafts_.forEach(revokeDraft);
  scope.drafts_ = null;
}
function leaveScope(scope) {
  if (scope === currentScope) {
    currentScope = scope.parent_;
  }
}
function enterScope(immer2) {
  return currentScope = createScope(currentScope, immer2);
}
function revokeDraft(draft) {
  const state = draft[DRAFT_STATE];
  if (state.type_ === 0 /* Object */ || state.type_ === 1 /* Array */)
    state.revoke_();
  else
    state.revoked_ = true;
}

// src/core/finalize.ts
function processResult(result, scope) {
  scope.unfinalizedDrafts_ = scope.drafts_.length;
  const baseDraft = scope.drafts_[0];
  const isReplaced = result !== void 0 && result !== baseDraft;
  if (isReplaced) {
    if (baseDraft[DRAFT_STATE].modified_) {
      revokeScope(scope);
      die(4);
    }
    if (isDraftable(result)) {
      result = finalize(scope, result);
      if (!scope.parent_)
        maybeFreeze(scope, result);
    }
    if (scope.patches_) {
      getPlugin("Patches").generateReplacementPatches_(
        baseDraft[DRAFT_STATE].base_,
        result,
        scope.patches_,
        scope.inversePatches_
      );
    }
  } else {
    result = finalize(scope, baseDraft, []);
  }
  revokeScope(scope);
  if (scope.patches_) {
    scope.patchListener_(scope.patches_, scope.inversePatches_);
  }
  return result !== NOTHING ? result : void 0;
}
function finalize(rootScope, value, path) {
  if (isFrozen(value))
    return value;
  const state = value[DRAFT_STATE];
  if (!state) {
    each(
      value,
      (key, childValue) => finalizeProperty(rootScope, state, value, key, childValue, path)
    );
    return value;
  }
  if (state.scope_ !== rootScope)
    return value;
  if (!state.modified_) {
    maybeFreeze(rootScope, state.base_, true);
    return state.base_;
  }
  if (!state.finalized_) {
    state.finalized_ = true;
    state.scope_.unfinalizedDrafts_--;
    const result = state.copy_;
    let resultEach = result;
    let isSet2 = false;
    if (state.type_ === 3 /* Set */) {
      resultEach = new Set(result);
      result.clear();
      isSet2 = true;
    }
    each(
      resultEach,
      (key, childValue) => finalizeProperty(rootScope, state, result, key, childValue, path, isSet2)
    );
    maybeFreeze(rootScope, result, false);
    if (path && rootScope.patches_) {
      getPlugin("Patches").generatePatches_(
        state,
        path,
        rootScope.patches_,
        rootScope.inversePatches_
      );
    }
  }
  return state.copy_;
}
function finalizeProperty(rootScope, parentState, targetObject, prop, childValue, rootPath, targetIsSet) {
  if (false)
    {}
  if (immer_isDraft(childValue)) {
    const path = rootPath && parentState && parentState.type_ !== 3 /* Set */ && // Set objects are atomic since they have no keys.
    !has(parentState.assigned_, prop) ? rootPath.concat(prop) : void 0;
    const res = finalize(rootScope, childValue, path);
    set(targetObject, prop, res);
    if (immer_isDraft(res)) {
      rootScope.canAutoFreeze_ = false;
    } else
      return;
  } else if (targetIsSet) {
    targetObject.add(childValue);
  }
  if (isDraftable(childValue) && !isFrozen(childValue)) {
    if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) {
      return;
    }
    finalize(rootScope, childValue);
    if ((!parentState || !parentState.scope_.parent_) && typeof prop !== "symbol" && Object.prototype.propertyIsEnumerable.call(targetObject, prop))
      maybeFreeze(rootScope, childValue);
  }
}
function maybeFreeze(scope, value, deep = false) {
  if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) {
    freeze(value, deep);
  }
}

// src/core/proxy.ts
function createProxyProxy(base, parent) {
  const isArray = Array.isArray(base);
  const state = {
    type_: isArray ? 1 /* Array */ : 0 /* Object */,
    // Track which produce call this is associated with.
    scope_: parent ? parent.scope_ : getCurrentScope(),
    // True for both shallow and deep changes.
    modified_: false,
    // Used during finalization.
    finalized_: false,
    // Track which properties have been assigned (true) or deleted (false).
    assigned_: {},
    // The parent draft state.
    parent_: parent,
    // The base state.
    base_: base,
    // The base proxy.
    draft_: null,
    // set below
    // The base copy with any updated values.
    copy_: null,
    // Called by the `produce` function.
    revoke_: null,
    isManual_: false
  };
  let target = state;
  let traps = objectTraps;
  if (isArray) {
    target = [state];
    traps = arrayTraps;
  }
  const { revoke, proxy } = Proxy.revocable(target, traps);
  state.draft_ = proxy;
  state.revoke_ = revoke;
  return proxy;
}
var objectTraps = {
  get(state, prop) {
    if (prop === DRAFT_STATE)
      return state;
    const source = latest(state);
    if (!has(source, prop)) {
      return readPropFromProto(state, source, prop);
    }
    const value = source[prop];
    if (state.finalized_ || !isDraftable(value)) {
      return value;
    }
    if (value === peek(state.base_, prop)) {
      prepareCopy(state);
      return state.copy_[prop] = createProxy(value, state);
    }
    return value;
  },
  has(state, prop) {
    return prop in latest(state);
  },
  ownKeys(state) {
    return Reflect.ownKeys(latest(state));
  },
  set(state, prop, value) {
    const desc = getDescriptorFromProto(latest(state), prop);
    if (desc?.set) {
      desc.set.call(state.draft_, value);
      return true;
    }
    if (!state.modified_) {
      const current2 = peek(latest(state), prop);
      const currentState = current2?.[DRAFT_STATE];
      if (currentState && currentState.base_ === value) {
        state.copy_[prop] = value;
        state.assigned_[prop] = false;
        return true;
      }
      if (is(value, current2) && (value !== void 0 || has(state.base_, prop)))
        return true;
      prepareCopy(state);
      markChanged(state);
    }
    if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
    (value !== void 0 || prop in state.copy_) || // special case: NaN
    Number.isNaN(value) && Number.isNaN(state.copy_[prop]))
      return true;
    state.copy_[prop] = value;
    state.assigned_[prop] = true;
    return true;
  },
  deleteProperty(state, prop) {
    if (peek(state.base_, prop) !== void 0 || prop in state.base_) {
      state.assigned_[prop] = false;
      prepareCopy(state);
      markChanged(state);
    } else {
      delete state.assigned_[prop];
    }
    if (state.copy_) {
      delete state.copy_[prop];
    }
    return true;
  },
  // Note: We never coerce `desc.value` into an Immer draft, because we can't make
  // the same guarantee in ES5 mode.
  getOwnPropertyDescriptor(state, prop) {
    const owner = latest(state);
    const desc = Reflect.getOwnPropertyDescriptor(owner, prop);
    if (!desc)
      return desc;
    return {
      writable: true,
      configurable: state.type_ !== 1 /* Array */ || prop !== "length",
      enumerable: desc.enumerable,
      value: owner[prop]
    };
  },
  defineProperty() {
    die(11);
  },
  getPrototypeOf(state) {
    return getPrototypeOf(state.base_);
  },
  setPrototypeOf() {
    die(12);
  }
};
var arrayTraps = {};
each(objectTraps, (key, fn) => {
  arrayTraps[key] = function() {
    arguments[0] = arguments[0][0];
    return fn.apply(this, arguments);
  };
});
arrayTraps.deleteProperty = function(state, prop) {
  if (false)
    {}
  return arrayTraps.set.call(this, state, prop, void 0);
};
arrayTraps.set = function(state, prop, value) {
  if (false)
    {}
  return objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function peek(draft, prop) {
  const state = draft[DRAFT_STATE];
  const source = state ? latest(state) : draft;
  return source[prop];
}
function readPropFromProto(state, source, prop) {
  const desc = getDescriptorFromProto(source, prop);
  return desc ? `value` in desc ? desc.value : (
    // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    desc.get?.call(state.draft_)
  ) : void 0;
}
function getDescriptorFromProto(source, prop) {
  if (!(prop in source))
    return void 0;
  let proto = getPrototypeOf(source);
  while (proto) {
    const desc = Object.getOwnPropertyDescriptor(proto, prop);
    if (desc)
      return desc;
    proto = getPrototypeOf(proto);
  }
  return void 0;
}
function markChanged(state) {
  if (!state.modified_) {
    state.modified_ = true;
    if (state.parent_) {
      markChanged(state.parent_);
    }
  }
}
function prepareCopy(state) {
  if (!state.copy_) {
    state.copy_ = shallowCopy(
      state.base_,
      state.scope_.immer_.useStrictShallowCopy_
    );
  }
}

// src/core/immerClass.ts
var Immer2 = class {
  constructor(config) {
    this.autoFreeze_ = true;
    this.useStrictShallowCopy_ = false;
    /**
     * The `produce` function takes a value and a "recipe function" (whose
     * return value often depends on the base state). The recipe function is
     * free to mutate its first argument however it wants. All mutations are
     * only ever applied to a __copy__ of the base state.
     *
     * Pass only a function to create a "curried producer" which relieves you
     * from passing the recipe function every time.
     *
     * Only plain objects and arrays are made mutable. All other objects are
     * considered uncopyable.
     *
     * Note: This function is __bound__ to its `Immer` instance.
     *
     * @param {any} base - the initial state
     * @param {Function} recipe - function that receives a proxy of the base state as first argument and which can be freely modified
     * @param {Function} patchListener - optional function that will be called with all the patches produced here
     * @returns {any} a new state, or the initial state if nothing was modified
     */
    this.produce = (base, recipe, patchListener) => {
      if (typeof base === "function" && typeof recipe !== "function") {
        const defaultBase = recipe;
        recipe = base;
        const self = this;
        return function curriedProduce(base2 = defaultBase, ...args) {
          return self.produce(base2, (draft) => recipe.call(this, draft, ...args));
        };
      }
      if (typeof recipe !== "function")
        die(6);
      if (patchListener !== void 0 && typeof patchListener !== "function")
        die(7);
      let result;
      if (isDraftable(base)) {
        const scope = enterScope(this);
        const proxy = createProxy(base, void 0);
        let hasError = true;
        try {
          result = recipe(proxy);
          hasError = false;
        } finally {
          if (hasError)
            revokeScope(scope);
          else
            leaveScope(scope);
        }
        usePatchesInScope(scope, patchListener);
        return processResult(result, scope);
      } else if (!base || typeof base !== "object") {
        result = recipe(base);
        if (result === void 0)
          result = base;
        if (result === NOTHING)
          result = void 0;
        if (this.autoFreeze_)
          freeze(result, true);
        if (patchListener) {
          const p = [];
          const ip = [];
          getPlugin("Patches").generateReplacementPatches_(base, result, p, ip);
          patchListener(p, ip);
        }
        return result;
      } else
        die(1, base);
    };
    this.produceWithPatches = (base, recipe) => {
      if (typeof base === "function") {
        return (state, ...args) => this.produceWithPatches(state, (draft) => base(draft, ...args));
      }
      let patches, inversePatches;
      const result = this.produce(base, recipe, (p, ip) => {
        patches = p;
        inversePatches = ip;
      });
      return [result, patches, inversePatches];
    };
    if (typeof config?.autoFreeze === "boolean")
      this.setAutoFreeze(config.autoFreeze);
    if (typeof config?.useStrictShallowCopy === "boolean")
      this.setUseStrictShallowCopy(config.useStrictShallowCopy);
  }
  createDraft(base) {
    if (!isDraftable(base))
      die(8);
    if (immer_isDraft(base))
      base = immer_current(base);
    const scope = enterScope(this);
    const proxy = createProxy(base, void 0);
    proxy[DRAFT_STATE].isManual_ = true;
    leaveScope(scope);
    return proxy;
  }
  finishDraft(draft, patchListener) {
    const state = draft && draft[DRAFT_STATE];
    if (!state || !state.isManual_)
      die(9);
    const { scope_: scope } = state;
    usePatchesInScope(scope, patchListener);
    return processResult(void 0, scope);
  }
  /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */
  setAutoFreeze(value) {
    this.autoFreeze_ = value;
  }
  /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */
  setUseStrictShallowCopy(value) {
    this.useStrictShallowCopy_ = value;
  }
  applyPatches(base, patches) {
    let i;
    for (i = patches.length - 1; i >= 0; i--) {
      const patch = patches[i];
      if (patch.path.length === 0 && patch.op === "replace") {
        base = patch.value;
        break;
      }
    }
    if (i > -1) {
      patches = patches.slice(i + 1);
    }
    const applyPatchesImpl = getPlugin("Patches").applyPatches_;
    if (immer_isDraft(base)) {
      return applyPatchesImpl(base, patches);
    }
    return this.produce(
      base,
      (draft) => applyPatchesImpl(draft, patches)
    );
  }
};
function createProxy(value, parent) {
  const draft = isMap(value) ? getPlugin("MapSet").proxyMap_(value, parent) : isSet(value) ? getPlugin("MapSet").proxySet_(value, parent) : createProxyProxy(value, parent);
  const scope = parent ? parent.scope_ : getCurrentScope();
  scope.drafts_.push(draft);
  return draft;
}

// src/core/current.ts
function immer_current(value) {
  if (!immer_isDraft(value))
    die(10, value);
  return currentImpl(value);
}
function currentImpl(value) {
  if (!isDraftable(value) || isFrozen(value))
    return value;
  const state = value[DRAFT_STATE];
  let copy;
  if (state) {
    if (!state.modified_)
      return state.base_;
    state.finalized_ = true;
    copy = shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
  } else {
    copy = shallowCopy(value, true);
  }
  each(copy, (key, childValue) => {
    set(copy, key, currentImpl(childValue));
  });
  if (state) {
    state.finalized_ = false;
  }
  return copy;
}

// src/plugins/patches.ts
function enablePatches() {
  const errorOffset = 16;
  if (false) {}
  const REPLACE = "replace";
  const ADD = "add";
  const REMOVE = "remove";
  function generatePatches_(state, basePath, patches, inversePatches) {
    switch (state.type_) {
      case 0 /* Object */:
      case 2 /* Map */:
        return generatePatchesFromAssigned(
          state,
          basePath,
          patches,
          inversePatches
        );
      case 1 /* Array */:
        return generateArrayPatches(state, basePath, patches, inversePatches);
      case 3 /* Set */:
        return generateSetPatches(
          state,
          basePath,
          patches,
          inversePatches
        );
    }
  }
  function generateArrayPatches(state, basePath, patches, inversePatches) {
    let { base_, assigned_ } = state;
    let copy_ = state.copy_;
    if (copy_.length < base_.length) {
      ;
      [base_, copy_] = [copy_, base_];
      [patches, inversePatches] = [inversePatches, patches];
    }
    for (let i = 0; i < base_.length; i++) {
      if (assigned_[i] && copy_[i] !== base_[i]) {
        const path = basePath.concat([i]);
        patches.push({
          op: REPLACE,
          path,
          // Need to maybe clone it, as it can in fact be the original value
          // due to the base/copy inversion at the start of this function
          value: clonePatchValueIfNeeded(copy_[i])
        });
        inversePatches.push({
          op: REPLACE,
          path,
          value: clonePatchValueIfNeeded(base_[i])
        });
      }
    }
    for (let i = base_.length; i < copy_.length; i++) {
      const path = basePath.concat([i]);
      patches.push({
        op: ADD,
        path,
        // Need to maybe clone it, as it can in fact be the original value
        // due to the base/copy inversion at the start of this function
        value: clonePatchValueIfNeeded(copy_[i])
      });
    }
    for (let i = copy_.length - 1; base_.length <= i; --i) {
      const path = basePath.concat([i]);
      inversePatches.push({
        op: REMOVE,
        path
      });
    }
  }
  function generatePatchesFromAssigned(state, basePath, patches, inversePatches) {
    const { base_, copy_ } = state;
    each(state.assigned_, (key, assignedValue) => {
      const origValue = get(base_, key);
      const value = get(copy_, key);
      const op = !assignedValue ? REMOVE : has(base_, key) ? REPLACE : ADD;
      if (origValue === value && op === REPLACE)
        return;
      const path = basePath.concat(key);
      patches.push(op === REMOVE ? { op, path } : { op, path, value });
      inversePatches.push(
        op === ADD ? { op: REMOVE, path } : op === REMOVE ? { op: ADD, path, value: clonePatchValueIfNeeded(origValue) } : { op: REPLACE, path, value: clonePatchValueIfNeeded(origValue) }
      );
    });
  }
  function generateSetPatches(state, basePath, patches, inversePatches) {
    let { base_, copy_ } = state;
    let i = 0;
    base_.forEach((value) => {
      if (!copy_.has(value)) {
        const path = basePath.concat([i]);
        patches.push({
          op: REMOVE,
          path,
          value
        });
        inversePatches.unshift({
          op: ADD,
          path,
          value
        });
      }
      i++;
    });
    i = 0;
    copy_.forEach((value) => {
      if (!base_.has(value)) {
        const path = basePath.concat([i]);
        patches.push({
          op: ADD,
          path,
          value
        });
        inversePatches.unshift({
          op: REMOVE,
          path,
          value
        });
      }
      i++;
    });
  }
  function generateReplacementPatches_(baseValue, replacement, patches, inversePatches) {
    patches.push({
      op: REPLACE,
      path: [],
      value: replacement === NOTHING ? void 0 : replacement
    });
    inversePatches.push({
      op: REPLACE,
      path: [],
      value: baseValue
    });
  }
  function applyPatches_(draft, patches) {
    patches.forEach((patch) => {
      const { path, op } = patch;
      let base = draft;
      for (let i = 0; i < path.length - 1; i++) {
        const parentType = getArchtype(base);
        let p = path[i];
        if (typeof p !== "string" && typeof p !== "number") {
          p = "" + p;
        }
        if ((parentType === 0 /* Object */ || parentType === 1 /* Array */) && (p === "__proto__" || p === "constructor"))
          die(errorOffset + 3);
        if (typeof base === "function" && p === "prototype")
          die(errorOffset + 3);
        base = get(base, p);
        if (typeof base !== "object")
          die(errorOffset + 2, path.join("/"));
      }
      const type = getArchtype(base);
      const value = deepClonePatchValue(patch.value);
      const key = path[path.length - 1];
      switch (op) {
        case REPLACE:
          switch (type) {
            case 2 /* Map */:
              return base.set(key, value);
            case 3 /* Set */:
              die(errorOffset);
            default:
              return base[key] = value;
          }
        case ADD:
          switch (type) {
            case 1 /* Array */:
              return key === "-" ? base.push(value) : base.splice(key, 0, value);
            case 2 /* Map */:
              return base.set(key, value);
            case 3 /* Set */:
              return base.add(value);
            default:
              return base[key] = value;
          }
        case REMOVE:
          switch (type) {
            case 1 /* Array */:
              return base.splice(key, 1);
            case 2 /* Map */:
              return base.delete(key);
            case 3 /* Set */:
              return base.delete(patch.value);
            default:
              return delete base[key];
          }
        default:
          die(errorOffset + 1, op);
      }
    });
    return draft;
  }
  function deepClonePatchValue(obj) {
    if (!isDraftable(obj))
      return obj;
    if (Array.isArray(obj))
      return obj.map(deepClonePatchValue);
    if (isMap(obj))
      return new Map(
        Array.from(obj.entries()).map(([k, v]) => [k, deepClonePatchValue(v)])
      );
    if (isSet(obj))
      return new Set(Array.from(obj).map(deepClonePatchValue));
    const cloned = Object.create(getPrototypeOf(obj));
    for (const key in obj)
      cloned[key] = deepClonePatchValue(obj[key]);
    if (has(obj, DRAFTABLE))
      cloned[DRAFTABLE] = obj[DRAFTABLE];
    return cloned;
  }
  function clonePatchValueIfNeeded(obj) {
    if (immer_isDraft(obj)) {
      return deepClonePatchValue(obj);
    } else
      return obj;
  }
  loadPlugin("Patches", {
    applyPatches_,
    generatePatches_,
    generateReplacementPatches_
  });
}

// src/plugins/mapset.ts
function enableMapSet() {
  class DraftMap extends Map {
    constructor(target, parent) {
      super();
      this[DRAFT_STATE] = {
        type_: 2 /* Map */,
        parent_: parent,
        scope_: parent ? parent.scope_ : getCurrentScope(),
        modified_: false,
        finalized_: false,
        copy_: void 0,
        assigned_: void 0,
        base_: target,
        draft_: this,
        isManual_: false,
        revoked_: false
      };
    }
    get size() {
      return latest(this[DRAFT_STATE]).size;
    }
    has(key) {
      return latest(this[DRAFT_STATE]).has(key);
    }
    set(key, value) {
      const state = this[DRAFT_STATE];
      assertUnrevoked(state);
      if (!latest(state).has(key) || latest(state).get(key) !== value) {
        prepareMapCopy(state);
        markChanged(state);
        state.assigned_.set(key, true);
        state.copy_.set(key, value);
        state.assigned_.set(key, true);
      }
      return this;
    }
    delete(key) {
      if (!this.has(key)) {
        return false;
      }
      const state = this[DRAFT_STATE];
      assertUnrevoked(state);
      prepareMapCopy(state);
      markChanged(state);
      if (state.base_.has(key)) {
        state.assigned_.set(key, false);
      } else {
        state.assigned_.delete(key);
      }
      state.copy_.delete(key);
      return true;
    }
    clear() {
      const state = this[DRAFT_STATE];
      assertUnrevoked(state);
      if (latest(state).size) {
        prepareMapCopy(state);
        markChanged(state);
        state.assigned_ = /* @__PURE__ */ new Map();
        each(state.base_, (key) => {
          state.assigned_.set(key, false);
        });
        state.copy_.clear();
      }
    }
    forEach(cb, thisArg) {
      const state = this[DRAFT_STATE];
      latest(state).forEach((_value, key, _map) => {
        cb.call(thisArg, this.get(key), key, this);
      });
    }
    get(key) {
      const state = this[DRAFT_STATE];
      assertUnrevoked(state);
      const value = latest(state).get(key);
      if (state.finalized_ || !isDraftable(value)) {
        return value;
      }
      if (value !== state.base_.get(key)) {
        return value;
      }
      const draft = createProxy(value, state);
      prepareMapCopy(state);
      state.copy_.set(key, draft);
      return draft;
    }
    keys() {
      return latest(this[DRAFT_STATE]).keys();
    }
    values() {
      const iterator = this.keys();
      return {
        [Symbol.iterator]: () => this.values(),
        next: () => {
          const r = iterator.next();
          if (r.done)
            return r;
          const value = this.get(r.value);
          return {
            done: false,
            value
          };
        }
      };
    }
    entries() {
      const iterator = this.keys();
      return {
        [Symbol.iterator]: () => this.entries(),
        next: () => {
          const r = iterator.next();
          if (r.done)
            return r;
          const value = this.get(r.value);
          return {
            done: false,
            value: [r.value, value]
          };
        }
      };
    }
    [(DRAFT_STATE, Symbol.iterator)]() {
      return this.entries();
    }
  }
  function proxyMap_(target, parent) {
    return new DraftMap(target, parent);
  }
  function prepareMapCopy(state) {
    if (!state.copy_) {
      state.assigned_ = /* @__PURE__ */ new Map();
      state.copy_ = new Map(state.base_);
    }
  }
  class DraftSet extends Set {
    constructor(target, parent) {
      super();
      this[DRAFT_STATE] = {
        type_: 3 /* Set */,
        parent_: parent,
        scope_: parent ? parent.scope_ : getCurrentScope(),
        modified_: false,
        finalized_: false,
        copy_: void 0,
        base_: target,
        draft_: this,
        drafts_: /* @__PURE__ */ new Map(),
        revoked_: false,
        isManual_: false
      };
    }
    get size() {
      return latest(this[DRAFT_STATE]).size;
    }
    has(value) {
      const state = this[DRAFT_STATE];
      assertUnrevoked(state);
      if (!state.copy_) {
        return state.base_.has(value);
      }
      if (state.copy_.has(value))
        return true;
      if (state.drafts_.has(value) && state.copy_.has(state.drafts_.get(value)))
        return true;
      return false;
    }
    add(value) {
      const state = this[DRAFT_STATE];
      assertUnrevoked(state);
      if (!this.has(value)) {
        prepareSetCopy(state);
        markChanged(state);
        state.copy_.add(value);
      }
      return this;
    }
    delete(value) {
      if (!this.has(value)) {
        return false;
      }
      const state = this[DRAFT_STATE];
      assertUnrevoked(state);
      prepareSetCopy(state);
      markChanged(state);
      return state.copy_.delete(value) || (state.drafts_.has(value) ? state.copy_.delete(state.drafts_.get(value)) : (
        /* istanbul ignore next */
        false
      ));
    }
    clear() {
      const state = this[DRAFT_STATE];
      assertUnrevoked(state);
      if (latest(state).size) {
        prepareSetCopy(state);
        markChanged(state);
        state.copy_.clear();
      }
    }
    values() {
      const state = this[DRAFT_STATE];
      assertUnrevoked(state);
      prepareSetCopy(state);
      return state.copy_.values();
    }
    entries() {
      const state = this[DRAFT_STATE];
      assertUnrevoked(state);
      prepareSetCopy(state);
      return state.copy_.entries();
    }
    keys() {
      return this.values();
    }
    [(DRAFT_STATE, Symbol.iterator)]() {
      return this.values();
    }
    forEach(cb, thisArg) {
      const iterator = this.values();
      let result = iterator.next();
      while (!result.done) {
        cb.call(thisArg, result.value, result.value, this);
        result = iterator.next();
      }
    }
  }
  function proxySet_(target, parent) {
    return new DraftSet(target, parent);
  }
  function prepareSetCopy(state) {
    if (!state.copy_) {
      state.copy_ = /* @__PURE__ */ new Set();
      state.base_.forEach((value) => {
        if (isDraftable(value)) {
          const draft = createProxy(value, state);
          state.drafts_.set(value, draft);
          state.copy_.add(draft);
        } else {
          state.copy_.add(value);
        }
      });
    }
  }
  function assertUnrevoked(state) {
    if (state.revoked_)
      die(3, JSON.stringify(latest(state)));
  }
  loadPlugin("MapSet", { proxyMap_, proxySet_ });
}

// src/immer.ts
var immer = new Immer2();
var produce = immer.produce;
var produceWithPatches = immer.produceWithPatches.bind(
  immer
);
var setAutoFreeze = immer.setAutoFreeze.bind(immer);
var setUseStrictShallowCopy = immer.setUseStrictShallowCopy.bind(immer);
var applyPatches = immer.applyPatches.bind(immer);
var createDraft = immer.createDraft.bind(immer);
var finishDraft = immer.finishDraft.bind(immer);
function castDraft(value) {
  return value;
}
function castImmutable(value) {
  return value;
}

//# sourceMappingURL=immer.mjs.map
;// ./node_modules/@reduxjs/toolkit/dist/redux-toolkit.modern.mjs
// src/index.ts




// src/createDraftSafeSelector.ts


var createDraftSafeSelectorCreator = (...args) => {
  const createSelector2 = createSelectorCreator(...args);
  const createDraftSafeSelector2 = Object.assign((...args2) => {
    const selector = createSelector2(...args2);
    const wrappedSelector = (value, ...rest) => selector(isDraft(value) ? current(value) : value, ...rest);
    Object.assign(wrappedSelector, selector);
    return wrappedSelector;
  }, {
    withTypes: () => createDraftSafeSelector2
  });
  return createDraftSafeSelector2;
};
var createDraftSafeSelector = /* @__PURE__ */ (/* unused pure expression or super */ null && (createDraftSafeSelectorCreator(weakMapMemoize)));

// src/configureStore.ts


// src/devtoolsExtension.ts

var composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
  if (arguments.length === 0) return void 0;
  if (typeof arguments[0] === "object") return compose;
  return compose.apply(null, arguments);
};
var devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function() {
  return function(noop3) {
    return noop3;
  };
};

// src/getDefaultMiddleware.ts


// src/createAction.ts


// src/tsHelpers.ts
var hasMatchFunction = (v) => {
  return v && typeof v.match === "function";
};

// src/createAction.ts
function createAction(type, prepareAction) {
  function actionCreator(...args) {
    if (prepareAction) {
      let prepared = prepareAction(...args);
      if (!prepared) {
        throw new Error( true ? redux_toolkit_modern_formatProdErrorMessage(0) : 0);
      }
      return {
        type,
        payload: prepared.payload,
        ..."meta" in prepared && {
          meta: prepared.meta
        },
        ..."error" in prepared && {
          error: prepared.error
        }
      };
    }
    return {
      type,
      payload: args[0]
    };
  }
  actionCreator.toString = () => `${type}`;
  actionCreator.type = type;
  actionCreator.match = (action) => redux_isAction(action) && action.type === type;
  return actionCreator;
}
function isActionCreator(action) {
  return typeof action === "function" && "type" in action && // hasMatchFunction only wants Matchers but I don't see the point in rewriting it
  hasMatchFunction(action);
}
function isFSA(action) {
  return isAction(action) && Object.keys(action).every(isValidKey);
}
function isValidKey(key) {
  return ["type", "payload", "error", "meta"].indexOf(key) > -1;
}

// src/actionCreatorInvariantMiddleware.ts
function getMessage(type) {
  const splitType = type ? `${type}`.split("/") : [];
  const actionName = splitType[splitType.length - 1] || "actionCreator";
  return `Detected an action creator with type "${type || "unknown"}" being dispatched. 
Make sure you're calling the action creator before dispatching, i.e. \`dispatch(${actionName}())\` instead of \`dispatch(${actionName})\`. This is necessary even if the action has no payload.`;
}
function createActionCreatorInvariantMiddleware(options = {}) {
  if (true) {
    return () => (next) => (action) => next(action);
  }
  const {
    isActionCreator: isActionCreator2 = isActionCreator
  } = options;
  return () => (next) => (action) => {
    if (isActionCreator2(action)) {
      console.warn(getMessage(action.type));
    }
    return next(action);
  };
}

// src/utils.ts

function getTimeMeasureUtils(maxDelay, fnName) {
  let elapsed = 0;
  return {
    measureTime(fn) {
      const started = Date.now();
      try {
        return fn();
      } finally {
        const finished = Date.now();
        elapsed += finished - started;
      }
    },
    warnIfExceeded() {
      if (elapsed > maxDelay) {
        console.warn(`${fnName} took ${elapsed}ms, which is more than the warning threshold of ${maxDelay}ms. 
If your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.
It is disabled in production builds, so you don't need to worry about that.`);
      }
    }
  };
}
var Tuple = class _Tuple extends Array {
  constructor(...items) {
    super(...items);
    Object.setPrototypeOf(this, _Tuple.prototype);
  }
  static get [Symbol.species]() {
    return _Tuple;
  }
  concat(...arr) {
    return super.concat.apply(this, arr);
  }
  prepend(...arr) {
    if (arr.length === 1 && Array.isArray(arr[0])) {
      return new _Tuple(...arr[0].concat(this));
    }
    return new _Tuple(...arr.concat(this));
  }
};
function freezeDraftable(val) {
  return isDraftable(val) ? produce(val, () => {
  }) : val;
}
function getOrInsertComputed(map, key, compute) {
  if (map.has(key)) return map.get(key);
  return map.set(key, compute(key)).get(key);
}

// src/immutableStateInvariantMiddleware.ts
function isImmutableDefault(value) {
  return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function trackForMutations(isImmutable, ignorePaths, obj) {
  const trackedProperties = trackProperties(isImmutable, ignorePaths, obj);
  return {
    detectMutations() {
      return detectMutations(isImmutable, ignorePaths, trackedProperties, obj);
    }
  };
}
function trackProperties(isImmutable, ignorePaths = [], obj, path = "", checkedObjects = /* @__PURE__ */ new Set()) {
  const tracked = {
    value: obj
  };
  if (!isImmutable(obj) && !checkedObjects.has(obj)) {
    checkedObjects.add(obj);
    tracked.children = {};
    for (const key in obj) {
      const childPath = path ? path + "." + key : key;
      if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) {
        continue;
      }
      tracked.children[key] = trackProperties(isImmutable, ignorePaths, obj[key], childPath);
    }
  }
  return tracked;
}
function detectMutations(isImmutable, ignoredPaths = [], trackedProperty, obj, sameParentRef = false, path = "") {
  const prevObj = trackedProperty ? trackedProperty.value : void 0;
  const sameRef = prevObj === obj;
  if (sameParentRef && !sameRef && !Number.isNaN(obj)) {
    return {
      wasMutated: true,
      path
    };
  }
  if (isImmutable(prevObj) || isImmutable(obj)) {
    return {
      wasMutated: false
    };
  }
  const keysToDetect = {};
  for (let key in trackedProperty.children) {
    keysToDetect[key] = true;
  }
  for (let key in obj) {
    keysToDetect[key] = true;
  }
  const hasIgnoredPaths = ignoredPaths.length > 0;
  for (let key in keysToDetect) {
    const nestedPath = path ? path + "." + key : key;
    if (hasIgnoredPaths) {
      const hasMatches = ignoredPaths.some((ignored) => {
        if (ignored instanceof RegExp) {
          return ignored.test(nestedPath);
        }
        return nestedPath === ignored;
      });
      if (hasMatches) {
        continue;
      }
    }
    const result = detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath);
    if (result.wasMutated) {
      return result;
    }
  }
  return {
    wasMutated: false
  };
}
function createImmutableStateInvariantMiddleware(options = {}) {
  if (true) {
    return () => (next) => (action) => next(action);
  } else { var stringify, getSerialize; }
}

// src/serializableStateInvariantMiddleware.ts

function isPlain(val) {
  const type = typeof val;
  return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || isPlainObject(val);
}
function findNonSerializableValue(value, path = "", isSerializable = isPlain, getEntries, ignoredPaths = [], cache) {
  let foundNestedSerializable;
  if (!isSerializable(value)) {
    return {
      keyPath: path || "<root>",
      value
    };
  }
  if (typeof value !== "object" || value === null) {
    return false;
  }
  if (cache?.has(value)) return false;
  const entries = getEntries != null ? getEntries(value) : Object.entries(value);
  const hasIgnoredPaths = ignoredPaths.length > 0;
  for (const [key, nestedValue] of entries) {
    const nestedPath = path ? path + "." + key : key;
    if (hasIgnoredPaths) {
      const hasMatches = ignoredPaths.some((ignored) => {
        if (ignored instanceof RegExp) {
          return ignored.test(nestedPath);
        }
        return nestedPath === ignored;
      });
      if (hasMatches) {
        continue;
      }
    }
    if (!isSerializable(nestedValue)) {
      return {
        keyPath: nestedPath,
        value: nestedValue
      };
    }
    if (typeof nestedValue === "object") {
      foundNestedSerializable = findNonSerializableValue(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
      if (foundNestedSerializable) {
        return foundNestedSerializable;
      }
    }
  }
  if (cache && isNestedFrozen(value)) cache.add(value);
  return false;
}
function isNestedFrozen(value) {
  if (!Object.isFrozen(value)) return false;
  for (const nestedValue of Object.values(value)) {
    if (typeof nestedValue !== "object" || nestedValue === null) continue;
    if (!isNestedFrozen(nestedValue)) return false;
  }
  return true;
}
function createSerializableStateInvariantMiddleware(options = {}) {
  if (true) {
    return () => (next) => (action) => next(action);
  } else {}
}

// src/getDefaultMiddleware.ts
function isBoolean(x) {
  return typeof x === "boolean";
}
var buildGetDefaultMiddleware = () => function getDefaultMiddleware(options) {
  const {
    thunk = true,
    immutableCheck = true,
    serializableCheck = true,
    actionCreatorCheck = true
  } = options ?? {};
  let middlewareArray = new Tuple();
  if (thunk) {
    if (isBoolean(thunk)) {
      middlewareArray.push(redux_thunk_thunk);
    } else {
      middlewareArray.push(withExtraArgument(thunk.extraArgument));
    }
  }
  if (false) {}
  return middlewareArray;
};

// src/autoBatchEnhancer.ts
var SHOULD_AUTOBATCH = "RTK_autoBatch";
var prepareAutoBatched = () => (payload) => ({
  payload,
  meta: {
    [SHOULD_AUTOBATCH]: true
  }
});
var createQueueWithTimer = (timeout) => {
  return (notify) => {
    setTimeout(notify, timeout);
  };
};
var autoBatchEnhancer = (options = {
  type: "raf"
}) => (next) => (...args) => {
  const store = next(...args);
  let notifying = true;
  let shouldNotifyAtEndOfTick = false;
  let notificationQueued = false;
  const listeners = /* @__PURE__ */ new Set();
  const queueCallback = options.type === "tick" ? queueMicrotask : options.type === "raf" ? (
    // requestAnimationFrame won't exist in SSR environments. Fall back to a vague approximation just to keep from erroring.
    typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : createQueueWithTimer(10)
  ) : options.type === "callback" ? options.queueNotification : createQueueWithTimer(options.timeout);
  const notifyListeners = () => {
    notificationQueued = false;
    if (shouldNotifyAtEndOfTick) {
      shouldNotifyAtEndOfTick = false;
      listeners.forEach((l) => l());
    }
  };
  return Object.assign({}, store, {
    // Override the base `store.subscribe` method to keep original listeners
    // from running if we're delaying notifications
    subscribe(listener2) {
      const wrappedListener = () => notifying && listener2();
      const unsubscribe = store.subscribe(wrappedListener);
      listeners.add(listener2);
      return () => {
        unsubscribe();
        listeners.delete(listener2);
      };
    },
    // Override the base `store.dispatch` method so that we can check actions
    // for the `shouldAutoBatch` flag and determine if batching is active
    dispatch(action) {
      try {
        notifying = !action?.meta?.[SHOULD_AUTOBATCH];
        shouldNotifyAtEndOfTick = !notifying;
        if (shouldNotifyAtEndOfTick) {
          if (!notificationQueued) {
            notificationQueued = true;
            queueCallback(notifyListeners);
          }
        }
        return store.dispatch(action);
      } finally {
        notifying = true;
      }
    }
  });
};

// src/getDefaultEnhancers.ts
var buildGetDefaultEnhancers = (middlewareEnhancer) => function getDefaultEnhancers(options) {
  const {
    autoBatch = true
  } = options ?? {};
  let enhancerArray = new Tuple(middlewareEnhancer);
  if (autoBatch) {
    enhancerArray.push(autoBatchEnhancer(typeof autoBatch === "object" ? autoBatch : void 0));
  }
  return enhancerArray;
};

// src/configureStore.ts
function configureStore(options) {
  const getDefaultMiddleware = buildGetDefaultMiddleware();
  const {
    reducer = void 0,
    middleware,
    devTools = true,
    preloadedState = void 0,
    enhancers = void 0
  } = options || {};
  let rootReducer;
  if (typeof reducer === "function") {
    rootReducer = reducer;
  } else if (redux_isPlainObject(reducer)) {
    rootReducer = combineReducers(reducer);
  } else {
    throw new Error( true ? redux_toolkit_modern_formatProdErrorMessage(1) : 0);
  }
  if (false) {}
  let finalMiddleware;
  if (typeof middleware === "function") {
    finalMiddleware = middleware(getDefaultMiddleware);
    if (false) {}
  } else {
    finalMiddleware = getDefaultMiddleware();
  }
  if (false) {}
  let finalCompose = compose;
  if (devTools) {
    finalCompose = composeWithDevTools({
      // Enable capture of stack traces for dispatched Redux actions
      trace: "production" !== "production",
      ...typeof devTools === "object" && devTools
    });
  }
  const middlewareEnhancer = applyMiddleware(...finalMiddleware);
  const getDefaultEnhancers = buildGetDefaultEnhancers(middlewareEnhancer);
  if (false) {}
  let storeEnhancers = typeof enhancers === "function" ? enhancers(getDefaultEnhancers) : getDefaultEnhancers();
  if (false) {}
  if (false) {}
  if (false) {}
  const composedEnhancer = finalCompose(...storeEnhancers);
  return createStore(rootReducer, preloadedState, composedEnhancer);
}

// src/createReducer.ts


// src/mapBuilders.ts
function executeReducerBuilderCallback(builderCallback) {
  const actionsMap = {};
  const actionMatchers = [];
  let defaultCaseReducer;
  const builder = {
    addCase(typeOrActionCreator, reducer) {
      if (false) {}
      const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
      if (!type) {
        throw new Error( true ? redux_toolkit_modern_formatProdErrorMessage(28) : 0);
      }
      if (type in actionsMap) {
        throw new Error( true ? redux_toolkit_modern_formatProdErrorMessage(29) : 0);
      }
      actionsMap[type] = reducer;
      return builder;
    },
    addMatcher(matcher, reducer) {
      if (false) {}
      actionMatchers.push({
        matcher,
        reducer
      });
      return builder;
    },
    addDefaultCase(reducer) {
      if (false) {}
      defaultCaseReducer = reducer;
      return builder;
    }
  };
  builderCallback(builder);
  return [actionsMap, actionMatchers, defaultCaseReducer];
}

// src/createReducer.ts
function isStateFunction(x) {
  return typeof x === "function";
}
function createReducer(initialState, mapOrBuilderCallback) {
  if (false) {}
  let [actionsMap, finalActionMatchers, finalDefaultCaseReducer] = executeReducerBuilderCallback(mapOrBuilderCallback);
  let getInitialState;
  if (isStateFunction(initialState)) {
    getInitialState = () => freezeDraftable(initialState());
  } else {
    const frozenInitialState = freezeDraftable(initialState);
    getInitialState = () => frozenInitialState;
  }
  function reducer(state = getInitialState(), action) {
    let caseReducers = [actionsMap[action.type], ...finalActionMatchers.filter(({
      matcher
    }) => matcher(action)).map(({
      reducer: reducer2
    }) => reducer2)];
    if (caseReducers.filter((cr) => !!cr).length === 0) {
      caseReducers = [finalDefaultCaseReducer];
    }
    return caseReducers.reduce((previousState, caseReducer) => {
      if (caseReducer) {
        if (immer_isDraft(previousState)) {
          const draft = previousState;
          const result = caseReducer(draft, action);
          if (result === void 0) {
            return previousState;
          }
          return result;
        } else if (!isDraftable(previousState)) {
          const result = caseReducer(previousState, action);
          if (result === void 0) {
            if (previousState === null) {
              return previousState;
            }
            throw Error("A case reducer on a non-draftable value must not return undefined");
          }
          return result;
        } else {
          return produce(previousState, (draft) => {
            return caseReducer(draft, action);
          });
        }
      }
      return previousState;
    }, state);
  }
  reducer.getInitialState = getInitialState;
  return reducer;
}

// src/matchers.ts
var matches = (matcher, action) => {
  if (hasMatchFunction(matcher)) {
    return matcher.match(action);
  } else {
    return matcher(action);
  }
};
function isAnyOf(...matchers) {
  return (action) => {
    return matchers.some((matcher) => matches(matcher, action));
  };
}
function isAllOf(...matchers) {
  return (action) => {
    return matchers.every((matcher) => matches(matcher, action));
  };
}
function hasExpectedRequestMetadata(action, validStatus) {
  if (!action || !action.meta) return false;
  const hasValidRequestId = typeof action.meta.requestId === "string";
  const hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
  return hasValidRequestId && hasValidRequestStatus;
}
function isAsyncThunkArray(a) {
  return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function isPending(...asyncThunks) {
  if (asyncThunks.length === 0) {
    return (action) => hasExpectedRequestMetadata(action, ["pending"]);
  }
  if (!isAsyncThunkArray(asyncThunks)) {
    return isPending()(asyncThunks[0]);
  }
  return isAnyOf(...asyncThunks.map((asyncThunk) => asyncThunk.pending));
}
function isRejected(...asyncThunks) {
  if (asyncThunks.length === 0) {
    return (action) => hasExpectedRequestMetadata(action, ["rejected"]);
  }
  if (!isAsyncThunkArray(asyncThunks)) {
    return isRejected()(asyncThunks[0]);
  }
  return isAnyOf(...asyncThunks.map((asyncThunk) => asyncThunk.rejected));
}
function isRejectedWithValue(...asyncThunks) {
  const hasFlag = (action) => {
    return action && action.meta && action.meta.rejectedWithValue;
  };
  if (asyncThunks.length === 0) {
    return isAllOf(isRejected(...asyncThunks), hasFlag);
  }
  if (!isAsyncThunkArray(asyncThunks)) {
    return isRejectedWithValue()(asyncThunks[0]);
  }
  return isAllOf(isRejected(...asyncThunks), hasFlag);
}
function isFulfilled(...asyncThunks) {
  if (asyncThunks.length === 0) {
    return (action) => hasExpectedRequestMetadata(action, ["fulfilled"]);
  }
  if (!isAsyncThunkArray(asyncThunks)) {
    return isFulfilled()(asyncThunks[0]);
  }
  return isAnyOf(...asyncThunks.map((asyncThunk) => asyncThunk.fulfilled));
}
function isAsyncThunkAction(...asyncThunks) {
  if (asyncThunks.length === 0) {
    return (action) => hasExpectedRequestMetadata(action, ["pending", "fulfilled", "rejected"]);
  }
  if (!isAsyncThunkArray(asyncThunks)) {
    return isAsyncThunkAction()(asyncThunks[0]);
  }
  return isAnyOf(...asyncThunks.flatMap((asyncThunk) => [asyncThunk.pending, asyncThunk.rejected, asyncThunk.fulfilled]));
}

// src/nanoid.ts
var urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var nanoid = (size = 21) => {
  let id = "";
  let i = size;
  while (i--) {
    id += urlAlphabet[Math.random() * 64 | 0];
  }
  return id;
};

// src/createAsyncThunk.ts
var commonProperties = ["name", "message", "stack", "code"];
var RejectWithValue = class {
  constructor(payload, meta) {
    this.payload = payload;
    this.meta = meta;
  }
  /*
  type-only property to distinguish between RejectWithValue and FulfillWithMeta
  does not exist at runtime
  */
  _type;
};
var FulfillWithMeta = class {
  constructor(payload, meta) {
    this.payload = payload;
    this.meta = meta;
  }
  /*
  type-only property to distinguish between RejectWithValue and FulfillWithMeta
  does not exist at runtime
  */
  _type;
};
var miniSerializeError = (value) => {
  if (typeof value === "object" && value !== null) {
    const simpleError = {};
    for (const property of commonProperties) {
      if (typeof value[property] === "string") {
        simpleError[property] = value[property];
      }
    }
    return simpleError;
  }
  return {
    message: String(value)
  };
};
var createAsyncThunk = /* @__PURE__ */ (() => {
  function createAsyncThunk2(typePrefix, payloadCreator, options) {
    const fulfilled = createAction(typePrefix + "/fulfilled", (payload, requestId, arg, meta) => ({
      payload,
      meta: {
        ...meta || {},
        arg,
        requestId,
        requestStatus: "fulfilled"
      }
    }));
    const pending = createAction(typePrefix + "/pending", (requestId, arg, meta) => ({
      payload: void 0,
      meta: {
        ...meta || {},
        arg,
        requestId,
        requestStatus: "pending"
      }
    }));
    const rejected = createAction(typePrefix + "/rejected", (error, requestId, arg, payload, meta) => ({
      payload,
      error: (options && options.serializeError || miniSerializeError)(error || "Rejected"),
      meta: {
        ...meta || {},
        arg,
        requestId,
        rejectedWithValue: !!payload,
        requestStatus: "rejected",
        aborted: error?.name === "AbortError",
        condition: error?.name === "ConditionError"
      }
    }));
    function actionCreator(arg) {
      return (dispatch, getState, extra) => {
        const requestId = options?.idGenerator ? options.idGenerator(arg) : nanoid();
        const abortController = new AbortController();
        let abortHandler;
        let abortReason;
        function abort(reason) {
          abortReason = reason;
          abortController.abort();
        }
        const promise = async function() {
          let finalAction;
          try {
            let conditionResult = options?.condition?.(arg, {
              getState,
              extra
            });
            if (isThenable(conditionResult)) {
              conditionResult = await conditionResult;
            }
            if (conditionResult === false || abortController.signal.aborted) {
              throw {
                name: "ConditionError",
                message: "Aborted due to condition callback returning false."
              };
            }
            const abortedPromise = new Promise((_, reject) => {
              abortHandler = () => {
                reject({
                  name: "AbortError",
                  message: abortReason || "Aborted"
                });
              };
              abortController.signal.addEventListener("abort", abortHandler);
            });
            dispatch(pending(requestId, arg, options?.getPendingMeta?.({
              requestId,
              arg
            }, {
              getState,
              extra
            })));
            finalAction = await Promise.race([abortedPromise, Promise.resolve(payloadCreator(arg, {
              dispatch,
              getState,
              extra,
              requestId,
              signal: abortController.signal,
              abort,
              rejectWithValue: (value, meta) => {
                return new RejectWithValue(value, meta);
              },
              fulfillWithValue: (value, meta) => {
                return new FulfillWithMeta(value, meta);
              }
            })).then((result) => {
              if (result instanceof RejectWithValue) {
                throw result;
              }
              if (result instanceof FulfillWithMeta) {
                return fulfilled(result.payload, requestId, arg, result.meta);
              }
              return fulfilled(result, requestId, arg);
            })]);
          } catch (err) {
            finalAction = err instanceof RejectWithValue ? rejected(null, requestId, arg, err.payload, err.meta) : rejected(err, requestId, arg);
          } finally {
            if (abortHandler) {
              abortController.signal.removeEventListener("abort", abortHandler);
            }
          }
          const skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
          if (!skipDispatch) {
            dispatch(finalAction);
          }
          return finalAction;
        }();
        return Object.assign(promise, {
          abort,
          requestId,
          arg,
          unwrap() {
            return promise.then(unwrapResult);
          }
        });
      };
    }
    return Object.assign(actionCreator, {
      pending,
      rejected,
      fulfilled,
      settled: isAnyOf(rejected, fulfilled),
      typePrefix
    });
  }
  createAsyncThunk2.withTypes = () => createAsyncThunk2;
  return createAsyncThunk2;
})();
function unwrapResult(action) {
  if (action.meta && action.meta.rejectedWithValue) {
    throw action.payload;
  }
  if (action.error) {
    throw action.error;
  }
  return action.payload;
}
function isThenable(value) {
  return value !== null && typeof value === "object" && typeof value.then === "function";
}

// src/createSlice.ts
var asyncThunkSymbol = /* @__PURE__ */ Symbol.for("rtk-slice-createasyncthunk");
var asyncThunkCreator = {
  [asyncThunkSymbol]: createAsyncThunk
};
var ReducerType = /* @__PURE__ */ ((ReducerType2) => {
  ReducerType2["reducer"] = "reducer";
  ReducerType2["reducerWithPrepare"] = "reducerWithPrepare";
  ReducerType2["asyncThunk"] = "asyncThunk";
  return ReducerType2;
})(ReducerType || {});
function getType(slice, actionKey) {
  return `${slice}/${actionKey}`;
}
function buildCreateSlice({
  creators
} = {}) {
  const cAT = creators?.asyncThunk?.[asyncThunkSymbol];
  return function createSlice2(options) {
    const {
      name,
      reducerPath = name
    } = options;
    if (!name) {
      throw new Error( true ? redux_toolkit_modern_formatProdErrorMessage(11) : 0);
    }
    if (typeof process !== "undefined" && "production" === "development") {}
    const reducers = (typeof options.reducers === "function" ? options.reducers(buildReducerCreators()) : options.reducers) || {};
    const reducerNames = Object.keys(reducers);
    const context = {
      sliceCaseReducersByName: {},
      sliceCaseReducersByType: {},
      actionCreators: {},
      sliceMatchers: []
    };
    const contextMethods = {
      addCase(typeOrActionCreator, reducer2) {
        const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
        if (!type) {
          throw new Error( true ? redux_toolkit_modern_formatProdErrorMessage(12) : 0);
        }
        if (type in context.sliceCaseReducersByType) {
          throw new Error( true ? redux_toolkit_modern_formatProdErrorMessage(13) : 0);
        }
        context.sliceCaseReducersByType[type] = reducer2;
        return contextMethods;
      },
      addMatcher(matcher, reducer2) {
        context.sliceMatchers.push({
          matcher,
          reducer: reducer2
        });
        return contextMethods;
      },
      exposeAction(name2, actionCreator) {
        context.actionCreators[name2] = actionCreator;
        return contextMethods;
      },
      exposeCaseReducer(name2, reducer2) {
        context.sliceCaseReducersByName[name2] = reducer2;
        return contextMethods;
      }
    };
    reducerNames.forEach((reducerName) => {
      const reducerDefinition = reducers[reducerName];
      const reducerDetails = {
        reducerName,
        type: getType(name, reducerName),
        createNotation: typeof options.reducers === "function"
      };
      if (isAsyncThunkSliceReducerDefinition(reducerDefinition)) {
        handleThunkCaseReducerDefinition(reducerDetails, reducerDefinition, contextMethods, cAT);
      } else {
        handleNormalReducerDefinition(reducerDetails, reducerDefinition, contextMethods);
      }
    });
    function buildReducer() {
      if (false) {}
      const [extraReducers = {}, actionMatchers = [], defaultCaseReducer = void 0] = typeof options.extraReducers === "function" ? executeReducerBuilderCallback(options.extraReducers) : [options.extraReducers];
      const finalCaseReducers = {
        ...extraReducers,
        ...context.sliceCaseReducersByType
      };
      return createReducer(options.initialState, (builder) => {
        for (let key in finalCaseReducers) {
          builder.addCase(key, finalCaseReducers[key]);
        }
        for (let sM of context.sliceMatchers) {
          builder.addMatcher(sM.matcher, sM.reducer);
        }
        for (let m of actionMatchers) {
          builder.addMatcher(m.matcher, m.reducer);
        }
        if (defaultCaseReducer) {
          builder.addDefaultCase(defaultCaseReducer);
        }
      });
    }
    const selectSelf = (state) => state;
    const injectedSelectorCache = /* @__PURE__ */ new Map();
    let _reducer;
    function reducer(state, action) {
      if (!_reducer) _reducer = buildReducer();
      return _reducer(state, action);
    }
    function getInitialState() {
      if (!_reducer) _reducer = buildReducer();
      return _reducer.getInitialState();
    }
    function makeSelectorProps(reducerPath2, injected = false) {
      function selectSlice(state) {
        let sliceState = state[reducerPath2];
        if (typeof sliceState === "undefined") {
          if (injected) {
            sliceState = getInitialState();
          } else if (false) {}
        }
        return sliceState;
      }
      function getSelectors(selectState = selectSelf) {
        const selectorCache = getOrInsertComputed(injectedSelectorCache, injected, () => /* @__PURE__ */ new WeakMap());
        return getOrInsertComputed(selectorCache, selectState, () => {
          const map = {};
          for (const [name2, selector] of Object.entries(options.selectors ?? {})) {
            map[name2] = wrapSelector(selector, selectState, getInitialState, injected);
          }
          return map;
        });
      }
      return {
        reducerPath: reducerPath2,
        getSelectors,
        get selectors() {
          return getSelectors(selectSlice);
        },
        selectSlice
      };
    }
    const slice = {
      name,
      reducer,
      actions: context.actionCreators,
      caseReducers: context.sliceCaseReducersByName,
      getInitialState,
      ...makeSelectorProps(reducerPath),
      injectInto(injectable, {
        reducerPath: pathOpt,
        ...config
      } = {}) {
        const newReducerPath = pathOpt ?? reducerPath;
        injectable.inject({
          reducerPath: newReducerPath,
          reducer
        }, config);
        return {
          ...slice,
          ...makeSelectorProps(newReducerPath, true)
        };
      }
    };
    return slice;
  };
}
function wrapSelector(selector, selectState, getInitialState, injected) {
  function wrapper(rootState, ...args) {
    let sliceState = selectState(rootState);
    if (typeof sliceState === "undefined") {
      if (injected) {
        sliceState = getInitialState();
      } else if (false) {}
    }
    return selector(sliceState, ...args);
  }
  wrapper.unwrapped = selector;
  return wrapper;
}
var createSlice = /* @__PURE__ */ buildCreateSlice();
function buildReducerCreators() {
  function asyncThunk(payloadCreator, config) {
    return {
      _reducerDefinitionType: "asyncThunk" /* asyncThunk */,
      payloadCreator,
      ...config
    };
  }
  asyncThunk.withTypes = () => asyncThunk;
  return {
    reducer(caseReducer) {
      return Object.assign({
        // hack so the wrapping function has the same name as the original
        // we need to create a wrapper so the `reducerDefinitionType` is not assigned to the original
        [caseReducer.name](...args) {
          return caseReducer(...args);
        }
      }[caseReducer.name], {
        _reducerDefinitionType: "reducer" /* reducer */
      });
    },
    preparedReducer(prepare, reducer) {
      return {
        _reducerDefinitionType: "reducerWithPrepare" /* reducerWithPrepare */,
        prepare,
        reducer
      };
    },
    asyncThunk
  };
}
function handleNormalReducerDefinition({
  type,
  reducerName,
  createNotation
}, maybeReducerWithPrepare, context) {
  let caseReducer;
  let prepareCallback;
  if ("reducer" in maybeReducerWithPrepare) {
    if (createNotation && !isCaseReducerWithPrepareDefinition(maybeReducerWithPrepare)) {
      throw new Error( true ? redux_toolkit_modern_formatProdErrorMessage(17) : 0);
    }
    caseReducer = maybeReducerWithPrepare.reducer;
    prepareCallback = maybeReducerWithPrepare.prepare;
  } else {
    caseReducer = maybeReducerWithPrepare;
  }
  context.addCase(type, caseReducer).exposeCaseReducer(reducerName, caseReducer).exposeAction(reducerName, prepareCallback ? createAction(type, prepareCallback) : createAction(type));
}
function isAsyncThunkSliceReducerDefinition(reducerDefinition) {
  return reducerDefinition._reducerDefinitionType === "asyncThunk" /* asyncThunk */;
}
function isCaseReducerWithPrepareDefinition(reducerDefinition) {
  return reducerDefinition._reducerDefinitionType === "reducerWithPrepare" /* reducerWithPrepare */;
}
function handleThunkCaseReducerDefinition({
  type,
  reducerName
}, reducerDefinition, context, cAT) {
  if (!cAT) {
    throw new Error( true ? redux_toolkit_modern_formatProdErrorMessage(18) : 0);
  }
  const {
    payloadCreator,
    fulfilled,
    pending,
    rejected,
    settled,
    options
  } = reducerDefinition;
  const thunk = cAT(type, payloadCreator, options);
  context.exposeAction(reducerName, thunk);
  if (fulfilled) {
    context.addCase(thunk.fulfilled, fulfilled);
  }
  if (pending) {
    context.addCase(thunk.pending, pending);
  }
  if (rejected) {
    context.addCase(thunk.rejected, rejected);
  }
  if (settled) {
    context.addMatcher(thunk.settled, settled);
  }
  context.exposeCaseReducer(reducerName, {
    fulfilled: fulfilled || noop,
    pending: pending || noop,
    rejected: rejected || noop,
    settled: settled || noop
  });
}
function noop() {
}

// src/entities/entity_state.ts
function getInitialEntityState() {
  return {
    ids: [],
    entities: {}
  };
}
function createInitialStateFactory(stateAdapter) {
  function getInitialState(additionalState = {}, entities) {
    const state = Object.assign(getInitialEntityState(), additionalState);
    return entities ? stateAdapter.setAll(state, entities) : state;
  }
  return {
    getInitialState
  };
}

// src/entities/state_selectors.ts
function createSelectorsFactory() {
  function getSelectors(selectState, options = {}) {
    const {
      createSelector: createSelector2 = createDraftSafeSelector
    } = options;
    const selectIds = (state) => state.ids;
    const selectEntities = (state) => state.entities;
    const selectAll = createSelector2(selectIds, selectEntities, (ids, entities) => ids.map((id) => entities[id]));
    const selectId = (_, id) => id;
    const selectById = (entities, id) => entities[id];
    const selectTotal = createSelector2(selectIds, (ids) => ids.length);
    if (!selectState) {
      return {
        selectIds,
        selectEntities,
        selectAll,
        selectTotal,
        selectById: createSelector2(selectEntities, selectId, selectById)
      };
    }
    const selectGlobalizedEntities = createSelector2(selectState, selectEntities);
    return {
      selectIds: createSelector2(selectState, selectIds),
      selectEntities: selectGlobalizedEntities,
      selectAll: createSelector2(selectState, selectAll),
      selectTotal: createSelector2(selectState, selectTotal),
      selectById: createSelector2(selectGlobalizedEntities, selectId, selectById)
    };
  }
  return {
    getSelectors
  };
}

// src/entities/state_adapter.ts

var isDraftTyped = (/* unused pure expression or super */ null && (isDraft3));
function createSingleArgumentStateOperator(mutator) {
  const operator = createStateOperator((_, state) => mutator(state));
  return function operation(state) {
    return operator(state, void 0);
  };
}
function createStateOperator(mutator) {
  return function operation(state, arg) {
    function isPayloadActionArgument(arg2) {
      return isFSA(arg2);
    }
    const runMutator = (draft) => {
      if (isPayloadActionArgument(arg)) {
        mutator(arg.payload, draft);
      } else {
        mutator(arg, draft);
      }
    };
    if (isDraftTyped(state)) {
      runMutator(state);
      return state;
    }
    return createNextState3(state, runMutator);
  };
}

// src/entities/utils.ts

function selectIdValue(entity, selectId) {
  const key = selectId(entity);
  if (false) {}
  return key;
}
function ensureEntitiesArray(entities) {
  if (!Array.isArray(entities)) {
    entities = Object.values(entities);
  }
  return entities;
}
function getCurrent(value) {
  return isDraft4(value) ? current2(value) : value;
}
function splitAddedUpdatedEntities(newEntities, selectId, state) {
  newEntities = ensureEntitiesArray(newEntities);
  const existingIdsArray = getCurrent(state.ids);
  const existingIds = new Set(existingIdsArray);
  const added = [];
  const updated = [];
  for (const entity of newEntities) {
    const id = selectIdValue(entity, selectId);
    if (existingIds.has(id)) {
      updated.push({
        id,
        changes: entity
      });
    } else {
      added.push(entity);
    }
  }
  return [added, updated, existingIdsArray];
}

// src/entities/unsorted_state_adapter.ts
function createUnsortedStateAdapter(selectId) {
  function addOneMutably(entity, state) {
    const key = selectIdValue(entity, selectId);
    if (key in state.entities) {
      return;
    }
    state.ids.push(key);
    state.entities[key] = entity;
  }
  function addManyMutably(newEntities, state) {
    newEntities = ensureEntitiesArray(newEntities);
    for (const entity of newEntities) {
      addOneMutably(entity, state);
    }
  }
  function setOneMutably(entity, state) {
    const key = selectIdValue(entity, selectId);
    if (!(key in state.entities)) {
      state.ids.push(key);
    }
    ;
    state.entities[key] = entity;
  }
  function setManyMutably(newEntities, state) {
    newEntities = ensureEntitiesArray(newEntities);
    for (const entity of newEntities) {
      setOneMutably(entity, state);
    }
  }
  function setAllMutably(newEntities, state) {
    newEntities = ensureEntitiesArray(newEntities);
    state.ids = [];
    state.entities = {};
    addManyMutably(newEntities, state);
  }
  function removeOneMutably(key, state) {
    return removeManyMutably([key], state);
  }
  function removeManyMutably(keys, state) {
    let didMutate = false;
    keys.forEach((key) => {
      if (key in state.entities) {
        delete state.entities[key];
        didMutate = true;
      }
    });
    if (didMutate) {
      state.ids = state.ids.filter((id) => id in state.entities);
    }
  }
  function removeAllMutably(state) {
    Object.assign(state, {
      ids: [],
      entities: {}
    });
  }
  function takeNewKey(keys, update, state) {
    const original3 = state.entities[update.id];
    if (original3 === void 0) {
      return false;
    }
    const updated = Object.assign({}, original3, update.changes);
    const newKey = selectIdValue(updated, selectId);
    const hasNewKey = newKey !== update.id;
    if (hasNewKey) {
      keys[update.id] = newKey;
      delete state.entities[update.id];
    }
    ;
    state.entities[newKey] = updated;
    return hasNewKey;
  }
  function updateOneMutably(update, state) {
    return updateManyMutably([update], state);
  }
  function updateManyMutably(updates, state) {
    const newKeys = {};
    const updatesPerEntity = {};
    updates.forEach((update) => {
      if (update.id in state.entities) {
        updatesPerEntity[update.id] = {
          id: update.id,
          // Spreads ignore falsy values, so this works even if there isn't
          // an existing update already at this key
          changes: {
            ...updatesPerEntity[update.id]?.changes,
            ...update.changes
          }
        };
      }
    });
    updates = Object.values(updatesPerEntity);
    const didMutateEntities = updates.length > 0;
    if (didMutateEntities) {
      const didMutateIds = updates.filter((update) => takeNewKey(newKeys, update, state)).length > 0;
      if (didMutateIds) {
        state.ids = Object.values(state.entities).map((e) => selectIdValue(e, selectId));
      }
    }
  }
  function upsertOneMutably(entity, state) {
    return upsertManyMutably([entity], state);
  }
  function upsertManyMutably(newEntities, state) {
    const [added, updated] = splitAddedUpdatedEntities(newEntities, selectId, state);
    updateManyMutably(updated, state);
    addManyMutably(added, state);
  }
  return {
    removeAll: createSingleArgumentStateOperator(removeAllMutably),
    addOne: createStateOperator(addOneMutably),
    addMany: createStateOperator(addManyMutably),
    setOne: createStateOperator(setOneMutably),
    setMany: createStateOperator(setManyMutably),
    setAll: createStateOperator(setAllMutably),
    updateOne: createStateOperator(updateOneMutably),
    updateMany: createStateOperator(updateManyMutably),
    upsertOne: createStateOperator(upsertOneMutably),
    upsertMany: createStateOperator(upsertManyMutably),
    removeOne: createStateOperator(removeOneMutably),
    removeMany: createStateOperator(removeManyMutably)
  };
}

// src/entities/sorted_state_adapter.ts
function findInsertIndex(sortedItems, item, comparisonFunction) {
  let lowIndex = 0;
  let highIndex = sortedItems.length;
  while (lowIndex < highIndex) {
    let middleIndex = lowIndex + highIndex >>> 1;
    const currentItem = sortedItems[middleIndex];
    const res = comparisonFunction(item, currentItem);
    if (res >= 0) {
      lowIndex = middleIndex + 1;
    } else {
      highIndex = middleIndex;
    }
  }
  return lowIndex;
}
function insert(sortedItems, item, comparisonFunction) {
  const insertAtIndex = findInsertIndex(sortedItems, item, comparisonFunction);
  sortedItems.splice(insertAtIndex, 0, item);
  return sortedItems;
}
function createSortedStateAdapter(selectId, comparer) {
  const {
    removeOne,
    removeMany,
    removeAll
  } = createUnsortedStateAdapter(selectId);
  function addOneMutably(entity, state) {
    return addManyMutably([entity], state);
  }
  function addManyMutably(newEntities, state, existingIds) {
    newEntities = ensureEntitiesArray(newEntities);
    const existingKeys = new Set(existingIds ?? getCurrent(state.ids));
    const models = newEntities.filter((model) => !existingKeys.has(selectIdValue(model, selectId)));
    if (models.length !== 0) {
      mergeFunction(state, models);
    }
  }
  function setOneMutably(entity, state) {
    return setManyMutably([entity], state);
  }
  function setManyMutably(newEntities, state) {
    newEntities = ensureEntitiesArray(newEntities);
    if (newEntities.length !== 0) {
      for (const item of newEntities) {
        delete state.entities[selectId(item)];
      }
      mergeFunction(state, newEntities);
    }
  }
  function setAllMutably(newEntities, state) {
    newEntities = ensureEntitiesArray(newEntities);
    state.entities = {};
    state.ids = [];
    addManyMutably(newEntities, state, []);
  }
  function updateOneMutably(update, state) {
    return updateManyMutably([update], state);
  }
  function updateManyMutably(updates, state) {
    let appliedUpdates = false;
    let replacedIds = false;
    for (let update of updates) {
      const entity = state.entities[update.id];
      if (!entity) {
        continue;
      }
      appliedUpdates = true;
      Object.assign(entity, update.changes);
      const newId = selectId(entity);
      if (update.id !== newId) {
        replacedIds = true;
        delete state.entities[update.id];
        const oldIndex = state.ids.indexOf(update.id);
        state.ids[oldIndex] = newId;
        state.entities[newId] = entity;
      }
    }
    if (appliedUpdates) {
      mergeFunction(state, [], appliedUpdates, replacedIds);
    }
  }
  function upsertOneMutably(entity, state) {
    return upsertManyMutably([entity], state);
  }
  function upsertManyMutably(newEntities, state) {
    const [added, updated, existingIdsArray] = splitAddedUpdatedEntities(newEntities, selectId, state);
    if (updated.length) {
      updateManyMutably(updated, state);
    }
    if (added.length) {
      addManyMutably(added, state, existingIdsArray);
    }
  }
  function areArraysEqual(a, b) {
    if (a.length !== b.length) {
      return false;
    }
    for (let i = 0; i < a.length; i++) {
      if (a[i] === b[i]) {
        continue;
      }
      return false;
    }
    return true;
  }
  const mergeFunction = (state, addedItems, appliedUpdates, replacedIds) => {
    const currentEntities = getCurrent(state.entities);
    const currentIds = getCurrent(state.ids);
    const stateEntities = state.entities;
    let ids = currentIds;
    if (replacedIds) {
      ids = new Set(currentIds);
    }
    let sortedEntities = [];
    for (const id of ids) {
      const entity = currentEntities[id];
      if (entity) {
        sortedEntities.push(entity);
      }
    }
    const wasPreviouslyEmpty = sortedEntities.length === 0;
    for (const item of addedItems) {
      stateEntities[selectId(item)] = item;
      if (!wasPreviouslyEmpty) {
        insert(sortedEntities, item, comparer);
      }
    }
    if (wasPreviouslyEmpty) {
      sortedEntities = addedItems.slice().sort(comparer);
    } else if (appliedUpdates) {
      sortedEntities.sort(comparer);
    }
    const newSortedIds = sortedEntities.map(selectId);
    if (!areArraysEqual(currentIds, newSortedIds)) {
      state.ids = newSortedIds;
    }
  };
  return {
    removeOne,
    removeMany,
    removeAll,
    addOne: createStateOperator(addOneMutably),
    updateOne: createStateOperator(updateOneMutably),
    upsertOne: createStateOperator(upsertOneMutably),
    setOne: createStateOperator(setOneMutably),
    setMany: createStateOperator(setManyMutably),
    setAll: createStateOperator(setAllMutably),
    addMany: createStateOperator(addManyMutably),
    updateMany: createStateOperator(updateManyMutably),
    upsertMany: createStateOperator(upsertManyMutably)
  };
}

// src/entities/create_adapter.ts
function createEntityAdapter(options = {}) {
  const {
    selectId,
    sortComparer
  } = {
    sortComparer: false,
    selectId: (instance) => instance.id,
    ...options
  };
  const stateAdapter = sortComparer ? createSortedStateAdapter(selectId, sortComparer) : createUnsortedStateAdapter(selectId);
  const stateFactory = createInitialStateFactory(stateAdapter);
  const selectorsFactory = createSelectorsFactory();
  return {
    selectId,
    sortComparer,
    ...stateFactory,
    ...selectorsFactory,
    ...stateAdapter
  };
}

// src/listenerMiddleware/index.ts


// src/listenerMiddleware/exceptions.ts
var task = "task";
var listener = "listener";
var completed = "completed";
var cancelled = "cancelled";
var taskCancelled = (/* unused pure expression or super */ null && (`task-${cancelled}`));
var taskCompleted = (/* unused pure expression or super */ null && (`task-${completed}`));
var listenerCancelled = (/* unused pure expression or super */ null && (`${listener}-${cancelled}`));
var listenerCompleted = (/* unused pure expression or super */ null && (`${listener}-${completed}`));
var TaskAbortError = class {
  constructor(code) {
    this.code = code;
    this.message = `${task} ${cancelled} (reason: ${code})`;
  }
  name = "TaskAbortError";
  message;
};

// src/listenerMiddleware/utils.ts
var assertFunction = (func, expected) => {
  if (typeof func !== "function") {
    throw new TypeError( true ? redux_toolkit_modern_formatProdErrorMessage(32) : 0);
  }
};
var noop2 = () => {
};
var catchRejection = (promise, onError = noop2) => {
  promise.catch(onError);
  return promise;
};
var addAbortSignalListener = (abortSignal, callback) => {
  abortSignal.addEventListener("abort", callback, {
    once: true
  });
  return () => abortSignal.removeEventListener("abort", callback);
};
var abortControllerWithReason = (abortController, reason) => {
  const signal = abortController.signal;
  if (signal.aborted) {
    return;
  }
  if (!("reason" in signal)) {
    Object.defineProperty(signal, "reason", {
      enumerable: true,
      value: reason,
      configurable: true,
      writable: true
    });
  }
  ;
  abortController.abort(reason);
};

// src/listenerMiddleware/task.ts
var validateActive = (signal) => {
  if (signal.aborted) {
    const {
      reason
    } = signal;
    throw new TaskAbortError(reason);
  }
};
function raceWithSignal(signal, promise) {
  let cleanup = noop2;
  return new Promise((resolve, reject) => {
    const notifyRejection = () => reject(new TaskAbortError(signal.reason));
    if (signal.aborted) {
      notifyRejection();
      return;
    }
    cleanup = addAbortSignalListener(signal, notifyRejection);
    promise.finally(() => cleanup()).then(resolve, reject);
  }).finally(() => {
    cleanup = noop2;
  });
}
var runTask = async (task2, cleanUp) => {
  try {
    await Promise.resolve();
    const value = await task2();
    return {
      status: "ok",
      value
    };
  } catch (error) {
    return {
      status: error instanceof TaskAbortError ? "cancelled" : "rejected",
      error
    };
  } finally {
    cleanUp?.();
  }
};
var createPause = (signal) => {
  return (promise) => {
    return catchRejection(raceWithSignal(signal, promise).then((output) => {
      validateActive(signal);
      return output;
    }));
  };
};
var createDelay = (signal) => {
  const pause = createPause(signal);
  return (timeoutMs) => {
    return pause(new Promise((resolve) => setTimeout(resolve, timeoutMs)));
  };
};

// src/listenerMiddleware/index.ts
var {
  assign: redux_toolkit_modern_assign
} = Object;
var INTERNAL_NIL_TOKEN = {};
var alm = "listenerMiddleware";
var createFork = (parentAbortSignal, parentBlockingPromises) => {
  const linkControllers = (controller) => addAbortSignalListener(parentAbortSignal, () => abortControllerWithReason(controller, parentAbortSignal.reason));
  return (taskExecutor, opts) => {
    assertFunction(taskExecutor, "taskExecutor");
    const childAbortController = new AbortController();
    linkControllers(childAbortController);
    const result = runTask(async () => {
      validateActive(parentAbortSignal);
      validateActive(childAbortController.signal);
      const result2 = await taskExecutor({
        pause: createPause(childAbortController.signal),
        delay: createDelay(childAbortController.signal),
        signal: childAbortController.signal
      });
      validateActive(childAbortController.signal);
      return result2;
    }, () => abortControllerWithReason(childAbortController, taskCompleted));
    if (opts?.autoJoin) {
      parentBlockingPromises.push(result.catch(noop2));
    }
    return {
      result: createPause(parentAbortSignal)(result),
      cancel() {
        abortControllerWithReason(childAbortController, taskCancelled);
      }
    };
  };
};
var createTakePattern = (startListening, signal) => {
  const take = async (predicate, timeout) => {
    validateActive(signal);
    let unsubscribe = () => {
    };
    const tuplePromise = new Promise((resolve, reject) => {
      let stopListening = startListening({
        predicate,
        effect: (action, listenerApi) => {
          listenerApi.unsubscribe();
          resolve([action, listenerApi.getState(), listenerApi.getOriginalState()]);
        }
      });
      unsubscribe = () => {
        stopListening();
        reject();
      };
    });
    const promises = [tuplePromise];
    if (timeout != null) {
      promises.push(new Promise((resolve) => setTimeout(resolve, timeout, null)));
    }
    try {
      const output = await raceWithSignal(signal, Promise.race(promises));
      validateActive(signal);
      return output;
    } finally {
      unsubscribe();
    }
  };
  return (predicate, timeout) => catchRejection(take(predicate, timeout));
};
var getListenerEntryPropsFrom = (options) => {
  let {
    type,
    actionCreator,
    matcher,
    predicate,
    effect
  } = options;
  if (type) {
    predicate = createAction(type).match;
  } else if (actionCreator) {
    type = actionCreator.type;
    predicate = actionCreator.match;
  } else if (matcher) {
    predicate = matcher;
  } else if (predicate) {
  } else {
    throw new Error( true ? redux_toolkit_modern_formatProdErrorMessage(21) : 0);
  }
  assertFunction(effect, "options.listener");
  return {
    predicate,
    type,
    effect
  };
};
var createListenerEntry = /* @__PURE__ */ redux_toolkit_modern_assign((options) => {
  const {
    type,
    predicate,
    effect
  } = getListenerEntryPropsFrom(options);
  const entry = {
    id: nanoid(),
    effect,
    type,
    predicate,
    pending: /* @__PURE__ */ new Set(),
    unsubscribe: () => {
      throw new Error( true ? redux_toolkit_modern_formatProdErrorMessage(22) : 0);
    }
  };
  return entry;
}, {
  withTypes: () => createListenerEntry
});
var findListenerEntry = (listenerMap, options) => {
  const {
    type,
    effect,
    predicate
  } = getListenerEntryPropsFrom(options);
  return Array.from(listenerMap.values()).find((entry) => {
    const matchPredicateOrType = typeof type === "string" ? entry.type === type : entry.predicate === predicate;
    return matchPredicateOrType && entry.effect === effect;
  });
};
var cancelActiveListeners = (entry) => {
  entry.pending.forEach((controller) => {
    abortControllerWithReason(controller, listenerCancelled);
  });
};
var createClearListenerMiddleware = (listenerMap) => {
  return () => {
    listenerMap.forEach(cancelActiveListeners);
    listenerMap.clear();
  };
};
var safelyNotifyError = (errorHandler, errorToNotify, errorInfo) => {
  try {
    errorHandler(errorToNotify, errorInfo);
  } catch (errorHandlerError) {
    setTimeout(() => {
      throw errorHandlerError;
    }, 0);
  }
};
var addListener = /* @__PURE__ */ redux_toolkit_modern_assign(/* @__PURE__ */ createAction(`${alm}/add`), {
  withTypes: () => addListener
});
var clearAllListeners = /* @__PURE__ */ (/* unused pure expression or super */ null && (createAction(`${alm}/removeAll`)));
var removeListener = /* @__PURE__ */ redux_toolkit_modern_assign(/* @__PURE__ */ createAction(`${alm}/remove`), {
  withTypes: () => removeListener
});
var defaultErrorHandler = (...args) => {
  console.error(`${alm}/error`, ...args);
};
var createListenerMiddleware = (middlewareOptions = {}) => {
  const listenerMap = /* @__PURE__ */ new Map();
  const {
    extra,
    onError = defaultErrorHandler
  } = middlewareOptions;
  assertFunction(onError, "onError");
  const insertEntry = (entry) => {
    entry.unsubscribe = () => listenerMap.delete(entry.id);
    listenerMap.set(entry.id, entry);
    return (cancelOptions) => {
      entry.unsubscribe();
      if (cancelOptions?.cancelActive) {
        cancelActiveListeners(entry);
      }
    };
  };
  const startListening = (options) => {
    const entry = findListenerEntry(listenerMap, options) ?? createListenerEntry(options);
    return insertEntry(entry);
  };
  redux_toolkit_modern_assign(startListening, {
    withTypes: () => startListening
  });
  const stopListening = (options) => {
    const entry = findListenerEntry(listenerMap, options);
    if (entry) {
      entry.unsubscribe();
      if (options.cancelActive) {
        cancelActiveListeners(entry);
      }
    }
    return !!entry;
  };
  redux_toolkit_modern_assign(stopListening, {
    withTypes: () => stopListening
  });
  const notifyListener = async (entry, action, api, getOriginalState) => {
    const internalTaskController = new AbortController();
    const take = createTakePattern(startListening, internalTaskController.signal);
    const autoJoinPromises = [];
    try {
      entry.pending.add(internalTaskController);
      await Promise.resolve(entry.effect(
        action,
        // Use assign() rather than ... to avoid extra helper functions added to bundle
        redux_toolkit_modern_assign({}, api, {
          getOriginalState,
          condition: (predicate, timeout) => take(predicate, timeout).then(Boolean),
          take,
          delay: createDelay(internalTaskController.signal),
          pause: createPause(internalTaskController.signal),
          extra,
          signal: internalTaskController.signal,
          fork: createFork(internalTaskController.signal, autoJoinPromises),
          unsubscribe: entry.unsubscribe,
          subscribe: () => {
            listenerMap.set(entry.id, entry);
          },
          cancelActiveListeners: () => {
            entry.pending.forEach((controller, _, set) => {
              if (controller !== internalTaskController) {
                abortControllerWithReason(controller, listenerCancelled);
                set.delete(controller);
              }
            });
          },
          cancel: () => {
            abortControllerWithReason(internalTaskController, listenerCancelled);
            entry.pending.delete(internalTaskController);
          },
          throwIfCancelled: () => {
            validateActive(internalTaskController.signal);
          }
        })
      ));
    } catch (listenerError) {
      if (!(listenerError instanceof TaskAbortError)) {
        safelyNotifyError(onError, listenerError, {
          raisedBy: "effect"
        });
      }
    } finally {
      await Promise.all(autoJoinPromises);
      abortControllerWithReason(internalTaskController, listenerCompleted);
      entry.pending.delete(internalTaskController);
    }
  };
  const clearListenerMiddleware = createClearListenerMiddleware(listenerMap);
  const middleware = (api) => (next) => (action) => {
    if (!isAction3(action)) {
      return next(action);
    }
    if (addListener.match(action)) {
      return startListening(action.payload);
    }
    if (clearAllListeners.match(action)) {
      clearListenerMiddleware();
      return;
    }
    if (removeListener.match(action)) {
      return stopListening(action.payload);
    }
    let originalState = api.getState();
    const getOriginalState = () => {
      if (originalState === INTERNAL_NIL_TOKEN) {
        throw new Error( true ? redux_toolkit_modern_formatProdErrorMessage(23) : 0);
      }
      return originalState;
    };
    let result;
    try {
      result = next(action);
      if (listenerMap.size > 0) {
        const currentState = api.getState();
        const listenerEntries = Array.from(listenerMap.values());
        for (const entry of listenerEntries) {
          let runListener = false;
          try {
            runListener = entry.predicate(action, currentState, originalState);
          } catch (predicateError) {
            runListener = false;
            safelyNotifyError(onError, predicateError, {
              raisedBy: "predicate"
            });
          }
          if (!runListener) {
            continue;
          }
          notifyListener(entry, action, api, getOriginalState);
        }
      }
    } finally {
      originalState = INTERNAL_NIL_TOKEN;
    }
    return result;
  };
  return {
    middleware,
    startListening,
    stopListening,
    clearListeners: clearListenerMiddleware
  };
};

// src/dynamicMiddleware/index.ts

var createMiddlewareEntry = (middleware) => ({
  middleware,
  applied: /* @__PURE__ */ new Map()
});
var matchInstance = (instanceId) => (action) => action?.meta?.instanceId === instanceId;
var createDynamicMiddleware = () => {
  const instanceId = nanoid();
  const middlewareMap = /* @__PURE__ */ new Map();
  const withMiddleware = Object.assign(createAction("dynamicMiddleware/add", (...middlewares) => ({
    payload: middlewares,
    meta: {
      instanceId
    }
  })), {
    withTypes: () => withMiddleware
  });
  const addMiddleware = Object.assign(function addMiddleware2(...middlewares) {
    middlewares.forEach((middleware2) => {
      getOrInsertComputed(middlewareMap, middleware2, createMiddlewareEntry);
    });
  }, {
    withTypes: () => addMiddleware
  });
  const getFinalMiddleware = (api) => {
    const appliedMiddleware = Array.from(middlewareMap.values()).map((entry) => getOrInsertComputed(entry.applied, api, entry.middleware));
    return compose3(...appliedMiddleware);
  };
  const isWithMiddleware = isAllOf(withMiddleware, matchInstance(instanceId));
  const middleware = (api) => (next) => (action) => {
    if (isWithMiddleware(action)) {
      addMiddleware(...action.payload);
      return api.dispatch;
    }
    return getFinalMiddleware(api)(next)(action);
  };
  return {
    middleware,
    addMiddleware,
    withMiddleware,
    instanceId
  };
};

// src/combineSlices.ts

var isSliceLike = (maybeSliceLike) => "reducerPath" in maybeSliceLike && typeof maybeSliceLike.reducerPath === "string";
var getReducers = (slices) => slices.flatMap((sliceOrMap) => isSliceLike(sliceOrMap) ? [[sliceOrMap.reducerPath, sliceOrMap.reducer]] : Object.entries(sliceOrMap));
var ORIGINAL_STATE = Symbol.for("rtk-state-proxy-original");
var isStateProxy = (value) => !!value && !!value[ORIGINAL_STATE];
var stateProxyMap = /* @__PURE__ */ new WeakMap();
var createStateProxy = (state, reducerMap) => getOrInsertComputed(stateProxyMap, state, () => new Proxy(state, {
  get: (target, prop, receiver) => {
    if (prop === ORIGINAL_STATE) return target;
    const result = Reflect.get(target, prop, receiver);
    if (typeof result === "undefined") {
      const reducer = reducerMap[prop.toString()];
      if (reducer) {
        const reducerResult = reducer(void 0, {
          type: nanoid()
        });
        if (typeof reducerResult === "undefined") {
          throw new Error( true ? redux_toolkit_modern_formatProdErrorMessage(24) : 0);
        }
        return reducerResult;
      }
    }
    return result;
  }
}));
var redux_toolkit_modern_original = (state) => {
  if (!isStateProxy(state)) {
    throw new Error( true ? redux_toolkit_modern_formatProdErrorMessage(25) : 0);
  }
  return state[ORIGINAL_STATE];
};
var noopReducer = (state = {}) => state;
function combineSlices(...slices) {
  const reducerMap = Object.fromEntries(getReducers(slices));
  const getReducer = () => Object.keys(reducerMap).length ? combineReducers2(reducerMap) : noopReducer;
  let reducer = getReducer();
  function combinedReducer(state, action) {
    return reducer(state, action);
  }
  combinedReducer.withLazyLoadedSlices = () => combinedReducer;
  const inject = (slice, config = {}) => {
    const {
      reducerPath,
      reducer: reducerToInject
    } = slice;
    const currentReducer = reducerMap[reducerPath];
    if (!config.overrideExisting && currentReducer && currentReducer !== reducerToInject) {
      if (typeof process !== "undefined" && "production" === "development") {}
      return combinedReducer;
    }
    reducerMap[reducerPath] = reducerToInject;
    reducer = getReducer();
    return combinedReducer;
  };
  const selector = Object.assign(function makeSelector(selectorFn, selectState) {
    return function selector2(state, ...args) {
      return selectorFn(createStateProxy(selectState ? selectState(state, ...args) : state, reducerMap), ...args);
    };
  }, {
    original: redux_toolkit_modern_original
  });
  return Object.assign(combinedReducer, {
    inject,
    selector
  });
}

// src/formatProdErrorMessage.ts
function redux_toolkit_modern_formatProdErrorMessage(code) {
  return `Minified Redux Toolkit error #${code}; visit https://redux-toolkit.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}

//# sourceMappingURL=redux-toolkit.modern.mjs.map
;// ./src/scripts/autocomplete-store.js
/**
 * @fileoverview Redux store configuration for managing the number of results.
 * @module AutoCompleteStore
 */



/**
 * Redux slice for managing the autocomplete state.
 * @type {import('@reduxjs/toolkit').Slice}
 */
var autocompleteStateSlice = createSlice({
  name: 'autocompleteState',
  initialState: {
    /** @type {Object} The current autocomplete state */
    value: {}
  },
  reducers: {
    /**
     * Updates the autocomplete state.
     * @param {Object} state - The current state.
     * @param {import('@reduxjs/toolkit').PayloadAction<number>} action - The action containing the new value.
     */
    update: function update(state, action) {
      state.value = action.payload;
    }
  }
});

/**
 * Action creator for updating the number of results.
 * @type {import('@reduxjs/toolkit').ActionCreatorWithPayload<number>}
 */
var update = autocompleteStateSlice.actions.update;

/**
 * The configured Redux store.
 * @type {import('@reduxjs/toolkit').Store}
 */

var store = configureStore({
  reducer: autocompleteStateSlice.reducer
});
;// ./node_modules/@algolia/autocomplete-preset-algolia/dist/esm/requester/createRequester.js
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function createRequester(fetcher, requesterId) {
  function execute(fetcherParams) {
    return fetcher({
      searchClient: fetcherParams.searchClient,
      queries: fetcherParams.requests.map(function (x) {
        return x.query;
      })
    }).then(function (responses) {
      return responses.map(function (response, index) {
        var _fetcherParams$reques = fetcherParams.requests[index],
          sourceId = _fetcherParams$reques.sourceId,
          transformResponse = _fetcherParams$reques.transformResponse;
        return {
          items: response,
          sourceId: sourceId,
          transformResponse: transformResponse
        };
      });
    });
  }
  return function createSpecifiedRequester(requesterParams) {
    return function requester(requestParams) {
      return _objectSpread(_objectSpread({
        requesterId: requesterId,
        execute: execute
      }, requesterParams), requestParams);
    };
  };
}
;// ./node_modules/@algolia/autocomplete-shared/dist/esm/version.js
var version = '1.18.1';
;// ./node_modules/@algolia/autocomplete-shared/dist/esm/userAgents.js

var userAgents_userAgents = [{
  segment: 'autocomplete-core',
  version: version
}];
;// ./node_modules/@algolia/autocomplete-shared/dist/esm/invariant.js
/**
 * Throws an error if the condition is not met in development mode.
 * This is used to make development a better experience to provide guidance as
 * to where the error comes from.
 */
function invariant(condition, message) {
  if (true) {
    return;
  }
  if (!condition) {
    throw new Error("[Autocomplete] ".concat(typeof message === 'function' ? message() : message));
  }
}
;// ./node_modules/@algolia/autocomplete-preset-algolia/dist/esm/constants/index.js
var HIGHLIGHT_PRE_TAG = '__aa-highlight__';
var HIGHLIGHT_POST_TAG = '__/aa-highlight__';
;// ./node_modules/@algolia/autocomplete-preset-algolia/dist/esm/utils/getAppIdAndApiKey.js
// typed as any, since it accepts the _real_ js clients, not the interface we otherwise expect
function getAppIdAndApiKey(searchClient) {
  var transporter = searchClient.transporter || {};
  var headers = transporter.headers || transporter.baseHeaders || {};
  var queryParameters = transporter.queryParameters || transporter.baseQueryParameters || {};
  var APP_ID = 'x-algolia-application-id';
  var API_KEY = 'x-algolia-api-key';
  var appId = headers[APP_ID] || queryParameters[APP_ID];
  var apiKey = headers[API_KEY] || queryParameters[API_KEY];
  return {
    appId: appId,
    apiKey: apiKey
  };
}
;// ./node_modules/@algolia/autocomplete-preset-algolia/dist/esm/search/fetchAlgoliaResults.js
function fetchAlgoliaResults_typeof(obj) { "@babel/helpers - typeof"; return fetchAlgoliaResults_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, fetchAlgoliaResults_typeof(obj); }
var _excluded = ["params"];
function fetchAlgoliaResults_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function fetchAlgoliaResults_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? fetchAlgoliaResults_ownKeys(Object(source), !0).forEach(function (key) { fetchAlgoliaResults_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : fetchAlgoliaResults_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function fetchAlgoliaResults_defineProperty(obj, key, value) { key = fetchAlgoliaResults_toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function fetchAlgoliaResults_toPropertyKey(arg) { var key = fetchAlgoliaResults_toPrimitive(arg, "string"); return fetchAlgoliaResults_typeof(key) === "symbol" ? key : String(key); }
function fetchAlgoliaResults_toPrimitive(input, hint) { if (fetchAlgoliaResults_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (fetchAlgoliaResults_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }



function fetchAlgoliaResults(_ref) {
  var searchClient = _ref.searchClient,
    queries = _ref.queries,
    _ref$userAgents = _ref.userAgents,
    userAgents = _ref$userAgents === void 0 ? [] : _ref$userAgents;
  if (typeof searchClient.addAlgoliaAgent === 'function') {
    var algoliaAgents = [].concat(_toConsumableArray(userAgents_userAgents), _toConsumableArray(userAgents));
    algoliaAgents.forEach(function (_ref2) {
      var segment = _ref2.segment,
        version = _ref2.version;
      searchClient.addAlgoliaAgent(segment, version);
    });
  }
  var _getAppIdAndApiKey = getAppIdAndApiKey(searchClient),
    appId = _getAppIdAndApiKey.appId,
    apiKey = _getAppIdAndApiKey.apiKey;
  invariant(Boolean(appId), 'The Algolia `appId` was not accessible from the searchClient passed.');
  invariant(Boolean(apiKey), 'The Algolia `apiKey` was not accessible from the searchClient passed.');
  return searchClient.search(queries.map(function (searchParameters) {
    var params = searchParameters.params,
      headers = _objectWithoutProperties(searchParameters, _excluded);
    return fetchAlgoliaResults_objectSpread(fetchAlgoliaResults_objectSpread({}, headers), {}, {
      params: fetchAlgoliaResults_objectSpread({
        hitsPerPage: 5,
        highlightPreTag: HIGHLIGHT_PRE_TAG,
        highlightPostTag: HIGHLIGHT_POST_TAG
      }, params)
    });
  })).then(function (response) {
    return response.results.map(function (result, resultIndex) {
      var _result$hits;
      return fetchAlgoliaResults_objectSpread(fetchAlgoliaResults_objectSpread({}, result), {}, {
        hits: (_result$hits = result.hits) === null || _result$hits === void 0 ? void 0 : _result$hits.map(function (hit) {
          return fetchAlgoliaResults_objectSpread(fetchAlgoliaResults_objectSpread({}, hit), {}, {
            // Bring support for the Insights plugin.
            __autocomplete_indexName: result.index || queries[resultIndex].indexName,
            __autocomplete_queryID: result.queryID,
            __autocomplete_algoliaCredentials: {
              appId: appId,
              apiKey: apiKey
            }
          });
        })
      });
    });
  });
}
;// ./node_modules/@algolia/autocomplete-js/dist/esm/userAgents.js

var userAgents = [{
  segment: 'autocomplete-js',
  version: version
}];
;// ./node_modules/@algolia/autocomplete-js/dist/esm/requesters/createAlgoliaRequester.js
function createAlgoliaRequester_typeof(obj) { "@babel/helpers - typeof"; return createAlgoliaRequester_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, createAlgoliaRequester_typeof(obj); }
function createAlgoliaRequester_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function createAlgoliaRequester_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? createAlgoliaRequester_ownKeys(Object(source), !0).forEach(function (key) { createAlgoliaRequester_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : createAlgoliaRequester_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function createAlgoliaRequester_defineProperty(obj, key, value) { key = createAlgoliaRequester_toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function createAlgoliaRequester_toPropertyKey(arg) { var key = createAlgoliaRequester_toPrimitive(arg, "string"); return createAlgoliaRequester_typeof(key) === "symbol" ? key : String(key); }
function createAlgoliaRequester_toPrimitive(input, hint) { if (createAlgoliaRequester_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (createAlgoliaRequester_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }


var createAlgoliaRequester = createRequester(function (params) {
  return fetchAlgoliaResults(createAlgoliaRequester_objectSpread(createAlgoliaRequester_objectSpread({}, params), {}, {
    userAgents: userAgents
  }));
}, 'algolia');
;// ./node_modules/@algolia/autocomplete-js/dist/esm/requesters/getAlgoliaResults.js


/**
 * Retrieves Algolia results from multiple indices.
 */
var getAlgoliaResults = createAlgoliaRequester({
  transformResponse: function transformResponse(response) {
    return response.hits;
  }
});
;// ./node_modules/@algolia/autocomplete-shared/dist/esm/getAttributeValueByPath.js
function getAttributeValueByPath(record, path) {
  return path.reduce(function (current, key) {
    return current && current[key];
  }, record);
}
;// ./node_modules/@algolia/autocomplete-plugin-query-suggestions/dist/esm/constants.js
var defaultTranslations = {
  fillQueryTitle: function fillQueryTitle(text) {
    return "Fill query with \"".concat(text, "\"");
  }
};
;// ./node_modules/@algolia/autocomplete-plugin-query-suggestions/dist/esm/getTemplates.js
/** @jsxRuntime classic */
/** @jsx createElement */

function getTemplates(_ref) {
  var onTapAhead = _ref.onTapAhead,
    translations = _ref.translations;
  return {
    item: function item(_ref2) {
      var item = _ref2.item,
        createElement = _ref2.createElement,
        components = _ref2.components;
      if (item.__autocomplete_qsCategory) {
        return createElement("div", {
          className: "aa-ItemWrapper"
        }, createElement("div", {
          className: "aa-ItemContent aa-ItemContent--indented"
        }, createElement("div", {
          className: "aa-ItemContentSubtitle aa-ItemContentSubtitle--standalone"
        }, createElement("span", {
          className: "aa-ItemContentSubtitleIcon"
        }), createElement("span", null, "in", ' ', createElement("span", {
          className: "aa-ItemContentSubtitleCategory"
        }, item.__autocomplete_qsCategory)))));
      }
      return createElement("div", {
        className: "aa-ItemWrapper"
      }, createElement("div", {
        className: "aa-ItemContent"
      }, createElement("div", {
        className: "aa-ItemIcon aa-ItemIcon--noBorder"
      }, createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "currentColor"
      }, createElement("path", {
        d: "M16.041 15.856c-0.034 0.026-0.067 0.055-0.099 0.087s-0.060 0.064-0.087 0.099c-1.258 1.213-2.969 1.958-4.855 1.958-1.933 0-3.682-0.782-4.95-2.050s-2.050-3.017-2.050-4.95 0.782-3.682 2.050-4.95 3.017-2.050 4.95-2.050 3.682 0.782 4.95 2.050 2.050 3.017 2.050 4.95c0 1.886-0.745 3.597-1.959 4.856zM21.707 20.293l-3.675-3.675c1.231-1.54 1.968-3.493 1.968-5.618 0-2.485-1.008-4.736-2.636-6.364s-3.879-2.636-6.364-2.636-4.736 1.008-6.364 2.636-2.636 3.879-2.636 6.364 1.008 4.736 2.636 6.364 3.879 2.636 6.364 2.636c2.125 0 4.078-0.737 5.618-1.968l3.675 3.675c0.391 0.391 1.024 0.391 1.414 0s0.391-1.024 0-1.414z"
      }))), createElement("div", {
        className: "aa-ItemContentBody"
      }, createElement("div", {
        className: "aa-ItemContentTitle"
      }, createElement(components.ReverseHighlight, {
        hit: item,
        attribute: "query"
      })))), createElement("div", {
        className: "aa-ItemActions"
      }, createElement("button", {
        type: "button",
        className: "aa-ItemActionButton",
        title: translations.fillQueryTitle(item.query),
        onClick: function onClick(event) {
          event.preventDefault();
          event.stopPropagation();
          onTapAhead(item);
        }
      }, createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "currentColor"
      }, createElement("path", {
        d: "M8 17v-7.586l8.293 8.293c0.391 0.391 1.024 0.391 1.414 0s0.391-1.024 0-1.414l-8.293-8.293h7.586c0.552 0 1-0.448 1-1s-0.448-1-1-1h-10c-0.552 0-1 0.448-1 1v10c0 0.552 0.448 1 1 1s1-0.448 1-1z"
      })))));
    }
  };
}
;// ./node_modules/@algolia/autocomplete-plugin-query-suggestions/dist/esm/createQuerySuggestionsPlugin.js
function createQuerySuggestionsPlugin_typeof(obj) { "@babel/helpers - typeof"; return createQuerySuggestionsPlugin_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, createQuerySuggestionsPlugin_typeof(obj); }
function createQuerySuggestionsPlugin_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function createQuerySuggestionsPlugin_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? createQuerySuggestionsPlugin_ownKeys(Object(source), !0).forEach(function (key) { createQuerySuggestionsPlugin_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : createQuerySuggestionsPlugin_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function createQuerySuggestionsPlugin_defineProperty(obj, key, value) { key = createQuerySuggestionsPlugin_toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function createQuerySuggestionsPlugin_toPropertyKey(arg) { var key = createQuerySuggestionsPlugin_toPrimitive(arg, "string"); return createQuerySuggestionsPlugin_typeof(key) === "symbol" ? key : String(key); }
function createQuerySuggestionsPlugin_toPrimitive(input, hint) { if (createQuerySuggestionsPlugin_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (createQuerySuggestionsPlugin_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = createQuerySuggestionsPlugin_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function createQuerySuggestionsPlugin_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return createQuerySuggestionsPlugin_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return createQuerySuggestionsPlugin_arrayLikeToArray(o, minLen); }
function createQuerySuggestionsPlugin_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }




function createQuerySuggestionsPlugin(options) {
  var _getOptions = getOptions(options),
    searchClient = _getOptions.searchClient,
    indexName = _getOptions.indexName,
    getSearchParams = _getOptions.getSearchParams,
    transformSource = _getOptions.transformSource,
    categoryAttribute = _getOptions.categoryAttribute,
    itemsWithCategories = _getOptions.itemsWithCategories,
    categoriesPerItem = _getOptions.categoriesPerItem,
    translations = _getOptions.translations;
  return {
    name: 'aa.querySuggestionsPlugin',
    getSources: function getSources(_ref) {
      var query = _ref.query,
        setQuery = _ref.setQuery,
        refresh = _ref.refresh,
        state = _ref.state;
      function onTapAhead(item) {
        setQuery("".concat(item.query, " "));
        refresh();
      }
      return [transformSource({
        source: {
          sourceId: 'querySuggestionsPlugin',
          getItemInputValue: function getItemInputValue(_ref2) {
            var item = _ref2.item;
            return item.query;
          },
          getItems: function getItems() {
            return getAlgoliaResults({
              searchClient: searchClient,
              queries: [{
                indexName: indexName,
                query: query,
                params: getSearchParams({
                  state: state
                })
              }],
              transformResponse: function transformResponse(_ref3) {
                var hits = _ref3.hits;
                var querySuggestionsHits = hits[0];
                if (!query || !categoryAttribute) {
                  return querySuggestionsHits;
                }
                var itemsWithCategoriesAdded = 0;
                return querySuggestionsHits.reduce(function (acc, current) {
                  var items = [current];
                  if (itemsWithCategoriesAdded < itemsWithCategories) {
                    var categories = (getAttributeValueByPath(current, Array.isArray(categoryAttribute) ? categoryAttribute : [categoryAttribute]) || []).map(function (x) {
                      return x.value;
                    }).slice(0, categoriesPerItem);
                    if (categories.length > 0) {
                      itemsWithCategoriesAdded++;
                    }
                    var _iterator = _createForOfIteratorHelper(categories),
                      _step;
                    try {
                      for (_iterator.s(); !(_step = _iterator.n()).done;) {
                        var category = _step.value;
                        items.push(createQuerySuggestionsPlugin_objectSpread({
                          __autocomplete_qsCategory: category
                        }, current));
                      }
                    } catch (err) {
                      _iterator.e(err);
                    } finally {
                      _iterator.f();
                    }
                  }
                  acc.push.apply(acc, items);
                  return acc;
                }, []);
              }
            });
          },
          templates: getTemplates({
            onTapAhead: onTapAhead,
            translations: translations
          })
        },
        onTapAhead: onTapAhead,
        state: state
      })];
    },
    __autocomplete_pluginOptions: options
  };
}
function getOptions(options) {
  return createQuerySuggestionsPlugin_objectSpread(createQuerySuggestionsPlugin_objectSpread({
    getSearchParams: function getSearchParams() {
      return {};
    },
    transformSource: function transformSource(_ref4) {
      var source = _ref4.source;
      return source;
    },
    itemsWithCategories: 1,
    categoriesPerItem: 1
  }, options), {}, {
    translations: createQuerySuggestionsPlugin_objectSpread(createQuerySuggestionsPlugin_objectSpread({}, defaultTranslations), options.translations)
  });
}
;// ./src/scripts/lang/algoliaTranslations.js
/**
 * @fileoverview Handles translations for Algolia search functionality by processing
 * and decoding translation strings from the global window.defaultAlgoliaTranslations object.
 */

/**
 * Object that will store the processed translation strings.
 * @type {Object.<string, string>}
 */
var languageStrings = {};

/**
 * Safely decodes URI components and HTML entities from a string.
 *
 * @param {*} str - The string to decode (or any value that might be a string)
 * @returns {*} The decoded string, or the original value if not a string or if decoding fails
 */
var safeDecodeURI = function safeDecodeURI(str) {
  try {
    // Return the input as is if it's not a string
    if (typeof str !== 'string') return str;
    var decoded = str;

    // Decode URI components (e.g., %20 → space)
    decoded = decodeURIComponent(decoded);

    // Decode HTML entities (e.g., &amp; → &) using textarea element
    var textArea = document.createElement('textarea');
    textArea.innerHTML = decoded;
    decoded = textArea.value;
    return decoded;
  } catch (e) {
    // Log the error and return the original string if decoding fails
    console.warn('Failed to decode:', str);
    console.warn('Error:', e);
    return str;
  }
};

// Process each translation string from the global Algolia translations object
Object.keys(window.defaultAlgoliaTranslations).forEach(function (key) {
  languageStrings[key] = safeDecodeURI(window.defaultAlgoliaTranslations[key]);
});

;// ./src/scripts/components/autocompleteOptionsHandler.js
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
function autocompleteOptionsHandler_typeof(o) { "@babel/helpers - typeof"; return autocompleteOptionsHandler_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, autocompleteOptionsHandler_typeof(o); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function autocompleteOptionsHandler_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function autocompleteOptionsHandler_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? autocompleteOptionsHandler_ownKeys(Object(t), !0).forEach(function (r) { autocompleteOptionsHandler_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : autocompleteOptionsHandler_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function autocompleteOptionsHandler_defineProperty(e, r, t) { return (r = autocompleteOptionsHandler_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, autocompleteOptionsHandler_toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function autocompleteOptionsHandler_toPropertyKey(t) { var i = autocompleteOptionsHandler_toPrimitive(t, "string"); return "symbol" == autocompleteOptionsHandler_typeof(i) ? i : i + ""; }
function autocompleteOptionsHandler_toPrimitive(t, r) { if ("object" != autocompleteOptionsHandler_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != autocompleteOptionsHandler_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }





/**
 * @typedef {Object} AutocompleteState
 * @property {string} query - The current search query
 * @property {boolean} isOpen - Whether the autocomplete panel is open
 * @property {string} status - Current status of the autocomplete (loading, idle, etc.)
 */

/**
 * @typedef {Object} AutocompleteOptions
 * @property {boolean} openOnFocus - Whether to open the panel when input is focused
 * @property {string} panelPlacement - How to position the panel
 * @property {Function} render - Custom render function for the autocomplete
 * @property {boolean} debug - Whether to enable debug mode
 * @property {Array} plugins - Array of autocomplete plugins
 * @property {Object} components - Custom components for rendering
 * @property {string} placeholder - Placeholder text for the input
 * @property {Function} onStateChange - Callback for state changes
 */

/**
 * Handles the configuration and customization of Algolia Autocomplete functionality
 * for the Shopify search implementation.
 */
var AutocompleteOptionsHandler = /*#__PURE__*/function () {
  /**
   * Initializes the AutocompleteOptionsHandler with required dependencies
   * from the window.algoliaShopify object.
   * @throws {Error} If algoliaShopify externals are not found
   */
  function AutocompleteOptionsHandler(config, parent) {
    _classCallCheck(this, AutocompleteOptionsHandler);
    this.config = config;
    this.currentState = null;
    this.closeButtonsEventListenersSet = false;
    var _window = window,
      algoliaShopify = _window.algoliaShopify;
    if (algoliaShopify && algoliaShopify.externals) {
      this.html = algoliaShopify.externals.html;
    } else {
      console.error('algoliaShopify externals not found');
    }
  }

  /**
   * Processes and modifies autocomplete options before initialization
   * @param {AutocompleteOptions} options - The original autocomplete options
   * @param {Object} parent - The parent context
   * @returns {AutocompleteOptions} Modified options
   */
  return _createClass(AutocompleteOptionsHandler, [{
    key: "beforeAutocompleteOptions",
    value: function beforeAutocompleteOptions(options) {
      try {
        this.setupOptions(options);
        this.replaceQuerySuggestionsPlugin(options);
        this.addDebouncingToPlugins(options);
        this.setComponents(options);
        this.setPlaceholder(options);
        this.setupOnStateChange(options);
        this.setupCloseButtonEventListeners();
        this.updateHitsPerPageBasedOnWindowWidth(options);
        return options;
      } catch (error) {
        console.error('Error in beforeAutocompleteOptions:', error);
      }
    }

    /**
     * Sets up basic autocomplete options and validates required methods
     * @param {AutocompleteOptions} options - The options to set up
     * @throws {Error} If customRender method is not defined
     */
  }, {
    key: "setupOptions",
    value: function setupOptions(options) {
      if (typeof this.customRender !== 'function') {
        throw new Error('customRender method is not defined');
      }
      options.panelPlacement = 'full-width';
      options.panelContainer = '.search-modal__content';
      options.openOnFocus = true;
      options.render = this.customRender.bind(this);
      options.debug = false;
      options.stallThreshold = 1200;
      options.onSubmit = function (_ref) {
        var e = _ref.state;
        /* Check if the current page is a brand page */
        var brandView = document.body.dataset.brand;
        var gibsonPreselected = window.Shopify.gibson_brand_preselected;
        var capitalisedBrand = window.Shopify.alternateBrand && window.Shopify.alternateBrand.isAlternateBrand ? window.Shopify.alternateBrand.brand.charAt(0).toUpperCase() + window.Shopify.alternateBrand.brand.slice(1) : '';
        /* Refinement list params in format: refinementList[vendor][0]=Epiphone */

        var baseParams = {
          q: e.query
        };
        var queryString = new URLSearchParams(baseParams).toString();
        if (gibsonPreselected && brandView === 'gibson') {
          capitalisedBrand = 'Gibson';
        }
        if (brandView === 'mesa') {
          capitalisedBrand = 'Mesa/Boogie';
        }
        // Add refinement list parameter if needed
        if (window.Shopify.alternateBrand && window.Shopify.alternateBrand.isAlternateBrand || gibsonPreselected && brandView === 'gibson') {
          if (gibsonPreselected && brandView === 'gibson') {
            queryString += "&refinementList[vendor][0]=Gibson&refinementList[vendor][1]=Gibson Custom";
          } else {
            queryString += "&refinementList[vendor][0]=".concat(encodeURIComponent(capitalisedBrand));
          }
        }

        // Add view parameter if needed
        if (brandView) {
          queryString += "&view=".concat(brandView);
        }
        var urlToRedirect = "".concat(window.Shopify.routes.root, "search?").concat(queryString);
        window.location.href = urlToRedirect;
      };
    }

    /**
     * Adds debouncing to all autocomplete plugins to prevent requests on every keystroke
     * Requests will only be made after the user stops typing for a specified delay
     * This wraps each source's getItems function with debouncing, which is where the actual API calls happen
     * @param {AutocompleteOptions} options - The options containing plugins
     * @private
     */
  }, {
    key: "addDebouncingToPlugins",
    value: function addDebouncingToPlugins(options) {
      var _this = this;
      try {
        if (!options.plugins || !Array.isArray(options.plugins)) {
          return;
        }

        // Debounce delay in milliseconds
        var DEBOUNCE_DELAY = 1000;

        // Map to store debounce state per source ID
        // This ensures debounce state persists even if getSources returns new source objects
        var debounceStateMap = new Map();
        options.plugins.forEach(function (plugin) {
          // Check if plugin has a getSources function
          if (plugin && typeof plugin.getSources === 'function') {
            var originalGetSources = plugin.getSources;
            var isQuerySuggestionsPlugin = plugin.name === 'aa.querySuggestionsPlugin';

            // Wrap getSources to intercept sources and debounce their getItems
            plugin.getSources = function (params) {
              // Prevent fetching if query is blank, but allow query suggestions plugin
              // to return static suggestions even when query is blank
              if ((!params.query || params.query.trim().length === 0) && !isQuerySuggestionsPlugin) {
                // Return empty sources array to prevent API calls for non-suggestion plugins
                return [];
              }
              var sourcesResult = originalGetSources(params);

              // Handle both Promise and array returns
              if (sourcesResult && typeof sourcesResult.then === 'function') {
                // If getSources returns a Promise, wrap it
                return sourcesResult.then(function (sources) {
                  return _this.debounceSources(sources, DEBOUNCE_DELAY, debounceStateMap);
                });
              } else if (Array.isArray(sourcesResult)) {
                // If getSources returns an array directly
                return _this.debounceSources(sourcesResult, DEBOUNCE_DELAY, debounceStateMap);
              }
              return sourcesResult;
            };
          }
        });
      } catch (error) {
        console.error('Error in addDebouncingToPlugins:', error);
      }
    }

    /**
     * Wraps each source's getItems function with debouncing
     * Uses sourceId as a key to maintain debounce state across multiple getSources calls
     * @param {Array} sources - Array of source objects
     * @param {number} delay - Debounce delay in milliseconds
     * @param {Map} debounceStateMap - Map to store debounce state per source ID
     * @returns {Array} Sources with debounced getItems functions
     * @private
     */
  }, {
    key: "debounceSources",
    value: function debounceSources(sources, delay, debounceStateMap) {
      if (!Array.isArray(sources)) {
        return sources;
      }
      return sources.map(function (source) {
        // Only wrap if source has a getItems function
        if (source && typeof source.getItems === 'function') {
          var sourceId = source.sourceId || source.id || "source-".concat(Math.random());
          var currentGetItems = source.getItems;
          // Check if this is the query suggestions source - it should not be debounced when query is empty
          var isQuerySuggestionsSource = sourceId === 'querySuggestions' || sourceId.includes('querySuggestions');

          // Get or create debounce state for this source ID
          if (!debounceStateMap.has(sourceId)) {
            debounceStateMap.set(sourceId, {
              timeout: null,
              pendingRequest: null
            });
          }
          var debounceState = debounceStateMap.get(sourceId);

          // Create the debounced version
          // Always use the current source's getItems function to ensure we have the latest closure/context
          // but share the debounce timer across all instances of the same source
          source.getItems = function (params) {
            // Prevent fetching if query is blank, but allow query suggestions to return static suggestions
            if (!params.query || params.query.trim().length === 0) {
              // If this is the query suggestions source, let it handle empty queries (for static suggestions)
              if (isQuerySuggestionsSource) {
                return currentGetItems(params);
              }
              // For other sources, return empty array
              return Promise.resolve([]);
            }
            return new Promise(function (resolve, reject) {
              // Clear any pending timeout
              if (debounceState.timeout) {
                clearTimeout(debounceState.timeout);
              }
              var modifiedDelay = params.query === '' ? 0 : delay;
              // Store the latest request details including the current getItems function
              debounceState.pendingRequest = {
                params: params,
                resolve: resolve,
                reject: reject,
                getItems: currentGetItems // Store the current getItems function
              };

              // Set up debounced execution
              debounceState.timeout = setTimeout(function () {
                if (!debounceState.pendingRequest) {
                  debounceState.timeout = null;
                  return;
                }
                var _debounceState$pendin = debounceState.pendingRequest,
                  latestParams = _debounceState$pendin.params,
                  latestResolve = _debounceState$pendin.resolve,
                  latestReject = _debounceState$pendin.reject,
                  getItemsToCall = _debounceState$pendin.getItems;
                debounceState.pendingRequest = null;

                // Call the getItems function that was stored with this request
                // This ensures we use the correct closure/context for the source
                try {
                  var itemsPromise = getItemsToCall(latestParams);

                  // Handle both Promise and non-Promise returns
                  if (itemsPromise && typeof itemsPromise.then === 'function') {
                    itemsPromise.then(function (items) {
                      if (latestResolve) {
                        latestResolve(items);
                      }
                    }).catch(function (error) {
                      if (latestReject) {
                        latestReject(error);
                      }
                    });
                  } else {
                    // If getItems doesn't return a Promise, resolve immediately
                    if (latestResolve) {
                      latestResolve(itemsPromise);
                    }
                  }
                } catch (error) {
                  if (latestReject) {
                    latestReject(error);
                  }
                }
                debounceState.timeout = null;
              }, modifiedDelay);
            });
          };
        }
        return source;
      });
    }

    /**
     * Gets static query suggestions to avoid API calls
     * @returns {Array} Array of static suggestion objects with query property
     * @private
     */
  }, {
    key: "getStaticSuggestions",
    value: function getStaticSuggestions() {
      // Define static suggestions - can be customized based on your needs
      var brandView = document.body.dataset.brand;
      var staticSuggestions = window.algoliaSuggestions['gibson'].map(function (item) {
        return {
          query: item.label,
          isLink: item.is_this_a_link,
          link: item.link
        };
      });
      if (window.algoliaSuggestions[brandView].length) {
        staticSuggestions = window.algoliaSuggestions[brandView].map(function (item) {
          return {
            query: item.label,
            isLink: item.is_this_a_link,
            link: item.link
          };
        });
      }
      return staticSuggestions;
    }

    /**
     * Replaces the default query suggestions plugin with a customized version
     * that includes custom templates, URL handling, and static sources to avoid API calls
     * @param {AutocompleteOptions} options - The options containing plugins
     */
  }, {
    key: "replaceQuerySuggestionsPlugin",
    value: function replaceQuerySuggestionsPlugin(options) {
      var _this2 = this;
      try {
        // Find the existing query suggestions plugin
        var foundPlugin = options.plugins.find(function (plugin) {
          return plugin.name === 'aa.querySuggestionsPlugin';
        });
        if (foundPlugin) {
          // Create new plugin options with custom templates and URL handling
          var newOptions = autocompleteOptionsHandler_objectSpread(autocompleteOptionsHandler_objectSpread({}, foundPlugin.__autocomplete_pluginOptions), {}, {
            transformSource: function transformSource(_ref2) {
              var source = _ref2.source,
                _onTapAhead = _ref2.onTapAhead;
              // Store the original getItems function
              var originalGetItems = source.getItems;
              // Store reference to this for getStaticSuggestions
              var handler = _this2;
              return autocompleteOptionsHandler_objectSpread(autocompleteOptionsHandler_objectSpread({}, source), {}, {
                sourceId: source.sourceId || 'querySuggestions',
                getItemUrl: function getItemUrl(_ref3) {
                  var item = _ref3.item;
                  return "".concat(window.Shopify.routes.root, "search?q=").concat(item.query);
                },
                // Override getItems to return static suggestions only when query is empty
                // Otherwise use the original function to make API calls
                getItems: function getItems(params) {
                  // Use static suggestions only if query is empty
                  // Call getStaticSuggestions dynamically to get current brand context
                  if (!params.query || params.query.trim().length === 0) {
                    var staticSuggestions = handler.getStaticSuggestions();
                    // Return directly (autocomplete handles both sync and async)
                    return staticSuggestions;
                  }
                  // Otherwise, use the original getItems function for API calls
                  // Ensure it always returns an array (even if empty) to keep the source visible
                  var result = originalGetItems(params);
                  // If result is a Promise, ensure it resolves to an array
                  if (result && typeof result.then === 'function') {
                    return result.then(function (items) {
                      return items || [];
                    });
                  }
                  // If result is not a Promise, ensure it's an array
                  return result || [];
                },
                // Add noResults template to ensure the source is always rendered
                templates: autocompleteOptionsHandler_objectSpread(autocompleteOptionsHandler_objectSpread({}, source.templates), {}, {
                  noResults: function noResults() {
                    return '';
                  },
                  item: function item(_ref4) {
                    var _item = _ref4.item,
                      components = _ref4.components;
                    var brandView = document.body.dataset.brand;
                    var gibsonPreselected = window.Shopify.gibson_brand_preselected;
                    var capitalisedBrand = window.Shopify.alternateBrand && window.Shopify.alternateBrand.isAlternateBrand ? window.Shopify.alternateBrand.brand.charAt(0).toUpperCase() + window.Shopify.alternateBrand.brand.slice(1) : '';
                    var baseParams = {
                      q: _item.query
                    };
                    var queryString;
                    if (_item.isLink && !!_item.link) {
                      queryString = _item.link.replace(/^\//, '');
                      queryString = "".concat(queryString.indexOf('http') < 0 ? window.Shopify.routes.root : '').concat(queryString);
                    } else {
                      queryString = new URLSearchParams(baseParams).toString();
                      // Add refinement list parameter if needed
                      if (window.Shopify.alternateBrand && window.Shopify.alternateBrand.isAlternateBrand || gibsonPreselected && brandView === 'gibson') {
                        if (brandView === 'mesa') {
                          queryString += "&refinementList[vendor][0]=Mesa/Boogie";
                        } else {
                          if (gibsonPreselected && brandView === 'gibson') {
                            queryString += "&refinementList[vendor][0]=Gibson&refinementList[vendor][1]=Gibson Custom";
                          } else {
                            queryString += "&refinementList[vendor][0]=".concat(encodeURIComponent(capitalisedBrand));
                          }
                        }
                      }

                      // Add view parameter if needed
                      if (brandView) {
                        queryString += "&view=".concat(brandView);
                      }
                      queryString = "".concat(window.Shopify.routes.root, "search?").concat(queryString);
                    }
                    return _this2.html(_templateObject || (_templateObject = _taggedTemplateLiteral(["<a\n                    class=\"aa-ItemLink button aa-ItemLink--button\"\n                    href=\"", "\"\n                  >\n                    ", "\n                  </a>"])), queryString, components.Highlight({
                      hit: _item,
                      attribute: 'query'
                    }));
                  }
                })
              });
            }
          });
          var newPlugin = createQuerySuggestionsPlugin(newOptions);

          // Replace old plugin with new one
          options.plugins = options.plugins.filter(function (plugin) {
            return plugin.name !== 'aa.querySuggestionsPlugin';
          });
          options.plugins.push(newPlugin);
        } else {
          console.warn('aa.querySuggestionsPlugin not found in options.plugins');
        }
      } catch (error) {
        console.error('Error in replaceQuerySuggestionsPlugin:', error);
      }
    }

    /**
     * Sets up custom components for the autocomplete UI
     * @param {AutocompleteOptions} options - The options to add components to
     */
  }, {
    key: "setComponents",
    value: function setComponents(options) {
      var _this3 = this;
      try {
        options.components = {
          // LookingFor component renders suggestion links with optional bullet points for desktop
          LookingFor: function LookingFor(handle, title, page) {
            if (window.algoliaShopify && window.algoliaShopify.translations) {
              window.algoliaShopify.translations.lookingFor = languageStrings.lookingFor;
            }
            return _this3.html(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["<li>\n            <a href=\"", "\" class=\"aa-ItemLink button aa-ItemLink--button\"\n              >\u2022 ", "</a\n            >\n          </li>"])), handle, title);
          }
        };
      } catch (error) {
        console.error('Error in setComponents:', error);
      }
    }

    /**
     * Sets the placeholder text based on window width
     * @param {AutocompleteOptions} options - The options to set placeholder on
     */
  }, {
    key: "setPlaceholder",
    value: function setPlaceholder(options) {
      options.placeholder = window.innerWidth < 1024 ? languageStrings.mobileSearchPlaceholder : languageStrings.desktopSearchPlaceholder;
    }

    /**
     * Sets up the state change handler for the autocomplete
     * @param {AutocompleteOptions} options - The options to add state change handler to
     */
  }, {
    key: "setupOnStateChange",
    value: function setupOnStateChange(options) {
      var _this4 = this;
      try {
        var _store$getState$value = store.getState().value,
          query = _store$getState$value.query,
          isOpen = _store$getState$value.isOpen,
          status = _store$getState$value.status;
        options.onStateChange = function (_ref5) {
          var state = _ref5.state;
          _this4.currentState = state;

          // Skip updates during loading state
          if (state.status === 'loading') return;
          var previousState = store.getState().value;
          var previousStateIsOpen = previousState.isOpen;

          // Update store with new state
          store.dispatch(update({
            query: state.query,
            isOpen: state.isOpen,
            status: state.status
          }));

          // Dispatch custom event when panel closes
          if (state.isOpen === false && previousStateIsOpen === true) {
            document.dispatchEvent(new CustomEvent('algolia.autocomplete.stateChange', {
              detail: {
                isOpen: state.isOpen,
                previousIsOpen: previousStateIsOpen
              }
            }));
          }
        };
      } catch (error) {
        console.error('Error in setupOnStateChange:', error);
      }
    }

    /**
     * Sets up event listeners for close buttons if not already set
     * Attaches click handlers to all close buttons in the search modal
     */
  }, {
    key: "setupCloseButtonEventListeners",
    value: function setupCloseButtonEventListeners() {
      var _this5 = this;
      if (this.closeButtonsEventListenersSet) return;
      try {
        var closeButtons = document.querySelectorAll('.search-modal__close-button');
        closeButtons.forEach(function (button) {
          button.addEventListener('click', function () {
            _this5.handleCloseButtonClick();
          });
        });
        this.closeButtonsEventListenersSet = true;
      } catch (error) {
        console.error('Error in setupCloseButtonEventListeners:', error);
      }
    }

    /**
     * Handles the close button click event
     * Updates store state, resets parent component, and simulates Escape key press
     */
  }, {
    key: "handleCloseButtonClick",
    value: function handleCloseButtonClick() {
      try {
        var _store$getState$value2 = store.getState().value,
          query = _store$getState$value2.query,
          status = _store$getState$value2.status;
        store.dispatch(update({
          query: query,
          isOpen: false,
          status: status
        }));
        var _window$algoliaShopif = window.algoliaShopify.custom,
          setQuery = _window$algoliaShopif.setQuery,
          setIsOpen = _window$algoliaShopif.setIsOpen;
        setIsOpen(false);
        setQuery('');

        // Simulate Escape key press to close autocomplete
        var element = document.querySelector('#autocomplete-0-input');
        if (element) {
          element.dispatchEvent(new KeyboardEvent('keydown', {
            key: 'Escape'
          }));
        } else {
          console.error('Element not found: #autocomplete-0-input');
        }
      } catch (error) {
        console.error('Error in handleCloseButtonClick:', error);
      }
    }

    /**
     * Updates the number of hits per page based on window width
     * Mobile shows fewer hits than desktop
     * @param {AutocompleteOptions} options - The options to update hits per page on
     */
  }, {
    key: "updateHitsPerPageBasedOnWindowWidth",
    value: function updateHitsPerPageBasedOnWindowWidth(options) {
      var windowWidth = window.innerWidth;
      var hitsPerPage = windowWidth < 1024 && windowWidth >= 768 ? 3 : 5;
      window.algoliaShopify.config.products_autocomplete_hits_per_page = hitsPerPage;
      options.hitsPerPage = hitsPerPage;
    }

    /**
     * Custom render function for the autocomplete panel
     * @param {Object} params - Render parameters
     * @param {Array} params.sections - Sections to render
     * @param {Object} params.elements - Elements to render
     * @param {Object} params.components - Available components
     * @param {Function} params.html - HTML template function
     * @param {Function} params.render - Render function
     * @param {AutocompleteState} params.state - Current autocomplete state
     * @param {HTMLElement} root - Root element to render into
     */
  }, {
    key: "customRender",
    value: function customRender(_ref6, root) {
      var sections = _ref6.sections,
        elements = _ref6.elements,
        components = _ref6.components,
        html = _ref6.html,
        render = _ref6.render,
        state = _ref6.state;
      try {
        // Update submit and clear button icons with responsive SVGs

        try {
          var submitButton = document.querySelector('.aa-SubmitButton');
          if (submitButton) {
            if (window.innerWidth >= 1024) {
              submitButton.innerHTML = "\n            <svg width=\"36\" height=\"36\" viewBox=\"0 0 36 36\" fill=\"none\"\n              xmlns=\"http://www.w3.org/2000/svg\" class=\"aa-SubmitIcon\">\n              <path d=\"M23.5736 10.2553C27.25 13.9317 27.25 19.8924 23.5736 23.5687C19.8972 27.2451 13.9366 27.2451 10.2602 23.5687C6.58383 19.8924 6.58383 13.9317 10.2602 10.2553C13.9366 6.57895 19.8972 6.57895 23.5736 10.2553\" stroke=\"black\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n              <path d=\"M28.4995 28.4995L23.5645 23.5645\" stroke=\"black\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n            </svg>\n          ";
            } else {
              submitButton.innerHTML = "\n            <svg width=\"30\" height=\"30\" viewBox=\"0 0 30 30\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n            <path d=\"M19.6422 8.54775C22.7059 11.6114 22.7059 16.5786 19.6422 19.6422C16.5786 22.7059 11.6114 22.7059 8.54775 19.6422C5.48408 16.5786 5.48408 11.6114 8.54775 8.54775C11.6114 5.48408 16.5786 5.48408 19.6422 8.54775\" stroke=\"#323232\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n            <path d=\"M23.7492 23.7492L19.6367 19.6367\" stroke=\"#323232\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n            </svg>\n          ";
            }
          } else {
            console.warn('Submit button not found.');
          }
          var clearButton = document.querySelectorAll('.aa-ClearButton');
          if (clearButton && clearButton.length > 0 && window.innerWidth < 1024) {
            clearButton.forEach(function (button) {
              button.innerHTML = "\n            <svg width=\"30\" height=\"30\" viewBox=\"0 0 30 30\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n            <rect x=\"9.16602\" y=\"8.3858\" width=\"17.25\" height=\"0.75\" rx=\"0.375\" transform=\"rotate(45 9.16602 8.3858)\" fill=\"black\" stroke=\"black\" stroke-width=\"0.75\"/>\n            <rect x=\"8.6358\" y=\"20.584\" width=\"17.25\" height=\"0.75\" rx=\"0.375\" transform=\"rotate(-45 8.6358 20.584)\" fill=\"black\" stroke=\"black\" stroke-width=\"0.75\"/>\n            </svg>\n          ";
            });
          } else {
            console.warn('Clear button not found.');
          }
        } catch (error) {
          console.error('Error in beforeAutocompleteOptions:', error);
        }

        // Filter and process collections to get relevant items

        var lookingForItems = window.lookingFor;

        // Transform items into component data
        var compdata = lookingForItems ? lookingForItems.map(function (item) {
          return {
            handle: item.link_url,
            title: item.link_title,
            page: 'pages'
          };
        }) : [];

        // Set up translations
        algoliaShopify.translations.suggestions = languageStrings.suggestedSearches;
        algoliaShopify.translations.lookingFor = languageStrings.lookingFor;
        algoliaShopify.translations.products = languageStrings.results;

        // Determine panel layout classes based on query length
        var queryLengthIsZeroLeft = state.query.length === 0 ? 'aa-PanelSection--half' : 'aa-PanelSection--full';
        var queryLengthIsZeroRight = state.query.length === 0 ? 'aa-PanelSection--half' : 'aa-PanelSection--full';

        // Render the complete panel with conditional sections based on query state
        render(html(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["<div class=\"aa-PanelLayout aa-Panel--scrollable ", "\">\n          <div class=\"aa-PanelSections\">\n            <div class=\"", "\">\n              <div class=\"aa-SourceHeader aa-SourceHeader--Suggestions\">\n                <span class=\"aa-SourceHeaderTitle\"\n                  >", "</span\n                >\n              </div>\n              ", "\n            </div>\n            <div class=\"", " ", "\">\n              ", "\n              ", "\n            </div>\n          </div>\n        </div>"])), state.query.length === 0 ? '' : 'has-products', queryLengthIsZeroLeft, algoliaShopify.translations.suggestions, elements.querySuggestionsPlugin, queryLengthIsZeroRight, state.query.length > 0 ? 'aa-ResultsList' : '', state.query.length === 0 ? html(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["<div class=\"aa-SourceHeader\">\n                      <span class=\"aa-SourceHeaderTitle\">", "</span>\n                    </div>\n                    <div class=\"aa-Source\" data-autocomplete-source-id=\"compdata\">\n                      <ul class=\"aa-PanelLayout--content-body aa-List\">\n                        ", "\n                      </ul>\n                    </div>"])), algoliaShopify.translations.lookingFor, compdata.map(function (_ref7) {
          var handle = _ref7.handle,
            title = _ref7.title,
            page = _ref7.page;
          return components.LookingFor(handle, title, page);
        })) : '', state.query.length === 0 ? '' : elements.products), root);
      } catch (error) {
        console.error('Error in customRender:', error);
      }
    }
  }]);
}();
/* harmony default export */ var autocompleteOptionsHandler = (AutocompleteOptionsHandler);
;// ./src/scripts/utils/PriceHandler.js
var PriceHandler_templateObject, PriceHandler_templateObject2;
function PriceHandler_taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function PriceHandler_typeof(o) { "@babel/helpers - typeof"; return PriceHandler_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, PriceHandler_typeof(o); }
function PriceHandler_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function PriceHandler_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, PriceHandler_toPropertyKey(o.key), o); } }
function PriceHandler_createClass(e, r, t) { return r && PriceHandler_defineProperties(e.prototype, r), t && PriceHandler_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function PriceHandler_toPropertyKey(t) { var i = PriceHandler_toPrimitive(t, "string"); return "symbol" == PriceHandler_typeof(i) ? i : i + ""; }
function PriceHandler_toPrimitive(t, r) { if ("object" != PriceHandler_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != PriceHandler_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var PriceHandler = /*#__PURE__*/function () {
  /**
   * Creates an instance of PriceHandler.
   * @param {Object} algoliaHelpers - Helper functions provided by Algolia.
   */
  function PriceHandler(algoliaHelpers) {
    PriceHandler_classCallCheck(this, PriceHandler);
    /**
     * Helper functions provided by Algolia.
     * @type {Object}
     */
    this.helpers = algoliaHelpers;
  }

  /**
   * Determines if the product is on sale.
   * Checks if the compare at price is greater than the current price,
   * using localized prices from market_pricing_ if available.
   * @param {Object} hit - The product hit data.
   * @returns {boolean} - True if the product is on sale, false otherwise.
   */
  return PriceHandler_createClass(PriceHandler, [{
    key: "isOnSale",
    value: function isOnSale(hit) {
      // Determine currency code
      var activeCurrencyCode = this.helpers.activeCurrencyCode && typeof this.helpers.activeCurrencyCode === 'function' ? this.helpers.activeCurrencyCode().toUpperCase() : window.algoliaShopify && window.algoliaShopify.config && window.algoliaShopify.config.store_currency ? window.algoliaShopify.config.store_currency : '';
      var defaultCurrencyCode = window.algoliaShopify && window.algoliaShopify.config && window.algoliaShopify.config.store_currency ? window.algoliaShopify.config.store_currency : '';
      var differentCurrency = !!(activeCurrencyCode && activeCurrencyCode !== defaultCurrencyCode);

      // Check for localized price if different currency
      if (differentCurrency && activeCurrencyCode) {
        var marketPricingKey = "market_pricing_".concat(activeCurrencyCode.toLowerCase());
        var localized = hit[marketPricingKey];
        if (localized && PriceHandler_typeof(localized) === 'object' && typeof localized.compare_at_price !== 'undefined' && typeof localized.price !== 'undefined') {
          return localized.compare_at_price > localized.price;
        }
      }

      // Fall back to default compare_at_price and price
      return hit.compare_at_price && hit.compare_at_price > hit.price;
    }

    /**
     * Creates the price element for the product.
     * Generates HTML for the product price, including sale price if applicable.
     * @param {Object} hit - The product hit data.
     * @param {Function} html - The HTML template function.
     * @returns {TemplateResult} - The HTML template for the price element.
     */
  }, {
    key: "createPriceElement",
    value: function createPriceElement(hit, html) {
      var _this = this;
      console.log('hit', hit);

      // Use localized price for striked (compare_at) price if available
      var activeCurrencyCode = this.helpers.activeCurrencyCode && this.helpers.activeCurrencyCode().toUpperCase ? this.helpers.activeCurrencyCode().toUpperCase() : window.algoliaShopify && window.algoliaShopify.config && window.algoliaShopify.config.store_currency ? window.algoliaShopify.config.store_currency : '';
      var differentCurrency = window.algoliaShopify && window.algoliaShopify.config && activeCurrencyCode && activeCurrencyCode !== window.algoliaShopify.config.store_currency;
      var marketPrice = hit.price;
      var marketCompareAtPrice = hit.compare_at_price;
      if (differentCurrency) {
        var marketPricingKey = "market_pricing_".concat(activeCurrencyCode.toLowerCase());
        if (hit[marketPricingKey] && PriceHandler_typeof(hit[marketPricingKey]) === "object") {
          if (typeof hit[marketPricingKey].price !== 'undefined') {
            marketPrice = hit[marketPricingKey].price;
          }
          if (typeof hit[marketPricingKey].compare_at_price !== 'undefined') {
            marketCompareAtPrice = hit[marketPricingKey].compare_at_price;
          }
        }
      }
      var isOnSale = this.isOnSale(hit);

      // Helper method to format the price.
      var helpermethod = function helpermethod(price) {
        return _this.helpers.displayPrice(price);
      };
      try {
        // Attempt to format the price using formatMoney method.
        var formatted = this.formatMoney(hit.price);
      } catch (error) {
        // Handle error if formatMoney is not defined.
      }
      return html(PriceHandler_templateObject || (PriceHandler_templateObject = PriceHandler_taggedTemplateLiteral(["\n      <div class=\"price\">\n        <div class=\"price__container\">\n          <div class=\"price__regular\" data-is-on-sale=\"", "\">\n            <span class=\"visually-hidden visually-hidden--inline\">Regular price</span>\n            <span class=\"price-item price-item--regular\">\n              <span>", "</span>\n              <span>\n                <s class=\"price-item price-item--regular\"\n                  >", "\n                </s>\n              </span>\n            </span>\n          </div>\n          ", "\n        </div>\n      </div>\n    "])), isOnSale, this.helpers.displayPrice(hit).replace(/([.,])00$/, ''), this.helpers.displayStrikedPrice(marketPrice, marketCompareAtPrice).replace(/([.,])00$/, ''), isOnSale ? this.createSalePricePercentage(hit, html) : '');
    }

    /**
     * Calculates and displays the discount percentage.
     * Computes the percentage off between the original and current price.
     * @param {number} compareAtPrice - The original price of the product.
     * @param {number} price - The current price of the product.
     * @returns {string} - The discount percentage as a string.
     */
  }, {
    key: "displayDiscount",
    value: function displayDiscount(compareAtPrice, price) {
      var ratio = price / compareAtPrice;

      // Round the discount fraction to 4 decimal places to avoid floating point precision issues
      var discountFraction = Number((1 - ratio).toFixed(4));
      var discountPercentage = Math.round(100 * discountFraction);
      var roundedPercentage = discountPercentage < 1 ? Math.ceil(discountPercentage) : Math.floor(discountPercentage);
      var calculatedPercentage = Number(price) && Number(compareAtPrice) > Number(price) ? "".concat(roundedPercentage, "% off") : '';
      return calculatedPercentage;
    }

    /**
     * Creates the sale price percentage element.
     * Generates HTML for the sale discount percentage display.
     * @param {Object} hit - The product hit data.
     * @param {Function} html - The HTML template function.
     * @returns {TemplateResult} - The HTML template for the sale price percentage.
     */
  }, {
    key: "createSalePricePercentage",
    value: function createSalePricePercentage(hit, html) {
      var percentagePrice = this.displayDiscount(hit.compare_at_price, hit.price);
      return html(PriceHandler_templateObject2 || (PriceHandler_templateObject2 = PriceHandler_taggedTemplateLiteral(["\n      <div class=\"price__sale--discount\">\n        <span class=\"visually-hidden visually-hidden--inline\">Sale price</span>\n        <span class=\"price-item price-item--percentage\"> ", " </span>\n      </div>\n    "])), percentagePrice);
    }
  }]);
}();
/* harmony default export */ var utils_PriceHandler = (PriceHandler);
;// ./src/scripts/components/autocompleteProductTemplate.js
var autocompleteProductTemplate_templateObject, autocompleteProductTemplate_templateObject2;
function autocompleteProductTemplate_taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function autocompleteProductTemplate_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function autocompleteProductTemplate_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? autocompleteProductTemplate_ownKeys(Object(t), !0).forEach(function (r) { autocompleteProductTemplate_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : autocompleteProductTemplate_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function autocompleteProductTemplate_defineProperty(e, r, t) { return (r = autocompleteProductTemplate_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function autocompleteProductTemplate_typeof(o) { "@babel/helpers - typeof"; return autocompleteProductTemplate_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, autocompleteProductTemplate_typeof(o); }
function autocompleteProductTemplate_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function autocompleteProductTemplate_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, autocompleteProductTemplate_toPropertyKey(o.key), o); } }
function autocompleteProductTemplate_createClass(e, r, t) { return r && autocompleteProductTemplate_defineProperties(e.prototype, r), t && autocompleteProductTemplate_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function autocompleteProductTemplate_toPropertyKey(t) { var i = autocompleteProductTemplate_toPrimitive(t, "string"); return "symbol" == autocompleteProductTemplate_typeof(i) ? i : i + ""; }
function autocompleteProductTemplate_toPrimitive(t, r) { if ("object" != autocompleteProductTemplate_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != autocompleteProductTemplate_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * @fileoverview Handles the rendering of product templates for an Algolia-powered Shopify store search interface.
 * Manages template caching and product data transformation for efficient rendering.
 */




/**
 * Utility class providing helper methods for string manipulation and badge creation.
 */
var Utils = /*#__PURE__*/function () {
  function Utils() {
    autocompleteProductTemplate_classCallCheck(this, Utils);
  }
  return autocompleteProductTemplate_createClass(Utils, null, [{
    key: "classSafeProductType",
    value:
    /**
     * Converts a product type string to a class-safe format.
     * Replaces spaces with hyphens and converts to lowercase.
     * @param {string} productType - The product type string to convert.
     * @returns {string} - The class-safe product type string.
     */
    function classSafeProductType(productType) {
      return productType ? productType.toLowerCase().replace(/\s+/g, '-') : 'unknown-product-type';
    }

    /**
     * Creates a badge object based on a given prefix.
     * Extracts the badge information from the badges object using the prefix.
     * @param {Object} badges - An object containing badge information.
     * @param {string} prefix - The prefix to use when creating the badge object.
     * @returns {string} - The badge object corresponding to the prefix.
     */
  }, {
    key: "createBadgeObject",
    value: function createBadgeObject(badges, prefix) {
      return badges[prefix] || '';
    }

    /**
     * Checks if a product is a merch product.
     * @param {Object} item - The product item data.
     * @returns {boolean} - True if the product is a merch product, false otherwise.
     */
  }, {
    key: "isMerchProduct",
    value: function isMerchProduct(item) {
      return item.named_tags && item.named_tags.primary_collection && (item.named_tags.primary_collection.includes('Clothing & Apparel') || item.tags.includes('new_merch_product') || item.tags.includes('non_merged_merch_product'));
    }
  }]);
}();
/**
 * @class ProductTemplateRenderer
 * @description Manages the rendering of product templates with caching capabilities.
 * Handles the transformation of raw product data into formatted HTML templates.
 */
var ProductTemplateRenderer = /*#__PURE__*/function () {
  /**
   * @constructor
   * Initializes a new ProductTemplateRenderer with an empty template cache
   */
  function ProductTemplateRenderer() {
    autocompleteProductTemplate_classCallCheck(this, ProductTemplateRenderer);
    /**
     * @private
     * @type {Map<string, string>}
     */
    this.templateCache = new Map();
    this.possibleVendorParams = ['kramer', 'epiphone', 'mesa', 'gibson', 'mesa-boogie', 'mesa/boogie'];
    this.brandUrlParams = '';
    if (window.location.href.indexOf('?view=kramer') > -1 || document.body.dataset.brand === 'kramer') {
      this.brandUrlParams = '?view=kramer';
      var url = new URL(window.location.href);
      url.searchParams.set('view', 'kramer');
    } else if (window.location.href.indexOf('?view=epiphone') > -1 || document.body.dataset.brand === 'epiphone') {
      if (window.location.search.indexOf('view=') > -1) {
        this.brandUrlParams = '?view=epiphone';
        var _url = new URL(window.location.href);
        _url.searchParams.set('view', 'epiphone');
      }
    } else if (window.location.href.indexOf('?view=mesa') > -1 || document.body.dataset.brand === 'mesa') {
      this.brandUrlParams = '?view=mesa';
      var _url2 = new URL(window.location.href);
      _url2.searchParams.set('view', 'mesa');
    } else {
      this.brandUrlParams = '';
    }
  }

  /**
   * Processes and renders a product template before autocomplete display
   * @param {string} _defaultTemplate - The default template (unused)
   * @param {Object} templateOptions - Options for template rendering
   * @param {Function} templateOptions.html - HTML template literal tag function
   * @param {Object} templateOptions.item - Product item data
   * @param {boolean} distinct - Flag indicating if this is a distinct variant
   * @param {string} itemLink - URL link for the product
   * @param {Function} trackSearchAttribution - Function to track search attribution events
   * @returns {string} The processed HTML template string
   * @throws {Error} When product data is invalid
   */
  return autocompleteProductTemplate_createClass(ProductTemplateRenderer, [{
    key: "beforeAutocompleteProductTemplate",
    value: function beforeAutocompleteProductTemplate(_defaultTemplate, templateOptions, distinct, itemLink, trackSearchAttribution) {
      try {
        // Initialize helpers and price handler
        this.helpers = window.algoliaShopify.helpers;
        var priceHandler = new utils_PriceHandler(this.helpers);
        this.priceHandler = priceHandler;
        var html = templateOptions.html,
          item = templateOptions.item;
        var cacheKey = "".concat(item.objectID, "-").concat(distinct);

        // Return cached template if available
        if (this.templateCache.has(cacheKey)) {
          return this.templateCache.get(cacheKey);
        }
        var productData = this.extractProductData(item, distinct);
        if (!itemLink || typeof itemLink !== 'string') {
          console.warn('Invalid itemLink provided');
          return '';
        }

        // Generate and cache the template
        var template = this.generateTemplate(html, autocompleteProductTemplate_objectSpread(autocompleteProductTemplate_objectSpread({}, productData), {}, {
          itemLink: itemLink,
          item: item,
          distinct: distinct,
          trackSearchAttribution: trackSearchAttribution
        }), this.brandUrlParams);
        this.templateCache.set(cacheKey, template);
        return template;
      } catch (error) {
        console.error('Error in beforeAutocompleteProductTemplate:', error);
        return '';
      }
    }

    /**
     * Extracts and normalizes product data from an Algolia hit
     * @private
     * @param {Object} item - Raw product data from Algolia
     * @param {boolean} distinct - Flag indicating if this is a distinct variant
     * @returns {Object} Normalized product data object
     * @throws {Error} If item data is invalid
     */
  }, {
    key: "extractProductData",
    value: function extractProductData(item, distinct) {
      if (!item || autocompleteProductTemplate_typeof(item) !== 'object') {
        throw new Error('Invalid item data');
      }
      if (item.image && item.image.includes('Serial') && item.image.includes('Listed') || item.image.includes('Unlisted') || item.image.includes('Sold') || item.image.includes('Serial') && item.image.includes('Thumbnail')) {
        item.image = item.product_image;
      }
      // Extract and process image and variant information
      var imageSrc = this.helpers.largeImage(item) || '';
      var variantAddition = this.helpers.variantTitleAddition(item, distinct) || '';
      var isOnSale = item.compare_at_price && item.compare_at_price > item.price ? 1 : 0;
      var productPrice = this.helpers.displayPrice(item, distinct) || '';
      var compareAtPrice = this.helpers.displayStrikedPrice(item, distinct) || '';
      return {
        imageSrc: imageSrc,
        productTitle: item.title || 'No Title',
        variantAddition: variantAddition,
        productHandle: item.handle || '',
        productId: item.objectID || '',
        variantId: item.variant_id || '',
        isOnSale: isOnSale,
        productPrice: productPrice,
        compareAtPrice: compareAtPrice
      };
    }

    /**
     * Generates the HTML template for a product card
     * @private
     * @param {Function} html - HTML template literal tag function
     * @param {Object} data - Processed product data
     * @param {string} data.imageSrc - URL of the product image
     * @param {string} data.productTitle - Product title
     * @param {string} data.variantAddition - Additional variant information
     * @param {string} data.productHandle - Product handle/slug
     * @param {string} data.productId - Product ID
     * @param {string} data.variantId - Variant ID
     * @param {string} data.itemLink - Product URL
     * @param {Object} data.item - Original product data
     * @param {boolean} data.distinct - Distinct variant flag
     * @param {number} data.isOnSale - Sale status (0 or 1)
     * @param {string} data.productPrice - Formatted product price
     * @param {string} data.compareAtPrice - Formatted compare-at price
     * @returns {string} Complete HTML template for the product card
     */
  }, {
    key: "generateTemplate",
    value: function generateTemplate(html, data, brandUrlParams) {
      var _item$meta, _item$meta2;
      var imageSrc = data.imageSrc,
        productTitle = data.productTitle,
        variantAddition = data.variantAddition,
        productHandle = data.productHandle,
        productId = data.productId,
        variantId = data.variantId,
        itemLink = data.itemLink,
        item = data.item,
        distinct = data.distinct,
        isOnSale = data.isOnSale,
        productPrice = data.productPrice,
        compareAtPrice = data.compareAtPrice,
        trackSearchAttribution = data.trackSearchAttribution;
      var newItemLink = itemLink;
      if (brandUrlParams === '' && item.vendor !== undefined && !item.vendor.toLowerCase().includes('gibson')) {
        if (this.possibleVendorParams.includes(item.vendor.toLowerCase())) {
          brandUrlParams = "?view=".concat(item.vendor.toLowerCase());
          // this.brandUrlParams = brandUrlParams;

          if (itemLink.includes('?view=')) {
            newItemLink = itemLink.replace('?view=', brandUrlParams);
          } else {
            newItemLink = "".concat(itemLink).concat(brandUrlParams);
          }
        }
      }

      // Generate product type-specific CSS class
      var productTypeClass = item.product_type ? "card-type--".concat(item.product_type) : '';

      // Create image element with responsive attributes
      var imageElement = html(autocompleteProductTemplate_templateObject || (autocompleteProductTemplate_templateObject = autocompleteProductTemplate_taggedTemplateLiteral(["\n      <img\n        srcset=\"\"\n        src=\"", "\"\n        sizes=\"(min-width: 1440px) 327px, (min-width: 990px) calc((100vw - 130px) / 4), (min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)\"\n        alt=\"", "\"\n        class=\"motion-reduce\"\n        loading=\"lazy\"\n        width=\"256\"\n        height=\"256\"\n      />\n    "])), imageSrc, productTitle);

      // Generate price element using price handler
      var priceElement = this.priceHandler.createPriceElement(item, html);
      var isSoldOut = this.determineSoldOutStatus(item);
      var hasNoBodyImage = item.tags && item.tags.includes('no_body_image_shot');

      // Return complete product card template
      return html(autocompleteProductTemplate_templateObject2 || (autocompleteProductTemplate_templateObject2 = autocompleteProductTemplate_taggedTemplateLiteral(["\n      <div\n        class=\"card-wrapper alt-card-wrapper product-card-wrapper algolia-search-card ", "\"\n        id=\"Card--", "\"\n        data-algolia-index=\"", "\"\n        data-algolia-position=\"", "\"\n        data-algolia-queryid=\"", "\"\n        data-algolia-objectid=\"", "\"\n        data-handle=\"", "\"\n        data-variant-id=\"", "\"\n        data-distinct=\"", "\"\n        data-product-id=\"", "\"\n      >\n        <div class=\"card card--standard alt-card card--media\" style=\"--ratio-percent: 100.0%;\">\n          <div class=\"card__inner alt-card__inner color-scheme-1 ratio\" style=\"--ratio-percent: 100.0%;\">\n            <a \n              href=\"", "\" \n              class=\"full-unstyled-link w-full\" \n              onClick=\"", "\"\n            >\n              <div class=\"card__media alt-card__media\">\n                <div class=\"media media--transparent media--hover-effect ", "\">\n                  <div\n                    id=\"media-template--", "\"\n                    class=\"media media--transparent\"\n                    role=\"group\"\n                    data-main-media-id=\"", "\"\n                    aria-labelledby=\"title-template--", "\"\n                  >\n                    ", "\n                  </div>\n                </div>\n              </div>\n            </a>\n          </div>\n          <div class=\"card__content alt-card__content\">\n            <div class=\"card__thumbnails\"></div>\n            <div class=\"card__information alt-card__information\">\n              <h3 class=\"card__heading h5\" id=\"title-template--", "\">\n                <a\n                  href=\"", "\"\n                  id=\"CardLink-template--", "\"\n                  class=\"full-unstyled-link\"\n                  aria-labelledby=\"CardLink-template--", "\"\n                  onClick=\"", "\"\n                >\n                  ", "\n                  <span class=\"vendor-name\">", "</span>\n                  <span class=\"meta-finish-name\">", "</span>\n                  <span class=\"algolia-variant\">", "</span>\n                </a>\n              </h3>\n              <div class=\"card-information\">\n                ", "\n                <div class=\"alt-card-is-serialized alt-card--oos\">\n                  <div class=\"alt-card-is-serialized__item alt-card--oos__item ", "\">\n                    <p class=\"alt-card-is-serialized__caption alt-card--oos__caption\">\n                      ", "\n                    </p>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    "])), productTypeClass, productId, item.__indexName || '', item.__position || '', item.__queryID || '', item.objectID || '', productHandle, variantId, distinct, productId, newItemLink, function () {
        return trackSearchAttribution(item);
      }, hasNoBodyImage ? 'no-body-image' : '', productId, variantId, productId, imageElement, productId, newItemLink, productId, productId, function () {
        return trackSearchAttribution(item);
      }, Utils.isMerchProduct(item) || item.tags && item.tags.includes('gibsonxcollab') ? productTitle : productTitle.replace(new RegExp("^".concat(item.vendor, "\\s*")), '').replace(", ".concat(item === null || item === void 0 || (_item$meta = item.meta) === null || _item$meta === void 0 || (_item$meta = _item$meta.finish) === null || _item$meta === void 0 ? void 0 : _item$meta.name), ''), item.vendor, item === null || item === void 0 || (_item$meta2 = item.meta) === null || _item$meta2 === void 0 || (_item$meta2 = _item$meta2.finish) === null || _item$meta2 === void 0 ? void 0 : _item$meta2.name, variantAddition, priceElement, isSoldOut ? '' : 'hidden', languageStrings.outOfStock);
    }

    /**
     * Determines if a product is sold out based on inventory and market-specific warehouse data.
     * @private
     * @param {Object} hit - Algolia product hit data
     * @returns {boolean} True if the product is sold out
     */
  }, {
    key: "determineSoldOutStatus",
    value: function determineSoldOutStatus(hit) {
      var isSoldOut = (hit.inventory_available === false || hit.inventory_quantity === 0) && hit.variants_inventory_count <= 0;
      if (hit.named_tags && hit.named_tags['out-of-stock']) {
        var outOfStockTags = Array.isArray(hit.named_tags['out-of-stock']) ? hit.named_tags['out-of-stock'] : [hit.named_tags['out-of-stock']];
        var marketHandle = window.Shopify.market_handle;
        var marketTagValue = ' ' + marketHandle.replace(/-/g, '_');
        if (outOfStockTags.includes(marketTagValue)) {
          return true;
        }
      }
      var gOpsAvailable = true;
      var gOpsEpiAvailable = true;
      var mainFreightAvailable = true;
      var hasGarageNashville = true;
      var hasGarageLondon = true;
      if (hit.named_tags && hit.named_tags['inventory-unavailable']) {
        var inventoryUnavailableTags = Array.isArray(hit.named_tags['inventory-unavailable']) ? hit.named_tags['inventory-unavailable'] : [hit.named_tags['inventory-unavailable']];
        inventoryUnavailableTags.forEach(function (tag) {
          if (tag === ' g-ops') {
            gOpsAvailable = false;
          } else if (tag === ' g-ops-epi') {
            gOpsEpiAvailable = false;
          } else if (tag === ' mainfreight') {
            mainFreightAvailable = false;
          } else if (tag === ' nashville') {
            hasGarageNashville = false;
          } else if (tag === ' london') {
            hasGarageLondon = false;
          }
        });
      }
      if (window.Shopify.market_handle === 'us') {
        var usWarehouseAvailable = gOpsAvailable || gOpsEpiAvailable;
        var garageAvailable = hasGarageNashville;
        if (!usWarehouseAvailable && !garageAvailable) {
          isSoldOut = true;
        }
      } else if (window.Shopify.market_handle === 'europe' || window.Shopify.market_handle === 'united-kingdom') {
        var euWarehouseAvailable = mainFreightAvailable;
        var _garageAvailable = hasGarageLondon;
        if (!euWarehouseAvailable && !_garageAvailable) {
          isSoldOut = true;
        }
      }
      return isSoldOut;
    }

    /**
     * Clears the template cache
     * @public
     */
  }, {
    key: "clearTemplateCache",
    value: function clearTemplateCache() {
      this.templateCache.clear();
    }
  }]);
}();
/* harmony default export */ var autocompleteProductTemplate = (ProductTemplateRenderer);
;// ./src/scripts/utils/algoliaRedirectUrl.js
// Algolia redirect rules return URLs without the Shopify market/language prefix.
// Prepend Shopify.routes.root for absolute paths; leave anything else untouched.
function prefixAlgoliaRedirectUrl(url) {
  var _window$Shopify;
  if (!url || typeof url !== 'string') return url;
  if (!url.startsWith('/') || url.startsWith('//')) return url;
  var root = ((_window$Shopify = window.Shopify) === null || _window$Shopify === void 0 || (_window$Shopify = _window$Shopify.routes) === null || _window$Shopify === void 0 ? void 0 : _window$Shopify.root) || '/';
  if (root === '/' || url.startsWith(root)) return url;
  return "".concat(root).concat(url.slice(1));
}
;// ./src/scripts/services/autocomplete-hooks.js
var autocomplete_hooks_templateObject, autocomplete_hooks_templateObject2, autocomplete_hooks_templateObject3, autocomplete_hooks_templateObject4, _templateObject5;
function autocomplete_hooks_typeof(o) { "@babel/helpers - typeof"; return autocomplete_hooks_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, autocomplete_hooks_typeof(o); }
function autocomplete_hooks_taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function autocomplete_hooks_toConsumableArray(r) { return autocomplete_hooks_arrayWithoutHoles(r) || autocomplete_hooks_iterableToArray(r) || autocomplete_hooks_unsupportedIterableToArray(r) || autocomplete_hooks_nonIterableSpread(); }
function autocomplete_hooks_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function autocomplete_hooks_unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return autocomplete_hooks_arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? autocomplete_hooks_arrayLikeToArray(r, a) : void 0; } }
function autocomplete_hooks_iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function autocomplete_hooks_arrayWithoutHoles(r) { if (Array.isArray(r)) return autocomplete_hooks_arrayLikeToArray(r); }
function autocomplete_hooks_arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function autocomplete_hooks_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function autocomplete_hooks_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? autocomplete_hooks_ownKeys(Object(t), !0).forEach(function (r) { autocomplete_hooks_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : autocomplete_hooks_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function autocomplete_hooks_defineProperty(e, r, t) { return (r = autocomplete_hooks_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function autocomplete_hooks_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function autocomplete_hooks_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, autocomplete_hooks_toPropertyKey(o.key), o); } }
function autocomplete_hooks_createClass(e, r, t) { return r && autocomplete_hooks_defineProperties(e.prototype, r), t && autocomplete_hooks_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function autocomplete_hooks_toPropertyKey(t) { var i = autocomplete_hooks_toPrimitive(t, "string"); return "symbol" == autocomplete_hooks_typeof(i) ? i : i + ""; }
function autocomplete_hooks_toPrimitive(t, r) { if ("object" != autocomplete_hooks_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != autocomplete_hooks_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }






var autocompleteState = store.getState();
var optionCopy = {};

/**
 * @class HooksInitializer
 * @description Manages the initialization and lifecycle of Algolia Shopify autocomplete hooks.
 * Handles product templates, suggestions, and various autocomplete customizations.
 */
var HooksInitializer = /*#__PURE__*/function () {
  /**
   * @constructor
   * @param {Object} config - Configuration object for the hooks initializer
   */
  function HooksInitializer(config) {
    autocomplete_hooks_classCallCheck(this, HooksInitializer);
    this.config = config;

    // Initialize core components
    this.renderer = new autocompleteProductTemplate();
    this.autocompleteOptionsHandler = new autocompleteOptionsHandler(this.config, this);
    this.optionCopy = {};

    // WeakMap to cache templates for performance optimization
    this.templateCache = new WeakMap();

    // Array to track registered hooks for cleanup
    this.hooks = [];
    this.initializeHooks();
  }
  return autocomplete_hooks_createClass(HooksInitializer, [{
    key: "beforeAutocompleteFiltersString",
    value: function beforeAutocompleteFiltersString(_defaultFilter) {
      var _newFilter = _defaultFilter;

      // Apply market suppression filter
      var country = window.Shopify.country;
      var locale = window.Shopify.country.toLowerCase();
      if (locale === 'us' || locale === 'united-states') {
        locale = 'en';
      } else if (locale === 'uk' || locale === 'united-kingdom' || locale === 'gb') {
        locale = 'en';
      } else if (locale === 'ie' || locale === 'ireland' || locale === 'ir') {
        locale = 'en';
      }
      var filterString = "".concat(locale, "-").concat(country);
      var alternateString = "en-".concat(country);
      var inheritNLMarketSuppression = window.Shopify.market_handle === 'europe' && (window.Shopify.country != 'IE' || window.Shopify.country != 'ir') && (window.Shopify.country != 'FR' || window.Shopify.country != 'DE' || window.Shopify.country != 'ES' || window.Shopify.country != 'IT');
      if (_newFilter) {
        _newFilter = _newFilter + " AND NOT meta.custom.market_suppression:\"".concat(filterString, "\" AND NOT meta.custom.market_suppression:\"").concat(alternateString, "\" ").concat(inheritNLMarketSuppression ? 'AND NOT meta.custom.market_suppression:"nl-NL"' : '');
      } else {
        _newFilter = "NOT meta.custom.market_suppression:\"".concat(filterString, "\" AND NOT meta.custom.market_suppression:\"").concat(alternateString, "\" ").concat(inheritNLMarketSuppression ? 'AND NOT meta.custom.market_suppression:"nl-NL"' : '');
      }

      // Apply alternate brand filter if applicable
      if (window.Shopify.alternateBrand && window.Shopify.alternateBrand.isAlternateBrand) {
        if (window.Shopify.alternateBrand.brand.includes('mesa')) {
          _newFilter = "(".concat(_newFilter, ") AND vendor:Mesa/Boogie");
        } else {
          _newFilter = "(".concat(_newFilter, ") AND vendor:").concat(window.Shopify.alternateBrand.brand);
        }
      } else {
        _newFilter = "(".concat(_newFilter, ")");
      }
      return _newFilter;
    }

    /**
     * @private
     * @description Initializes all autocomplete hooks and binds them to their respective handlers
     */
  }, {
    key: "initializeHooks",
    value: function initializeHooks() {
      try {
        try {
          this.registerHook('beforeAutocompleteProductTransformResponseHits', this.beforeProductTransformResponseHits.bind(this));
        } catch (error) {
          console.error('Error in beforeAutocompleteProductTransformResponseHits:', error);
        }
        try {
          this.registerHook('beforeAutocompleteOptions', this.beforeAutocompleteOptions.bind(this));
        } catch (error) {
          console.error('Error in beforeAutocompleteOptions:', error);
        }
        try {
          this.registerHook('beforeAutocompleteProductTemplate', this.beforeAutocompleteProductTemplate.bind(this));
        } catch (error) {
          console.error('Error in beforeAutocompleteProductTemplate:', error);
        }

        // Bind template cache clearing to renderer
        this.clearCache = this.renderer.clearTemplateCache.bind(this.renderer);
        try {
          this.registerHook('beforeAutocompleteSuggestionsTemplate', this.beforeAutocompleteSuggestionsTemplate.bind(this));
        } catch (error) {
          console.error('Error in beforeAutocompleteSuggestionsTemplate:', error);
        }
        try {
          this.registerHook('beforeAutocompleteFooterTemplate', this.beforeAutocompleteFooterTemplate.bind(this));
        } catch (error) {
          console.error('Error in beforeAutocompleteFooterTemplate:', error);
        }
        try {
          this.registerHook('beforeAutocompleteMainTemplate', this.beforeAutocompleteMainTemplate.bind(this));
        } catch (error) {
          console.error('Error in beforeAutocompleteMainTemplate:', error);
        }
        try {
          this.registerHook('beforeAutocompleteMainProductsTemplate', this.beforeAutocompleteMainProductsTemplate.bind(this));
        } catch (error) {
          console.error('Error in beforeAutocompleteMainProductsTemplate:', error);
        }
        try {
          this.registerHook('beforeAutocompleteFiltersString', this.beforeAutocompleteFiltersString.bind(this));
        } catch (error) {
          console.error('Error in beforeAutocompleteFiltersString:', error);
        }
        try {
          this.registerHook('beforeAutocompleteRedirectUrlOptions', this.beforeAutocompleteRedirectUrlOptions.bind(this));
        } catch (error) {
          console.error('Error in beforeAutocompleteRedirectUrlOptions:', error);
        }
      } catch (error) {
        console.error('Error initializing hooks:', error);
      }
    }

    // Algolia redirect rules return URLs without the Shopify market/language prefix.
    // This hook customizes createRedirectUrlPlugin's onRedirect so the prefix is applied
    // before the plugin navigates on submit (Enter) or selection.
  }, {
    key: "beforeAutocompleteRedirectUrlOptions",
    value: function beforeAutocompleteRedirectUrlOptions(options) {
      return autocomplete_hooks_objectSpread(autocomplete_hooks_objectSpread({}, options), {}, {
        onRedirect: function onRedirect(redirects, _ref) {
          var _item$urls;
          var event = _ref.event,
            navigator = _ref.navigator,
            state = _ref.state;
          var item = redirects === null || redirects === void 0 ? void 0 : redirects[0];
          var itemUrl = item === null || item === void 0 || (_item$urls = item.urls) === null || _item$urls === void 0 ? void 0 : _item$urls[0];
          if (!itemUrl) return;
          var url = prefixAlgoliaRedirectUrl(itemUrl);
          if (event.metaKey || event.ctrlKey) {
            navigator.navigateNewTab({
              itemUrl: url,
              item: item,
              state: state
            });
          } else if (event.shiftKey) {
            navigator.navigateNewWindow({
              itemUrl: url,
              item: item,
              state: state
            });
          } else {
            navigator.navigate({
              itemUrl: url,
              item: item,
              state: state
            });
          }
        }
      });
    }

    /**
     * @private
     * @param {string} hookName - Name of the hook to register
     * @param {Function} method - Method to be called when the hook is triggered
     */
  }, {
    key: "registerHook",
    value: function registerHook(hookName, method) {
      algoliaShopify.hooks.registerHook(hookName, method);
      this.hooks.push({
        hookName: hookName,
        method: method
      });
    }

    /**
     * @public
     * @description Unregisters all hooks and cleans up resources
     */
  }, {
    key: "unregisterHooks",
    value: function unregisterHooks() {
      this.hooks.forEach(function (_ref2) {
        var hookName = _ref2.hookName,
          method = _ref2.method;
        algoliaShopify.hooks.unregisterHook(hookName, method);
      });
      this.hooks = [];
    }

    /**
     * @private
     * @param {Array} hits - Array of search result hits
     * @param {Object} results - Search results object
     * @returns {Array} Transformed hits array
     */
  }, {
    key: "beforeProductTransformResponseHits",
    value: function beforeProductTransformResponseHits(hits, results) {
      try {
        var timestamp = new Date().toISOString();
        var renderingContent = results[0].renderingContent;
        this.setupSearchSuggestionEventListeners();
        return hits;
      } catch (error) {
        console.error('Error in beforeProductTransformResponseHits:', error);
        return [];
      }
    }
  }, {
    key: "setupSearchSuggestionEventListeners",
    value: function setupSearchSuggestionEventListeners() {
      setTimeout(function () {
        var searchSuggestions = document.querySelectorAll('[js-search-suggestion]');
        autocomplete_hooks_toConsumableArray(searchSuggestions).forEach(function (suggestion) {
          suggestion.addEventListener('click', function (e) {
            e.preventDefault();
          });
        });
      }, 1000);
    }
    /**
     * @private
     * @param {Object} options - Original autocomplete options
     * @returns {Object} Modified autocomplete options
     */
  }, {
    key: "beforeAutocompleteOptions",
    value: function beforeAutocompleteOptions(options) {
      try {
        // Set default translation for "all products" text
        window.algoliaShopify.translations.allProducts = languageStrings.viewAllResults;
        var timestamp = new Date().toISOString();

        // Process options through the handler
        var newOptions = this.autocompleteOptionsHandler.beforeAutocompleteOptions(options);
        this.optionCopy = autocomplete_hooks_objectSpread({}, newOptions);
        return newOptions;
      } catch (error) {
        console.error('Error in beforeAutocompleteOptions:', error);
        return options;
      }
    }

    /**
     * @private
     * @param {Function} defaultTemplate - Default template function
     * @param {Object} templateOptions - Options for template customization
     * @param {boolean} distinct - Whether to use distinct results
     * @param {string} itemLink - Link for the item
     * @returns {Function} Customized template function
     */
  }, {
    key: "beforeAutocompleteProductTemplate",
    value: function beforeAutocompleteProductTemplate(defaultTemplate, templateOptions, distinct, itemLink) {
      try {
        // Check cache for existing template
        if (this.templateCache.has(defaultTemplate)) {
          return this.templateCache.get(defaultTemplate);
        }

        // Generate new template and cache it
        var template = this.renderer.beforeAutocompleteProductTemplate(defaultTemplate, templateOptions, distinct, itemLink);
        this.templateCache.set(defaultTemplate, template);
        return template;
      } catch (error) {
        console.error('Error in beforeAutocompleteProductTemplate:', error);
        return defaultTemplate;
      }
    }

    /**
     * @private
     * @param {Function} _defaultTemplate - Default suggestions template
     * @param {Object} templateOptions - Template customization options
     * @param {Object} templateOptions.html - HTML template literal function
     * @param {Object} templateOptions.item - Suggestion item data
     * @param {Object} templateOptions.components - Component utilities
     * @returns {Function} Customized suggestions template
     */
  }, {
    key: "beforeAutocompleteSuggestionsTemplate",
    value: function beforeAutocompleteSuggestionsTemplate(_defaultTemplate, templateOptions) {
      try {
        var html = templateOptions.html,
          item = templateOptions.item,
          components = templateOptions.components;
        return html(autocomplete_hooks_templateObject || (autocomplete_hooks_templateObject = autocomplete_hooks_taggedTemplateLiteral(["\n        <a class=\"aa-ItemLink aa-ItemWrapper\" href=\"", "search?q=", "\">\n          <div class=\"aa-ItemContent\">\n            <div class=\"aa-ItemIcon aa-ItemIcon--noBorder\">\n              <svg viewBox=\"0 0 24 24\" fill=\"currentColor\">\n                <path\n                  d=\"M16.041 15.856c-0.034 0.026-0.067 0.055-0.099 0.087s-0.060 0.064-0.087 0.099c-1.258 1.213-2.969 1.958-4.855 1.958-1.933 0-3.682-0.782-4.95-2.050s-2.050-3.017-2.050-4.95 0.782-3.682 2.050-4.95 3.017-2.050 4.95-2.050 3.682 0.782 4.95 2.050 2.050 3.017 2.050 4.95c0 1.886-0.745 3.597-1.959 4.856zM21.707 20.293l-3.675-3.675c1.231-1.54 1.968-3.493 1.968-5.618 0-2.485-1.008-4.736-2.636-6.364s-3.879-2.636-6.364-2.636-4.736 1.008-6.364 2.636-2.636 3.879-2.636 6.364 1.008 4.736 2.636 6.364 3.879 2.636 6.364 2.636c2.125 0 4.078-0.737 5.618-1.968l3.675 3.675c0.391 0.391 1.024 0.391 1.414 0s0.391-1.024 0-1.414z\"\n                />\n              </svg>\n            </div>\n            <div class=\"aa-ItemContentBody\">\n              <div class=\"aa-ItemContentTitle\">", "</div>\n            </div>\n          </div>\n          <div class=\"aa-ItemActions\">\n            <button class=\"aa-ItemActionButton\" title=\"Fill query with ", "\">\n              <svg viewBox=\"0 0 24 24\" fill=\"currentColor\">\n                <path\n                  d=\"M8 17v-7.586l8.293 8.293c0.391 0.391 1.024 0.391 1.414 0s0.391-1.024 0-1.414l-8.293-8.293h7.586c0.552 0 1-0.448 1-1s-0.448-1-1-1h-10c-0.552 0-1 0.448-1 1v10c0 0.552 0.448 1 1 1s1-0.448 1-1z\"\n                />\n              </svg>\n            </button>\n          </div>\n        </a>\n      "])), window.Shopify.routes.root, item.query, components.Highlight({
          hit: item,
          attribute: 'query'
        }), item.query);
      } catch (error) {
        console.error('Error in beforeAutocompleteSuggestionsTemplate:', error);
        return _defaultTemplate;
      }
    }

    /**
     * @private
     * @param {Function} _defaultTemplate - Default footer template
     * @param {Object} templateOptions - Template customization options
     * @param {Object} templateOptions.html - HTML template literal function
     * @param {Object} templateOptions.state - Current state of the autocomplete
     * @returns {Function} Customized footer template
     */
  }, {
    key: "beforeAutocompleteFooterTemplate",
    value: function beforeAutocompleteFooterTemplate(_defaultTemplate, templateOptions) {
      try {
        var _state$context, _state$context2, _state$context3;
        var html = templateOptions.html,
          state = templateOptions.state;
        var brandView = document.body.dataset.brand;
        var gibsonPreselected = window.Shopify.gibson_brand_preselected;
        var capitalisedBrand = window.Shopify.alternateBrand && window.Shopify.alternateBrand.isAlternateBrand ? window.Shopify.alternateBrand.brand.charAt(0).toUpperCase() + window.Shopify.alternateBrand.brand.slice(1) : '';
        var baseParams = {
          q: state.query
        };
        var queryString = new URLSearchParams(baseParams).toString();
        // Add refinement list parameter if needed
        if (gibsonPreselected && brandView === 'gibson') {
          capitalisedBrand = 'Gibson';
        }
        if (brandView === 'mesa') {
          capitalisedBrand = 'Mesa/Boogie';
        }
        // Add refinement list parameter if needed
        if (window.Shopify.alternateBrand && window.Shopify.alternateBrand.isAlternateBrand || gibsonPreselected && brandView === 'gibson') {
          if (gibsonPreselected && brandView === 'gibson') {
            queryString += "&refinementList[vendor][0]=Gibson&refinementList[vendor][1]=Gibson Custom";
          } else {
            queryString += "&refinementList[vendor][0]=".concat(encodeURIComponent(capitalisedBrand));
          }
        }

        // Add view parameter if needed
        if (brandView) {
          queryString += "&view=".concat(brandView);
        }
        var urlToRedirect = "".concat(window.Shopify.routes.root, "search?").concat(queryString);
        if ((_state$context = state.context) !== null && _state$context !== void 0 && _state$context.redirectUrlPlugin && (_state$context2 = state.context) !== null && _state$context2 !== void 0 && (_state$context2 = _state$context2.redirectUrlPlugin) !== null && _state$context2 !== void 0 && _state$context2.data && ((_state$context3 = state.context) === null || _state$context3 === void 0 || (_state$context3 = _state$context3.redirectUrlPlugin) === null || _state$context3 === void 0 ? void 0 : _state$context3.data.length) > 0) {
          var _state$context4;
          var algoliaRedirectUrl = (_state$context4 = state.context) === null || _state$context4 === void 0 || (_state$context4 = _state$context4.redirectUrlPlugin) === null || _state$context4 === void 0 || (_state$context4 = _state$context4.data[0]) === null || _state$context4 === void 0 ? void 0 : _state$context4.urls[0];
          urlToRedirect = prefixAlgoliaRedirectUrl(algoliaRedirectUrl);
        }
        return html(autocomplete_hooks_templateObject2 || (autocomplete_hooks_templateObject2 = autocomplete_hooks_taggedTemplateLiteral(["\n        <div class=\"aa-footer\">\n          <a class=\"button button--secondary aa-SeeAllBtn\" href=\"", "\">\n            ", "\n          </a>\n        </div>\n      "])), urlToRedirect, window.algoliaShopify.translations.allProducts);
      } catch (error) {
        console.error('Error in beforeAutocompleteFooterTemplate:', error);
        return _defaultTemplate;
      }
    }
  }, {
    key: "beforeAutocompleteMainProductsTemplate",
    value: function beforeAutocompleteMainProductsTemplate(_defaultTemplate, templateOptions, elements) {
      var html = templateOptions.html;
      return html(autocomplete_hooks_templateObject3 || (autocomplete_hooks_templateObject3 = autocomplete_hooks_taggedTemplateLiteral(["\n      <div class=\"aa-PanelLayout aa-Panel--scrollable\">\n        <div class=\"aa-PanelSection\">", "</div>\n      </div>\n    "])), elements.products);
    }

    /**
     * @private
     * @param {Function} _defaultTemplate - Default main template
     * @param {Object} templateOptions - Template customization options
     * @param {Object} elements - Object containing various template elements
     * @param {boolean} displaySuggestions - Whether to display suggestions section
     * @returns {Function} Customized main template
     */
  }, {
    key: "beforeAutocompleteMainTemplate",
    value: function beforeAutocompleteMainTemplate(_defaultTemplate, templateOptions, elements, displaySuggestions) {
      try {
        var html = templateOptions.html;
        var leftSection = [];

        // Add suggestions section if enabled
        if (displaySuggestions) {
          leftSection.push(html(autocomplete_hooks_templateObject4 || (autocomplete_hooks_templateObject4 = autocomplete_hooks_taggedTemplateLiteral(["\n          <div class=\"aa-SourceHeader\">\n            <span class=\"aa-SourceHeaderTitle\"> ", " </span>\n            <div class=\"aa-SourceHeaderLine\"></div>\n          </div>\n          ", "\n        "])), algoliaShopify.translations.suggestions, elements.querySuggestionsPlugin));
        }

        // Add additional elements to left section
        [elements.collections, elements.articles, elements.pages, elements.redirectUrlPlugin].forEach(function (element) {
          if (element) leftSection.push(element);
        });

        // Return complete template with left and right sections
        return html(_templateObject5 || (_templateObject5 = autocomplete_hooks_taggedTemplateLiteral(["\n        <div class=\"aa-PanelLayout aa-Panel--scrollable\">\n          <div class=\"aa-PanelSections\">\n            <div class=\"aa-PanelSection--left\">", "</div>\n            <div class=\"aa-PanelSection--right\">", "</div>\n          </div>\n        </div>\n      "])), leftSection, elements.products);
      } catch (error) {
        console.error('Error in beforeAutocompleteMainTemplate:', error);
        return _defaultTemplate;
      }
    }
  }]);
}();
/* harmony default export */ var autocomplete_hooks = (HooksInitializer);
;// ./src/scripts/services/base-autocomplete-handler.js
function base_autocomplete_handler_typeof(o) { "@babel/helpers - typeof"; return base_autocomplete_handler_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, base_autocomplete_handler_typeof(o); }
function base_autocomplete_handler_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function base_autocomplete_handler_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, base_autocomplete_handler_toPropertyKey(o.key), o); } }
function base_autocomplete_handler_createClass(e, r, t) { return r && base_autocomplete_handler_defineProperties(e.prototype, r), t && base_autocomplete_handler_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function base_autocomplete_handler_toPropertyKey(t) { var i = base_autocomplete_handler_toPrimitive(t, "string"); return "symbol" == base_autocomplete_handler_typeof(i) ? i : i + ""; }
function base_autocomplete_handler_toPrimitive(t, r) { if ("object" != base_autocomplete_handler_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != base_autocomplete_handler_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * @class BaseAutocompleteHandler
 * @description Base class for autocomplete functionality that provides core properties and methods
 * used by various autocomplete implementations. Handles configuration management and
 * maintains the basic state of the autocomplete interface.
 */
var BaseAutocompleteHandler = /*#__PURE__*/function () {
  /**
   * @constructor
   * @param {Object} [config] - Configuration object for the autocomplete handler
   * @param {Object} [config.options] - Initial options for autocomplete behavior
   */
  function BaseAutocompleteHandler(config) {
    base_autocomplete_handler_classCallCheck(this, BaseAutocompleteHandler);
    /**
     * @type {Object}
     * @protected
     * @description Configuration settings for the autocomplete handler
     */
    this.config = config;

    /**
     * @type {function|null}
     * @private
     * @description Internal storage for query setter function
     */
    this._query = null;

    /**
     * @type {function|null}
     * @private
     * @description Internal storage for isOpen setter function
     */
    this._isOpen = null;
  }

  /**
   * @method setOptions
   * @description Sets the options for the autocomplete handler, creating a copy to prevent mutation
   * @param {Object} options - Options object to be stored
   * @public
   */
  return base_autocomplete_handler_createClass(BaseAutocompleteHandler, [{
    key: "setOptions",
    value: function setOptions(options) {
      /**
       * @type {Object}
       * @protected
       * @description Copy of the options object to prevent direct mutation of the original
       */
      this.optionCopy = options;
    }

    /**
     * @method query
     * @description Setter for the query state
     * @param {function} value - Function to set the current query
     */
  }, {
    key: "query",
    get:
    /**
     * @method query
     * @description Getter for the query state
     * @returns {function|null} Current query setter function
     */
    function get() {
      return this._query;
    }

    /**
     * @method isOpen
     * @description Setter for the open state of the autocomplete interface
     * @param {function} value - Function to set the open state
     */,
    set: function set(value) {
      this._query = value;
    }
  }, {
    key: "isOpen",
    get:
    /**
     * @method isOpen
     * @description Getter for the open state of the autocomplete interface
     * @returns {function|null} Current isOpen setter function
     */
    function get() {
      return this._isOpen;
    },
    set: function set(value) {
      this._isOpen = value;
    }
  }]);
}();
;// ./src/scripts/components/autocompleteSearchHandler.js
function autocompleteSearchHandler_typeof(o) { "@babel/helpers - typeof"; return autocompleteSearchHandler_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, autocompleteSearchHandler_typeof(o); }
function autocompleteSearchHandler_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function autocompleteSearchHandler_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, autocompleteSearchHandler_toPropertyKey(o.key), o); } }
function autocompleteSearchHandler_createClass(e, r, t) { return r && autocompleteSearchHandler_defineProperties(e.prototype, r), t && autocompleteSearchHandler_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function autocompleteSearchHandler_toPropertyKey(t) { var i = autocompleteSearchHandler_toPrimitive(t, "string"); return "symbol" == autocompleteSearchHandler_typeof(i) ? i : i + ""; }
function autocompleteSearchHandler_toPrimitive(t, r) { if ("object" != autocompleteSearchHandler_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != autocompleteSearchHandler_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == autocompleteSearchHandler_typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }



var autocompleteSearchHandler_autocompleteState = store.getState();
store.subscribe(function () {
  autocompleteSearchHandler_autocompleteState = store.getState();
});

/**
 * @class SearchHandler
 * @extends BaseAutocompleteHandler
 * @description Handles search functionality with autocomplete features using Algolia's autocomplete library.
 * Manages the search modal, input interactions, and responsive submit button displays.
 */
var SearchHandler = /*#__PURE__*/function (_BaseAutocompleteHand) {
  /**
   * @constructor
   * @param {Object} config - Configuration object for the SearchHandler
   * @param {HooksInitializer} config.hooksInitializer - Initializer containing option configurations
   */
  function SearchHandler(config) {
    var _this;
    autocompleteSearchHandler_classCallCheck(this, SearchHandler);
    _this = _callSuper(this, SearchHandler, [config]);
    _this.setOptions(config.hooksInitializer.optionCopy);

    /** @type {Object|null} - Instance of the autocomplete implementation */
    _this.autocompleteInstance = null;
    /** @type {Object} - Configuration settings */
    _this.config = config;
    _this.initialize();
    return _this;
  }

  /**
   * @method initialize
   * @description Initializes the search handler by setting up DOM elements, autocomplete, and event listeners
   * @private
   */
  _inherits(SearchHandler, _BaseAutocompleteHand);
  return autocompleteSearchHandler_createClass(SearchHandler, [{
    key: "initialize",
    value: function initialize() {
      this.cacheDOMElements();
      this.initializeAutocomplete();
      this.addEventListeners();
      this.updateSubmitButton();
    }

    /**
     * @method cacheDOMElements
     * @description Caches commonly used DOM elements for better performance
     * @private
     */
  }, {
    key: "cacheDOMElements",
    value: function cacheDOMElements() {
      // Cache DOM elements for frequent access
      this.clearButton = document.querySelector('.search-modal__clear-button');
      this.submitButton = document.querySelector('.aa-SubmitButton');
      this.inputElement = document.querySelector('#autocomplete-0-input');
    }

    /**
     * @method initializeAutocomplete
     * @description Initializes or reinitializes the Algolia autocomplete instance
     * @private
     * @throws {Error} If autocomplete initialization fails
     */
  }, {
    key: "initializeAutocomplete",
    value: function initializeAutocomplete() {
      try {
        var _this$autocompleteIns;
        // Cleanup existing instance if it exists
        if ((_this$autocompleteIns = this.autocompleteInstance) !== null && _this$autocompleteIns !== void 0 && _this$autocompleteIns.destroy) {
          this.autocompleteInstance.destroy();
        }

        // Initialize new autocomplete instance
        this.autocompleteInstance = window.algoliaShopify.externals.autocomplete(this.optionCopy);
        var _this$autocompleteIns2 = this.autocompleteInstance,
          setQuery = _this$autocompleteIns2.setQuery,
          setIsOpen = _this$autocompleteIns2.setIsOpen,
          destroy = _this$autocompleteIns2.destroy;

        // Bind methods to maintain correct context
        this.destroyAutocomplete = destroy.bind(this.autocompleteInstance);
        this.query = setQuery;
        this.isOpen = setIsOpen;

        // Expose methods globally for external access
        window.algoliaShopify.custom = {
          setQuery: this.query,
          setIsOpen: this.isOpen
        };

        // Reset initial state
        this.query('');
        this.isOpen(false);
        this.destroyAutocomplete();
      } catch (error) {
        console.error('Error initializing autocomplete:', error);
      }
    }

    /**
     * @method addEventListeners
     * @description Sets up event listeners for clear button and modal close events
     * @private
     * @throws {Error} If event listener attachment fails
     */
  }, {
    key: "addEventListeners",
    value: function addEventListeners() {
      try {
        if (this.clearButton) {
          this.clearButtonClickHandler = this.onClearButtonClick.bind(this);
          this.clearButton.addEventListener('click', this.clearButtonClickHandler);
        } else {
          console.warn('Clear button not found: .search-modal__clear-button');
        }
        this.modalCloseHandler = this.onModalClose.bind(this);
        document.addEventListener('details-modal:close', this.modalCloseHandler);
      } catch (error) {
        console.error('Error adding event listeners:', error);
      }
    }

    /**
     * @method onClearButtonClick
     * @description Handles clear button click event by resetting the form
     * @private
     */
  }, {
    key: "onClearButtonClick",
    value: function onClearButtonClick() {
      var form = document.querySelector('.aa-Form');
      form.reset();
    }

    /**
     * @method onModalClose
     * @description Handles modal close event by resetting search state
     * @private
     * @throws {Error} If modal close handling fails
     */
  }, {
    key: "onModalClose",
    value: function onModalClose() {
      try {
        if (!this.inputElement) {
          this.inputElement = document.querySelector('#autocomplete-0-input');
        }
        if (this.inputElement) {
          // Simulate escape key press to close autocomplete
          this.inputElement.dispatchEvent(new KeyboardEvent('keydown', {
            key: 'Escape'
          }));
          this.isOpen(false);
          this.query('');
        } else {
          console.warn('Input not found: #autocomplete-0-input');
        }
      } catch (error) {
        console.error('Error in details-modal:close event listener:', error);
      }
    }

    /**
     * @method updateSubmitButton
     * @description Updates the submit button SVG based on screen width with debounced resize handling
     * @private
     * @throws {Error} If submit button update fails
     */
  }, {
    key: "updateSubmitButton",
    value: function updateSubmitButton() {
      var _this2 = this;
      try {
        if (this.submitButton) {
          var updateSVG = function updateSVG() {
            var svgContent = window.innerWidth >= 1024 ? _this2.getLargeSVG() : _this2.getSmallSVG();
            _this2.submitButton.innerHTML = svgContent;
          };
          updateSVG();

          // Debounce resize handler
          var resizeTimeout;
          this.resizeHandler = function () {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(updateSVG, 200);
          };
          window.addEventListener('resize', this.resizeHandler);
        } else {
          console.warn('Submit button not found.');
        }
      } catch (error) {
        console.error('Error updating submit button:', error);
      }
    }

    /**
     * @method getLargeSVG
     * @description Returns the large version of the search icon SVG
     * @private
     * @returns {string} SVG markup for large screens
     */
  }, {
    key: "getLargeSVG",
    value: function getLargeSVG() {
      return "\n      <svg width=\"36\" height=\"36\" viewBox=\"0 0 36 36\" fill=\"none\"\n        xmlns=\"http://www.w3.org/2000/svg\" class=\"aa-SubmitIcon\">\n        <path d=\"M23.5736 10.2553C27.25 13.9317 27.25 19.8924 23.5736 23.5687C19.8972 27.2451 13.9366 27.2451 10.2602 23.5687C6.58383 19.8924 6.58383 13.9317 10.2602 10.2553C13.9366 6.57895 19.8972 6.57895 23.5736 10.2553\" stroke=\"black\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n        <path d=\"M28.4995 28.4995L23.5645 23.5645\" stroke=\"black\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n      </svg>\n    ";
    }

    /**
     * @method getSmallSVG
     * @description Returns the small version of the search icon SVG
     * @private
     * @returns {string} SVG markup for small screens
     */
  }, {
    key: "getSmallSVG",
    value: function getSmallSVG() {
      return "\n      <svg width=\"30\" height=\"30\" viewBox=\"0 0 30 30\" fill=\"none\"\n        xmlns=\"http://www.w3.org/2000/svg\">\n        <path d=\"M19.6422 8.54775C22.7059 11.6114 22.7059 16.5786 19.6422 19.6422C16.5786 22.7059 11.6114 22.7059 8.54775 19.6422C5.48408 16.5786 5.48408 11.6114 8.54775 8.54775C11.6114 5.48408 16.5786 5.48408 19.6422 8.54775\" stroke=\"#323232\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n        <path d=\"M23.7492 23.7492L19.6367 19.6367\" stroke=\"#323232\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n      </svg>\n    ";
    }

    /**
     * @method destroy
     * @description Cleans up instance by removing event listeners and destroying autocomplete
     * @public
     * @throws {Error} If cleanup fails
     */
  }, {
    key: "destroy",
    value: function destroy() {
      try {
        var _this$autocompleteIns3;
        (_this$autocompleteIns3 = this.autocompleteInstance) === null || _this$autocompleteIns3 === void 0 || _this$autocompleteIns3.destroy();
        if (this.resizeHandler) {
          window.removeEventListener('resize', this.resizeHandler);
        }
        if (this.clearButtonClickHandler && this.clearButton) {
          this.clearButton.removeEventListener('click', this.clearButtonClickHandler);
        }
        if (this.modalCloseHandler) {
          document.removeEventListener('details-modal:close', this.modalCloseHandler);
        }
      } catch (error) {
        console.error('Error destroying SearchHandler:', error);
      }
    }
  }]);
}(BaseAutocompleteHandler);
/* harmony default export */ var autocompleteSearchHandler = (SearchHandler);
;// ./src/scripts/sections/autocomplete.js
function autocomplete_typeof(o) { "@babel/helpers - typeof"; return autocomplete_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, autocomplete_typeof(o); }
function autocomplete_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function autocomplete_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, autocomplete_toPropertyKey(o.key), o); } }
function autocomplete_createClass(e, r, t) { return r && autocomplete_defineProperties(e.prototype, r), t && autocomplete_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function autocomplete_toPropertyKey(t) { var i = autocomplete_toPrimitive(t, "string"); return "symbol" == autocomplete_typeof(i) ? i : i + ""; }
function autocomplete_toPrimitive(t, r) { if ("object" != autocomplete_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != autocomplete_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function autocomplete_callSuper(t, o, e) { return o = autocomplete_getPrototypeOf(o), autocomplete_possibleConstructorReturn(t, autocomplete_isNativeReflectConstruct() ? Reflect.construct(o, e || [], autocomplete_getPrototypeOf(t).constructor) : o.apply(t, e)); }
function autocomplete_possibleConstructorReturn(t, e) { if (e && ("object" == autocomplete_typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return autocomplete_assertThisInitialized(t); }
function autocomplete_assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function autocomplete_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (autocomplete_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function autocomplete_getPrototypeOf(t) { return autocomplete_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, autocomplete_getPrototypeOf(t); }
function autocomplete_inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && autocomplete_setPrototypeOf(t, e); }
function autocomplete_setPrototypeOf(t, e) { return autocomplete_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, autocomplete_setPrototypeOf(t, e); }
/**
 * @fileoverview Manages the initialization and coordination of autocomplete functionality
 * across the application, integrating with Algolia's autocomplete service.
 */






/** @type {Object} Current state of the autocomplete store */
var autocomplete_autocompleteState = store.getState();

// Subscribe to store updates
store.subscribe(function () {
  autocomplete_autocompleteState = store.getState();
});

/**
 * @class AutocompleteManager
 * @extends BaseAutocompleteHandler
 * @description Main manager class for autocomplete functionality. Coordinates initialization
 * of search handlers and hooks, manages application state, and handles core event listeners.
 */
var AutocompleteManager = /*#__PURE__*/function (_BaseAutocompleteHand) {
  /**
   * @constructor
   * @description Initializes the AutocompleteManager and sets up initial state
   */
  function AutocompleteManager() {
    var _this;
    autocomplete_classCallCheck(this, AutocompleteManager);
    _this = autocomplete_callSuper(this, AutocompleteManager);

    /**
     * @type {Object}
     * @private
     * @description Stores the current state of the autocomplete manager
     */
    _this.currentState = {};

    /**
     * @type {HooksInitializer|null}
     * @private
     * @description Instance of HooksInitializer for managing autocomplete hooks
     */
    _this.hooksInitializer = null;
    _this.initialize();
    return _this;
  }

  /**
   * @method initialize
   * @description Sets up event listeners for autocomplete initialization and DOM content loading.
   * Handles the creation of SearchHandler instances and initialization of hooks.
   * @private
   * @throws {Error} If initialization fails
   */
  autocomplete_inherits(AutocompleteManager, _BaseAutocompleteHand);
  return autocomplete_createClass(AutocompleteManager, [{
    key: "initialize",
    value: function initialize() {
      var _this2 = this;
      try {
        // Listen for autocomplete initialization completion
        document.addEventListener('algolia.autocomplete.afterInit', function () {
          // Create new SearchHandler instance after autocomplete is initialized
          new autocompleteSearchHandler(_this2);
        });

        // Listen for DOM content loaded to mark page as ready
        document.addEventListener('DOMContentLoaded', this.onContentLoaded.bind(this));

        // Listen for hooks initialization request
        document.addEventListener('algolia.hooks.initialize', function () {
          // Initialize hooks system when requested
          _this2.hooksInitializer = new autocomplete_hooks(_this2);
        });
      } catch (error) {
        console.error('Error initializing AutocompleteManager:', error);
      }
    }

    /**
     * @method onContentLoaded
     * @description Handles DOM content loaded event by marking the body as loaded
     * @private
     */
  }, {
    key: "onContentLoaded",
    value: function onContentLoaded() {
      document.body.classList.add('loaded');
    }
  }]);
}(BaseAutocompleteHandler); // Initialize the AutocompleteManager
new AutocompleteManager();
/******/ })()
;